/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Metka.Backend
 * OpenAPI spec version: 1.0
 */
import { customFetch } from './mutator';
export type GetApiV1VkMetricsParams = {
erid: string;
};

export type GetApiV1VkPostsParams = {
erid: string;
};

export type PostApiV1VkPublishHeaders = {
'X-Idempotency-Key'?: string;
};

export type GetApiV1TgMessagesParams = {
erid: string;
};

export type GetApiV1TgMetricsParams = {
erid: string;
};

export type GetApiV1StorageValidateVideoByKeyParams = {
videoKey: string;
};

export type GetApiV1StoragePresignGetParams = {
postId: string;
key: string;
};

export type GetApiV1AdminPromoCodesParams = {
isActive?: boolean;
};

export type GetApiV1AdminPostsParams = {
q?: string;
source?: string;
userId?: string;
accountId?: string;
page?: number;
size?: number;
};

export type GetApiV1PostsByEridParams = {
erid: string;
};

export type GetApiV1PostsParams = {
source?: string;
q?: string;
isAd?: boolean;
hasErid?: boolean;
erid?: string;
dateFrom?: string;
dateTo?: string;
providers?: string;
contractExternalId?: string;
needsAct?: boolean;
page?: number;
size?: number;
};

export type HandlePlatformOAuthCallbackParams = {
code: string;
state: string;
};

export type GetPlatformOAuthConnectUrlParams = {
padId?: string;
};

export type GetApiV1PermissionsMeParams = {
accountId?: string;
};

export type GetApiV1PaymentsParams = {
limit?: number;
};

export type GetApiV1PartnersPayoutsParams = {
page?: number;
pageSize?: number;
};

export type GetApiV1PartnersCommissionsParams = {
page?: number;
pageSize?: number;
};

export type GetApiV1PartnersClientsParams = {
page?: number;
pageSize?: number;
};

export type GetApiV1PadsParams = {
search?: string;
preset?: PlatformPreset;
status?: string;
limit?: number;
offset?: number;
provider?: string;
};

export type GetApiV1OrdStatisticsImportsParams = {
page: number;
pageSize: number;
};

export type PostApiV1OrdStatisticsImportParams = {
fileName?: string;
};

export type GetApiV1OrdReportingStatusMonthParams = {
erids?: string;
padId?: string;
};

export type GetApiV1OrdReachMonthMissingParams = {
isVideo?: boolean;
};

export type GetApiV1OrdReachMonthParams = {
isVideo?: boolean;
};

export type GetApiV1CreativesResolveByEridParams = {
erid: string;
};

export type GetApiV1ActsExternalIdAllocationsParams = {
provider?: string;
};

export type GetApiV1ActsExternalIdSuggestAllocationParams = {
provider?: string;
};

export type PostApiV1ActsExternalIdAllocateParams = {
provider?: string;
};

export type GetOwnCounterpartyStatusParams = {
provider?: string;
};

export type GetPersonMyParams = {
provider?: string;
};

export type GetCounterpartyByExternalIdParams = {
provider?: string;
};

export type GetContractByExternalIdParams = {
provider?: string;
};

export type ListMonitoringTasksParams = {
page?: number;
pageSize?: number;
};

export type PostApiV1PadsSyncFromOrdParams = {
provider?: string;
};

export type GetApiV1AdminTgMtAccountsIdStatsParams = {
days?: number;
};

export type PostApiV1ActsExternalIdSendToErirParams = {
provider?: string;
};

export type GetApiV1OrdInvoicesExternalIdParams = {
provider?: string;
};

export type PostApiV1ActsBatchDeleteParams = {
provider?: string;
};

export type DeleteApiV1ActsExternalIdParams = {
provider?: string;
};

export type PostApiV1ActsCreateParams = {
provider?: string;
};

export type GetApiV1OrdInvoicesParams = {
offset?: number;
limit?: number;
provider?: string;
search?: string;
};

export type PostApiV1OrdReachDraftsMonthBody = {[key: string]: JsonNode};

export type PostApiV1ChannelsConnectParams = {
provider?: string;
};

export type GetApiV1OrdCounterpartiesListParams = {
search?: string;
offset?: number;
limit?: number;
provider?: string;
};

export type GetApiV1OrdCounterpartiesParams = {
provider?: string;
};

export type PostApiV1OrdSyncPostsFromCreativesParams = {
provider?: string;
};

export type PostApiV1OrdSyncCounterpartiesParams = {
limit?: number;
offset?: number;
fullScan?: boolean;
provider?: string;
};

export type PostApiV1OrdSyncContractsParams = {
limit?: number;
offset?: number;
fullScan?: boolean;
provider?: string;
};

export type PostApiV1ContractsExternalIdCreateCidParams = {
provider?: string;
};

export type PostApiV1ContractsCreateParams = {
provider?: string;
};

export type GetApiV1OrdContractsListParams = {
offset?: number;
limit?: number;
provider?: string;
};

export type GetApiV1OrdAddressCorrectParams = {
address: string;
provider?: string;
};

export type PostApiV1UsersOnboardingSelfPromotionParams = {
provider?: string;
};

export type PostApiV1UsersOnboardingParams = {
provider?: string;
};

export type GetApiV1DictKktuParams = {
search?: string;
limit?: number;
lang?: string;
offset?: number;
codes?: string;
leafOnly?: boolean;
};

export type GetApiV1NotificationsParams = {
unread?: boolean;
limit?: number;
accountId?: string;
};

export type PostApiV1ReferralsClaimParams = {
promoCode?: string;
};

export type PatchApiV1AnalysisIdBody = {[key: string]: JsonNode};

export type GetApiV1AnalysisFeedParams = {
limit?: number;
beforeId?: number;
workflow?: string;
author?: string;
isAd?: boolean;
hasErid?: boolean;
erid?: string;
dateFrom?: string;
dateTo?: string;
};

export type GetApiV1AnalysisParams = {
limit?: number;
beforeId?: number;
workflow?: string;
author?: string;
isAd?: boolean;
hasErid?: boolean;
};

export type GetErirStatusesByFilterParams = {
dataType: string;
status: string;
limit?: number;
provider?: string;
};

export type GetErirStatusParams = {
provider?: string;
};

export type GetCreativeErirStatusParams = {
provider?: string;
};

export type GetApiV1ComplianceInvoicesParams = {
offset?: number;
limit?: number;
};

export type GetApiV1ComplianceAuditParams = {
creativeId: string;
};

export type GetApiV1CompliancePlacementStatusParams = {
erids?: string;
creativeIds?: string;
};

export type GetApiV1ComplianceActsByContractParams = {
contractExternalId: string;
};

export type GetApiV1ComplianceSummaryParams = {
months?: number;
};

export type GetApiV1ComplianceReportRowEridParams = {
month: string;
};

export type GetApiV1ComplianceReportParams = {
month: string;
actionRequired?: boolean;
page?: number;
pageSize?: number;
providers?: string;
hideCompleted?: boolean;
stage?: string;
erids?: string;
search?: string;
};

export type GetApiV1BlogArticlesParams = {
categorySlug?: string;
page?: number;
pageSize?: number;
};

export type GetApiV1AccountsIdAuditParams = {
userId?: string;
action?: string;
status?: string;
from?: string;
to?: string;
cursor?: string;
limit: number;
};

export type ExportArchivesParams = {
format?: string;
erid?: string;
startDate?: string;
endDate?: string;
};

export type GetUserTariffsBatch200 = {[key: string]: UserTariffInfo};

export type GetAdminTeamsParams = {
q?: string;
page?: number;
size?: number;
filter?: string;
};

export type ListAllTariffsParams = {
status?: string;
};

export type GetApiV1AdminPromoPresetsParams = {
includeInactive: boolean;
};

export type GetPartnerReferralsParams = {
page?: number;
pageSize?: number;
};

export type GetPendingPartnerPayoutsParams = {
limit?: number;
};

export type GetPartnersStatisticsParams = {
limit?: number;
};

export type AdminSyncPostsFromCreativesParams = {
provider?: string;
};

export type GetApiV1AdminBlogArticlesParams = {
status?: string;
categorySlug?: string;
search?: string;
page?: number;
pageSize?: number;
};

export type ListMonitorBotUsersParams = {
page: number;
pageSize: number;
};

export type ListMonitorBotTasksParams = {
page: number;
pageSize: number;
status?: string;
};

export type GetUserActivityStatsParams = {
from?: string;
to?: string;
interval?: string;
};

export type ListUserAuditLogsParams = {
from?: string;
to?: string;
userId?: string;
accountId?: string;
action?: UserActionKind;
status?: UserAuditStatus;
q?: string;
page?: number;
pageSize?: number;
};

export type AdminListNewsParams = {
status?: NewsStatus;
};

export interface YtVideoStatsResponse {
  collectedAtMs?: number;
  /** @nullable */
  comments?: number | null;
  /** @nullable */
  likes?: number | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  videoId?: string | null;
  /** @nullable */
  videoUrl?: string | null;
  views?: number;
}

export interface YtMonthlyReachItem {
  /** @nullable */
  month?: string | null;
  views?: number;
}

export interface YtMonthlyReachResponse {
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  months?: YtMonthlyReachItem[] | null;
}

export interface YtLinkVideoResponse {
  /** @nullable */
  channelTitle?: string | null;
  linkedAtMs?: number;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  videoId?: string | null;
  /** @nullable */
  videoUrl?: string | null;
}

export interface YtLinkVideoRequest {
  /** @nullable */
  videoUrl?: string | null;
}

export interface YtEridReachResponse {
  /** @nullable */
  erid?: string | null;
  reach?: number;
  /** @nullable */
  updatedAtMs?: number | null;
}

export interface WriteAccessAllowed {
  from_attachment_menu?: boolean;
  from_request?: boolean;
  /** @nullable */
  web_app_name?: string | null;
}

export interface WebAppInfo {
  /** @nullable */
  url?: string | null;
}

export interface WebAppData {
  /** @nullable */
  button_text?: string | null;
  /** @nullable */
  data?: string | null;
}

export interface Void { [key: string]: unknown }

export interface Voice {
  duration?: number;
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
  /** @nullable */
  mime_type?: string | null;
}

export interface VkPhotoAttachment {
  /** @nullable */
  sourceUrl?: string | null;
}

export interface VkPublishRequest {
  /** @nullable */
  deleteAtMs?: number | null;
  /** @nullable */
  erid?: string | null;
  ordPadId?: string;
  /** @nullable */
  photos?: VkPhotoAttachment[] | null;
  /** @nullable */
  publishAt?: string | null;
  /** @nullable */
  text?: string | null;
}

export interface VkConnectManualResponse {
  /** @nullable */
  groupId?: string | null;
  isNew?: boolean;
  linkedAt?: string;
  /** @nullable */
  membersCount?: number | null;
  /** @nullable */
  name?: string | null;
  padId?: string;
  /** @nullable */
  photo?: string | null;
  /** @nullable */
  screenName?: string | null;
}

export interface VkConnectManualRequest {
  /** @nullable */
  accessToken?: string | null;
  /** @nullable */
  groupId?: string | null;
}

export interface VideoWatermarkStatusDto {
  /** @nullable */
  completedAt?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  durationMode?: string | null;
  /** @nullable */
  errorCode?: string | null;
  /** @nullable */
  errorMessage?: string | null;
  /** @nullable */
  jobId?: string | null;
  /** @nullable */
  overlayPngKey?: string | null;
  /** @nullable */
  resultVideoKey?: string | null;
  /** @nullable */
  resultVideoUrl?: string | null;
  /** @nullable */
  segmentEndSec?: number | null;
  /** @nullable */
  segmentStartSec?: number | null;
  /** @nullable */
  status?: string | null;
}

export interface VideoWatermarkRequest {
  /** @nullable */
  durationMode?: string | null;
  /** @nullable */
  overlayPngKey?: string | null;
  /** @nullable */
  segmentEndSec?: number | null;
  /** @nullable */
  segmentStartSec?: number | null;
}

export interface VideoWatermarkEnqueueResponse {
  jobId?: string;
}

export interface VideoValidationDetails {
  audio?: AudioDetails;
  bitrate?: BitrateDetails;
  codec?: CodecDetails;
  container?: ContainerDetails;
  duration?: number;
  frameRate?: number;
  resolution?: ResolutionDetails;
}

export interface VideoValidationResponse {
  details?: VideoValidationDetails;
  /** @nullable */
  errorMessage?: string | null;
  isCompliant?: boolean;
  /** @nullable */
  postId?: string | null;
  /** @nullable */
  requirements?: ValidationRequirement[] | null;
  /** @nullable */
  summary?: string | null;
  /** @nullable */
  videoKey?: string | null;
}

export interface VideoQuality {
  /** @nullable */
  codec?: string | null;
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
  height?: number;
  width?: number;
}

export interface VideoNote {
  duration?: number;
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
  length?: number;
  thumbnail?: PhotoSize;
}

export interface VideoChatStarted { [key: string]: unknown }

export interface VideoChatScheduled {
  start_date?: string;
}

export interface VideoChatParticipantsInvited {
  /** @nullable */
  users?: User[] | null;
}

export interface VideoChatEnded {
  duration?: number;
}

export interface Video {
  /** @nullable */
  cover?: PhotoSize[] | null;
  duration?: number;
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_name?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
  height?: number;
  /** @nullable */
  mime_type?: string | null;
  /** @nullable */
  qualities?: VideoQuality[] | null;
  /** @nullable */
  start_timestamp?: number | null;
  thumbnail?: PhotoSize;
  width?: number;
}

export interface Venue {
  /** @nullable */
  address?: string | null;
  /** @nullable */
  foursquare_id?: string | null;
  /** @nullable */
  foursquare_type?: string | null;
  /** @nullable */
  google_place_id?: string | null;
  /** @nullable */
  google_place_type?: string | null;
  location?: Location;
  /** @nullable */
  title?: string | null;
}

export interface ValidationRequirement {
  /** @nullable */
  actualValue?: string | null;
  /** @nullable */
  expectedValue?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  label?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  warning?: string | null;
}

/**
 * @nullable
 */
export type ValidationProblemDetailsErrors = {[key: string]: string[]} | null;

export interface ValidationProblemDetails {
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  errors?: ValidationProblemDetailsErrors;
  /** @nullable */
  instance?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  [key: string]: unknown;
}

export interface ValidationError {
  /** @nullable */
  field?: string | null;
  /** @nullable */
  message?: string | null;
}

export interface ValidatePromoCodeRequest {
  amount?: number;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  tariffId?: string | null;
}

export interface UtmBatchRequest {
  /** @nullable */
  userIds: string[] | null;
}

export interface UsersShared {
  request_id?: number;
  /** @nullable */
  users?: SharedUser[] | null;
}

export interface UserTariffsBatchRequest {
  /** @nullable */
  userIds?: string[] | null;
}

export interface UserTariffSnapshot {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  expiresAt?: string | null;
  isExpired?: boolean;
  isTrial?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  source?: string | null;
}

export interface UserTariffInfo {
  /** @nullable */
  expiresAt?: string | null;
  isTrial?: boolean;
  tariff?: TariffBriefDto;
}

export type UserAuditStatus = typeof UserAuditStatus[keyof typeof UserAuditStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserAuditStatus = {
  succeeded: 'succeeded',
  failed: 'failed',
} as const;

export interface UserActivityInterval {
  eventCount?: number;
  timestamp?: string;
  uniqueUsers?: number;
}

export interface UserActivityStatsResponse {
  from?: string;
  /** @nullable */
  interval?: string | null;
  /** @nullable */
  intervals?: UserActivityInterval[] | null;
  to?: string;
  totalEvents?: number;
  totalUniqueUsers?: number;
}

export type UserActionKind = typeof UserActionKind[keyof typeof UserActionKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserActionKind = {
  analysis_Run: 'analysis_Run',
  erid_Create: 'erid_Create',
  erid_Delete: 'erid_Delete',
  ord_Token_Add: 'ord_Token_Add',
  ord_Token_Remove: 'ord_Token_Remove',
  ord_Contract_Create: 'ord_Contract_Create',
  ord_Contract_Update: 'ord_Contract_Update',
  ord_Pad_Link: 'ord_Pad_Link',
  ord_Pad_Create: 'ord_Pad_Create',
  ord_Pad_Update: 'ord_Pad_Update',
  ord_Pad_Delete: 'ord_Pad_Delete',
  ord_Act_Create: 'ord_Act_Create',
  ord_Act_Delete: 'ord_Act_Delete',
  ord_Act_BatchDelete: 'ord_Act_BatchDelete',
  ord_Act_SendToErir: 'ord_Act_SendToErir',
  ord_Addendum_Create: 'ord_Addendum_Create',
  ord_Addendum_Update: 'ord_Addendum_Update',
  ord_Addendum_Delete: 'ord_Addendum_Delete',
  payment_Create: 'payment_Create',
  payment_Refund: 'payment_Refund',
  tariff_Assign: 'tariff_Assign',
  tariff_Expire: 'tariff_Expire',
  role_Update: 'role_Update',
  user_Delete: 'user_Delete',
  data_Purge: 'data_Purge',
  integration_Update: 'integration_Update',
  admin_Impersonate: 'admin_Impersonate',
  memberInvited: 'memberInvited',
  memberAcceptedInvite: 'memberAcceptedInvite',
  invitationRevoked: 'invitationRevoked',
  memberRoleChanged: 'memberRoleChanged',
  memberRemoved: 'memberRemoved',
  roleCreated: 'roleCreated',
  roleUpdated: 'roleUpdated',
  roleDeleted: 'roleDeleted',
  ord_Reach_Submit: 'ord_Reach_Submit',
  ord_Reach_Update: 'ord_Reach_Update',
  ord_Deallocation_Update: 'ord_Deallocation_Update',
  ord_Counterparty_Create: 'ord_Counterparty_Create',
  ord_Counterparty_Update: 'ord_Counterparty_Update',
} as const;

export interface UserAuditLog {
  /** @nullable */
  accountId?: string | null;
  action: UserActionKind;
  createdAt?: string;
  /** @nullable */
  durationMs?: number | null;
  /** @nullable */
  httpCode?: number | null;
  id?: string;
  /**
   * @maxLength 45
   * @nullable
   */
  ipAddress?: string | null;
  /** @nullable */
  metaJson?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  requestId?: string | null;
  /**
   * @maxLength 500
   * @nullable
   */
  resourceId?: string | null;
  /**
   * @maxLength 500
   * @nullable
   */
  route?: string | null;
  status: UserAuditStatus;
  /**
   * @maxLength 255
   * @nullable
   */
  traceId?: string | null;
  /**
   * @maxLength 500
   * @nullable
   */
  userAgent?: string | null;
  /**
   * @minLength 1
   * @maxLength 255
   */
  userId: string;
}

export interface UserAuditListItem {
  /** @nullable */
  accountId?: string | null;
  action?: UserActionKind;
  createdAt?: string;
  /** @nullable */
  durationMs?: number | null;
  /** @nullable */
  httpCode?: number | null;
  id?: string;
  /** @nullable */
  requestId?: string | null;
  /** @nullable */
  resourceId?: string | null;
  /** @nullable */
  route?: string | null;
  status?: UserAuditStatus;
  /** @nullable */
  traceId?: string | null;
  /** @nullable */
  userEmail?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface User {
  added_to_attachment_menu?: boolean;
  allows_users_to_create_topics?: boolean;
  can_connect_to_business?: boolean;
  can_join_groups?: boolean;
  can_read_all_group_messages?: boolean;
  /** @nullable */
  first_name?: string | null;
  has_main_web_app?: boolean;
  has_topics_enabled?: boolean;
  id?: number;
  is_bot?: boolean;
  is_premium?: boolean;
  /** @nullable */
  language_code?: string | null;
  /** @nullable */
  last_name?: string | null;
  supports_inline_queries?: boolean;
  /** @nullable */
  username?: string | null;
}

export interface UpdateTariffRequest {
  /** @nullable */
  capabilitiesJson?: string | null;
  code?: TariffCode;
  /** @nullable */
  defaultDurationDays?: number | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  displayOrder?: number | null;
  /** @nullable */
  isRecommended?: boolean | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  oldPricePerMonthRub?: number | null;
  /** @nullable */
  price12MonthsRub?: number | null;
  /** @nullable */
  price3MonthsRub?: number | null;
  /** @nullable */
  pricePerMonthRub?: number | null;
}

export interface UpdateRoleRequest {
  /** @nullable */
  description?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  permissions?: string[] | null;
}

export interface UpdatePromoCodeRequest {
  /** @nullable */
  description?: string | null;
  /** @nullable */
  discountAmountRub?: number | null;
  /** @nullable */
  discountPercent?: number | null;
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  maxUses?: number | null;
  /** @nullable */
  minOrderAmountRub?: number | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
}

export interface UpdatePostResponse {
  id?: string;
  ok?: boolean;
}

export interface UpdatePostRequest {
  /** @nullable */
  adPeriodEndMs?: number | null;
  /** @nullable */
  adPeriodStartMs?: number | null;
  /** @nullable */
  contentText?: string | null;
  /** @nullable */
  contentTextMarked?: string | null;
  /** @nullable */
  draftStateJson?: string | null;
  /** @nullable */
  images?: string[] | null;
  /** @nullable */
  markedTextIndex?: number | null;
  /** @nullable */
  padId?: string | null;
}

export interface UpdatePartnerPromoCodeRequest {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  presetId?: string | null;
}

export interface UpdatePadRequest {
  distributionType?: DistributionType;
  /** @nullable */
  isOwner?: boolean | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  personExternalId?: string | null;
  platformPreset?: PlatformPreset;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  username?: string | null;
}

export interface UpdateNotificationSettingsRequest {
  emailNotificationsEnabled?: boolean;
  pushNotificationsEnabled?: boolean;
}

/**
 * @nullable
 */
export type UpdateNotificationPreferencesV2RequestSettings = {[key: string]: NotificationTypeSetting} | null;

export interface UpdateNotificationPreferencesV2Request {
  globalChannels?: GlobalChannels;
  /** @nullable */
  settings?: UpdateNotificationPreferencesV2RequestSettings;
}

export interface UpdateNewsRequest {
  /** @nullable */
  content?: string | null;
  status?: NewsStatus;
  /** @nullable */
  title?: string | null;
}

export interface UpdateMaxTasksRequest {
  maxTasks?: number;
}

export interface UpdateBlogTagRequest {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
}

export interface UpdateBlogCategoryRequest {
  /** @nullable */
  description?: string | null;
  isHidden?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
  sortOrder?: number;
}

export interface UpdateBlogAuthorRequest {
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  bio?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface UpdateBlogArticleRequest {
  /** @nullable */
  authorId?: string | null;
  categoryId?: string;
  /** @nullable */
  contentJson?: string | null;
  /** @nullable */
  coverImageAlt?: string | null;
  /** @nullable */
  coverImageUrl?: string | null;
  /** @nullable */
  excerpt?: string | null;
  isFeatured?: boolean;
  /** @nullable */
  scheduledAt?: string | null;
  /** @nullable */
  seoDescription?: string | null;
  /** @nullable */
  seoTitle?: string | null;
  showAuthor?: boolean;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  tagIds?: string[] | null;
  /** @nullable */
  title?: string | null;
}

export interface UpdateAutoDeleteResponse {
  deleteAtMs?: number;
  ok?: boolean;
}

export interface UpdateAutoDeleteRequest {
  /** @nullable */
  deleteAtMs?: number | null;
}

export interface Update {
  business_connection?: BusinessConnection;
  business_message?: Message;
  callback_query?: CallbackQuery;
  channel_post?: Message;
  chat_boost?: ChatBoostUpdated;
  chat_join_request?: ChatJoinRequest;
  chat_member?: ChatMemberUpdated;
  chosen_inline_result?: ChosenInlineResult;
  deleted_business_messages?: BusinessMessagesDeleted;
  edited_business_message?: Message;
  edited_channel_post?: Message;
  edited_message?: Message;
  inline_query?: InlineQuery;
  message?: Message;
  message_reaction?: MessageReactionUpdated;
  message_reaction_count?: MessageReactionCountUpdated;
  my_chat_member?: ChatMemberUpdated;
  poll?: Poll;
  poll_answer?: PollAnswer;
  pre_checkout_query?: PreCheckoutQuery;
  purchased_paid_media?: PaidMediaPurchased;
  removed_chat_boost?: ChatBoostRemoved;
  shipping_query?: ShippingQuery;
  update_id?: number;
}

export interface UniqueGiftSymbol {
  /** @nullable */
  name?: string | null;
  rarity_per_mille?: number;
  sticker?: Sticker;
}

export type UniqueGiftModelRarity = typeof UniqueGiftModelRarity[keyof typeof UniqueGiftModelRarity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UniqueGiftModelRarity = {
  uncommon: 'uncommon',
  rare: 'rare',
  epic: 'epic',
  legendary: 'legendary',
} as const;

export interface UniqueGiftModel {
  /** @nullable */
  name?: string | null;
  rarity?: UniqueGiftModelRarity;
  rarity_per_mille?: number;
  sticker?: Sticker;
}

export interface UniqueGiftColors {
  dark_theme_main_color?: number;
  /** @nullable */
  dark_theme_other_colors?: number[] | null;
  light_theme_main_color?: number;
  /** @nullable */
  light_theme_other_colors?: number[] | null;
  /** @nullable */
  model_custom_emoji_id?: string | null;
  /** @nullable */
  symbol_custom_emoji_id?: string | null;
}

export interface UniqueGiftBackdropColors {
  center_color?: number;
  edge_color?: number;
  symbol_color?: number;
  text_color?: number;
}

export interface UniqueGiftBackdrop {
  colors?: UniqueGiftBackdropColors;
  /** @nullable */
  name?: string | null;
  rarity_per_mille?: number;
}

export interface UniqueGift {
  backdrop?: UniqueGiftBackdrop;
  /** @nullable */
  base_name?: string | null;
  colors?: UniqueGiftColors;
  /** @nullable */
  gift_id?: string | null;
  is_burned?: boolean;
  is_from_blockchain?: boolean;
  is_premium?: boolean;
  model?: UniqueGiftModel;
  /** @nullable */
  name?: string | null;
  number?: number;
  publisher_chat?: Chat;
  symbol?: UniqueGiftSymbol;
}

export interface UniqueGiftInfo {
  gift?: UniqueGift;
  /** @nullable */
  last_resale_amount?: number | null;
  /** @nullable */
  last_resale_currency?: string | null;
  /** @nullable */
  next_transfer_date?: string | null;
  /** @nullable */
  origin?: string | null;
  /** @nullable */
  owned_gift_id?: string | null;
  /** @nullable */
  transfer_star_count?: number | null;
}

export interface UnifiedPublishResponse {
  /** @nullable */
  id?: string | null;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  messageId?: number | null;
  /** @nullable */
  postId?: number | null;
  /** @nullable */
  status?: string | null;
}

export interface UnifiedPublishApiRequest {
  /** @nullable */
  deleteAtMs?: number | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  imageUrl?: string | null;
  /** @nullable */
  mediaJson?: string | null;
  ordPadId?: string;
  /** @nullable */
  postId?: string | null;
  /** @nullable */
  publishAtMs?: number | null;
  /** @nullable */
  text?: string | null;
}

export interface TrialGrantedDto {
  startedAt?: string;
  subscriptionId?: string;
  tariffId?: string;
  trialEndsAt?: string;
  /** @nullable */
  userId?: string | null;
}

export interface ToggleAutoRenewResponse {
  autoRenew?: boolean;
  /** @nullable */
  message?: string | null;
  subscriptionId?: string;
}

export interface ToggleAutoRenewRequest {
  enabled?: boolean;
}

export interface ThreePercentIndicator {
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  baseAmount?: number | null;
  /** @nullable */
  baseType?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface TextQuote {
  /** @nullable */
  entities?: MessageEntity[] | null;
  is_manual?: boolean;
  position?: number;
  /** @nullable */
  text?: string | null;
}

export interface TelegramWebhookResponse {
  ok?: boolean;
}

export interface TelegramPublishResponse {
  id?: string;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  messageId?: number | null;
  /** @nullable */
  status?: string | null;
}

export interface TelegramMessageItem {
  /** @nullable */
  chatId?: string | null;
  /** @nullable */
  deleteAtMs?: number | null;
  /** @nullable */
  error?: string | null;
  id?: string;
  messageId?: number;
  ordPadId?: string;
  /** @nullable */
  platform?: string | null;
  /** @nullable */
  publishAtMs?: number | null;
  /** @nullable */
  publishedAtMs?: number | null;
  /** @nullable */
  status?: string | null;
}

export interface TelegramMessagesResponse {
  /** @nullable */
  items?: TelegramMessageItem[] | null;
}

export interface TelegramMeResponse {
  id?: number;
  /** @nullable */
  username?: string | null;
}

export interface TelegramConnectResponse {
  /** @nullable */
  chatId?: string | null;
  id?: string;
  /** @nullable */
  linkedAt?: string | null;
  /** @nullable */
  url?: string | null;
}

export interface TelegramChannelConnectResponse {
  /** @nullable */
  chatId?: string | null;
  id?: string;
  /** @nullable */
  linkedAt?: string | null;
  /** @nullable */
  platform?: string | null;
  /** @nullable */
  username?: string | null;
}

export interface TariffDto {
  capabilities?: TariffCapabilitiesDto;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  defaultDurationDays?: number | null;
  /** @nullable */
  description?: string | null;
  displayOrder?: number;
  id?: string;
  isActive?: boolean;
  isRecommended?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  oldPricePerMonthRub?: number | null;
  pricePerMonthRub?: number;
}

export type TariffCode = typeof TariffCode[keyof typeof TariffCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TariffCode = {
  free: 'free',
  standard: 'standard',
  standardAi: 'standardAi',
  agency: 'agency',
} as const;

export interface TariffChangeDto {
  amountDue?: number;
  /** @nullable */
  changeType?: string | null;
  createdAt?: string;
  effectiveDate?: string;
  fromTariffId?: string;
  id?: string;
  newPeriodAmount?: number;
  newPeriodEnd?: string;
  newPeriodStart?: string;
  /** @nullable */
  paymentId?: string | null;
  prorationCredit?: number;
  remainingDays?: number;
  toTariffId?: string;
}

export interface TariffCapabilitiesDto {
  aiFeatures?: boolean;
  autofillContractors?: boolean;
  channelCheck?: boolean;
  deallocation?: boolean;
  fullReporting?: boolean;
  generateErid?: boolean;
  invoiceGeneration?: boolean;
  /** @nullable */
  maxCabinets?: number | null;
  /** @nullable */
  monthlyPostsLimit?: number | null;
  prioritySupport?: boolean;
  statsCollection?: boolean;
  teamAccess?: boolean;
  /** @nullable */
  teamMembersLimit?: number | null;
  telegramPosting?: boolean;
}

export interface TariffBriefDto {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  name?: string | null;
}

export interface TariffAssignmentDto {
  assignedAt?: string;
  /** @nullable */
  assignedByAdminId?: string | null;
  assignmentId?: string;
  /** @nullable */
  expiresAt?: string | null;
  /** @nullable */
  reason?: string | null;
  tariffId?: string;
  /** @nullable */
  userId?: string | null;
}

export interface TGFile {
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_path?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
}

export type SystemRoleKind = typeof SystemRoleKind[keyof typeof SystemRoleKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SystemRoleKind = {
  owner: 'owner',
  admin: 'admin',
  editor: 'editor',
  viewer: 'viewer',
} as const;

export interface SyncScheduledResponse {
  scheduled?: boolean;
}

export interface SwitchInlineQueryChosenChat {
  allow_bot_chats?: boolean;
  allow_channel_chats?: boolean;
  allow_group_chats?: boolean;
  allow_user_chats?: boolean;
  /** @nullable */
  query?: string | null;
}

export interface SwitchAccountResponse {
  defaultAccountId?: string;
  ok?: boolean;
}

export type SuggestedPostRefundedReason = typeof SuggestedPostRefundedReason[keyof typeof SuggestedPostRefundedReason];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuggestedPostRefundedReason = {
  postDeleted: 'postDeleted',
  paymentRefunded: 'paymentRefunded',
} as const;

export interface SuggestedPostRefunded {
  reason?: SuggestedPostRefundedReason;
  suggested_post_message?: Message;
}

export interface SuggestedPostPrice {
  amount?: number;
  /** @nullable */
  currency?: string | null;
}

export interface SuggestedPostInfo {
  price?: SuggestedPostPrice;
  /** @nullable */
  send_date?: string | null;
  /** @nullable */
  state?: string | null;
}

export interface SuggestedPostDeclined {
  /** @nullable */
  comment?: string | null;
  suggested_post_message?: Message;
}

export interface SuggestedPostApproved {
  price?: SuggestedPostPrice;
  send_date?: string;
  suggested_post_message?: Message;
}

export interface SuggestedPostApprovalFailed {
  price?: SuggestedPostPrice;
  suggested_post_message?: Message;
}

export interface SuccessfulPayment {
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  invoice_payload?: string | null;
  is_first_recurring?: boolean;
  is_recurring?: boolean;
  order_info?: OrderInfo;
  /** @nullable */
  provider_payment_charge_id?: string | null;
  /** @nullable */
  shipping_option_id?: string | null;
  /** @nullable */
  subscription_expiration_date?: string | null;
  /** @nullable */
  telegram_payment_charge_id?: string | null;
  total_amount?: number;
}

export interface SubmitBatchRequest {
  /** @nullable */
  creativeIds?: string[] | null;
  forceResubmit?: boolean;
  /** @nullable */
  month?: string | null;
}

export interface Story {
  chat?: Chat;
  id?: number;
}

export interface StoreContractReq {
  /** @nullable */
  buyerCounterpartyId?: string | null;
  createdAtMs?: number;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  sellerCounterpartyId?: string | null;
}

export type StickerType = typeof StickerType[keyof typeof StickerType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StickerType = {
  regular: 'regular',
  mask: 'mask',
  customEmoji: 'customEmoji',
} as const;

export interface Sticker {
  /** @nullable */
  custom_emoji_id?: string | null;
  /** @nullable */
  emoji?: string | null;
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
  height?: number;
  is_animated?: boolean;
  is_video?: boolean;
  mask_position?: MaskPosition;
  needs_repainting?: boolean;
  premium_animation?: TGFile;
  /** @nullable */
  set_name?: string | null;
  thumbnail?: PhotoSize;
  type?: StickerType;
  width?: number;
}

export interface StatisticsImportResult {
  created?: number;
  creativesCount?: number;
  /** @nullable */
  erids?: string[] | null;
  /** @nullable */
  errors?: RowError[] | null;
  /** @nullable */
  pads?: PadSummary[] | null;
  totalRows?: number;
  updated?: number;
}

export interface StatisticsImportListItem {
  createdAt?: string;
  createdCount?: number;
  creativesCount?: number;
  errorsCount?: number;
  /** @nullable */
  fileName?: string | null;
  hasFile?: boolean;
  id?: string;
  padsCount?: number;
  totalRows?: number;
  updatedCount?: number;
}

export interface StatisticsImportListResponse {
  /** @nullable */
  items?: StatisticsImportListItem[] | null;
  page?: number;
  pageSize?: number;
  total?: number;
}

export interface StatisticsImportDetailDto {
  createdAt?: string;
  createdCount?: number;
  creativesCount?: number;
  errorsCount?: number;
  /** @nullable */
  fileName?: string | null;
  hasFile?: boolean;
  id?: string;
  padsCount?: number;
  report?: unknown;
  totalRows?: number;
  updatedCount?: number;
}

export interface StartLoginRequest {
  /** @nullable */
  cloudPassword?: string | null;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  loginCode?: string | null;
  /** @nullable */
  maxJoinsPerDay?: number | null;
  /** @nullable */
  maxViewBatchesPerMinute?: number | null;
  /** @nullable */
  phoneNumber?: string | null;
}

export interface StarAmount {
  amount?: number;
  /** @nullable */
  nanostar_amount?: number | null;
}

export interface SuggestedPostPaid {
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  currency?: string | null;
  star_amount?: StarAmount;
  suggested_post_message?: Message;
}

export interface SingleRowResponse {
  actionRequiredCount?: number;
  overdueCount?: number;
  readyToSubmitCount?: number;
  row?: ComplianceRow;
  submittedCount?: number;
  total?: number;
}

export interface SimpleRequestByCreative {
  creativeId?: string;
}

export interface ShippingAddress {
  /** @nullable */
  city?: string | null;
  /** @nullable */
  country_code?: string | null;
  /** @nullable */
  post_code?: string | null;
  /** @nullable */
  state?: string | null;
  /** @nullable */
  street_line1?: string | null;
  /** @nullable */
  street_line2?: string | null;
}

export interface ShippingQuery {
  from?: User;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  invoice_payload?: string | null;
  shipping_address?: ShippingAddress;
}

export interface SharedUser {
  /** @nullable */
  first_name?: string | null;
  /** @nullable */
  last_name?: string | null;
  /** @nullable */
  photo?: PhotoSize[] | null;
  user_id?: number;
  /** @nullable */
  username?: string | null;
}

export interface SetTeamNameRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  teamName: string;
}

export interface SetSettingReq {
  /** @nullable */
  key?: string | null;
  /** @nullable */
  value?: string | null;
}

export interface SetSelectedContractReq {
  /** @nullable */
  selectedContractId?: string | null;
}

export interface SetProviderTokenRequest {
  /** @nullable */
  token?: string | null;
}

export interface SetPreferredProviderRequest {
  /** @nullable */
  provider?: string | null;
}

export interface SetInvitationPasswordRequest {
  /** @nullable */
  password?: string | null;
}

export interface SetCabinetAccessRequest {
  /** @nullable */
  accountIds?: string[] | null;
}

export interface SetBalanceReq {
  accruedTotal?: number;
  availableAmount?: number;
  snapshotAt?: number;
}

export interface SendActToErirResponse {
  queued?: boolean;
}

export interface SeedKktuRequest {
  /** @nullable */
  csvPath?: string | null;
}

export interface RtVideoStatsResponse {
  collectedAtMs?: number;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  videoId?: string | null;
  /** @nullable */
  videoUrl?: string | null;
  views?: number;
}

export interface RtMonthlyReachItem {
  /** @nullable */
  month?: string | null;
  views?: number;
}

export interface RtMonthlyReachResponse {
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  months?: RtMonthlyReachItem[] | null;
}

export interface RtLinkVideoResponse {
  linkedAtMs?: number;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  videoId?: string | null;
  /** @nullable */
  videoUrl?: string | null;
}

export interface RtLinkVideoRequest {
  /** @nullable */
  videoUrl?: string | null;
}

export interface RtEridReachResponse {
  /** @nullable */
  erid?: string | null;
  reach?: number;
  /** @nullable */
  updatedAtMs?: number | null;
}

export interface RowError {
  /** @nullable */
  creativeRef?: string | null;
  /** @nullable */
  padExternalId?: string | null;
  /** @nullable */
  reason?: string | null;
  rowNumber?: number;
}

export interface RoleTemplateDto {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  descriptionRu?: string | null;
  /** @nullable */
  nameRu?: string | null;
  /** @nullable */
  permissions?: string[] | null;
}

export interface RoleDto {
  /** @nullable */
  description?: string | null;
  id?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  permissions?: string[] | null;
  /** @nullable */
  systemKind?: string | null;
}

export interface ResolvePlatformResponse {
  /** @nullable */
  canonicalUrl?: string | null;
  /** @nullable */
  distributionType?: string | null;
  /** @nullable */
  normalizedIdentifier?: string | null;
  /** @nullable */
  platformPreset?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface ResolvePlatformRequest {
  /** @nullable */
  urlOrIdentifier?: string | null;
}

export interface ResolutionDetails {
  height?: number;
  width?: number;
}

export interface ReportingStatusItem {
  /** @nullable */
  dateEnd?: string | null;
  /** @nullable */
  dateStart?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  pad?: string | null;
  /** @nullable */
  shows?: number | null;
  /** @nullable */
  status?: string | null;
}

export interface ReportingStatusResponse {
  /** @nullable */
  items?: ReportingStatusItem[] | null;
}

export interface ReportingFinishedItem {
  /** @nullable */
  creativeName?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  lastActivityMonth?: string | null;
  /** @nullable */
  obligationEndsAt?: string | null;
}

export interface RenameAccountResponse {
  id?: string;
  /** @nullable */
  name?: string | null;
}

export interface RenameAccountRequest {
  /**
   * @minLength 1
   * @maxLength 200
   */
  name: string;
}

export interface RefundedPayment {
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  invoice_payload?: string | null;
  /** @nullable */
  provider_payment_charge_id?: string | null;
  /** @nullable */
  telegram_payment_charge_id?: string | null;
  total_amount?: number;
}

export interface RecurringJobInfo {
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  cron: string | null;
  /** @nullable */
  id: string | null;
  /** @nullable */
  lastExecution?: string | null;
  /** @nullable */
  lastJobState?: string | null;
  /** @nullable */
  nextExecution?: string | null;
}

export interface RecordLegalConsentsResponse {
  success?: boolean;
}

export interface RecordLegalConsentsRequest {
  /** @nullable */
  consents?: LegalConsentItem[] | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  keycloakUserId?: string | null;
  source?: LegalConsentSource;
}

export interface RebuildCommissionResponse {
  ok?: boolean;
  removed?: number;
}

export interface ReadReq {
  /** @nullable */
  ids?: number[] | null;
}

export type ReactionTypeKind = typeof ReactionTypeKind[keyof typeof ReactionTypeKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ReactionTypeKind = {
  emoji: 'emoji',
  customEmoji: 'customEmoji',
  paid: 'paid',
} as const;

export interface ReactionType {
  type?: ReactionTypeKind;
}

export interface ReactionCount {
  total_count?: number;
  type?: ReactionType;
}

export interface ReachSubmitResponse {
  ok?: boolean;
  submitted?: number;
}

export interface ReachSubmitItemDto {
  /** @nullable */
  creativeExternalId?: string | null;
  /** @nullable */
  padExternalId?: string | null;
  showsCount?: number;
}

export interface ReachSubmitRequest {
  /** @nullable */
  isVideo?: boolean | null;
  /** @nullable */
  items?: ReachSubmitItemDto[] | null;
  /** @nullable */
  month?: string | null;
}

export interface ReachSubmissionItem {
  createdAt?: string;
  /** @nullable */
  error?: string | null;
  id?: string;
  /** @nullable */
  month?: string | null;
  /** @nullable */
  status?: string | null;
  updatedAt?: string;
}

export interface ReachSubmissionsResponse {
  /** @nullable */
  items?: ReachSubmissionItem[] | null;
}

export interface ReachStatItem {
  /** @nullable */
  adPeriodEndMs?: number | null;
  /** @nullable */
  adPeriodStartMs?: number | null;
  /** @nullable */
  channelUsername?: string | null;
  /** @nullable */
  creativeExternalId?: string | null;
  /** @nullable */
  dateEndActual?: string | null;
  /** @nullable */
  dateStartActual?: string | null;
  /** @nullable */
  erid?: string | null;
  erirStatus?: ErirStatusDto;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  padExternalId?: string | null;
  /** @nullable */
  padTitle?: string | null;
  /** @nullable */
  postId?: string | null;
  /** @nullable */
  postTitle?: string | null;
  /** @nullable */
  publishedAtMs?: number | null;
  /** @nullable */
  reach?: number | null;
  /** @nullable */
  showsCount?: number | null;
}

export interface ReachMissingResponse {
  /** @nullable */
  missing?: string[] | null;
  /** @nullable */
  month?: string | null;
  /** @nullable */
  present?: string[] | null;
}

export interface ReachListResponse {
  /** @nullable */
  items?: ReachStatItem[] | null;
}

export interface ReachAllowedMonthsResponse {
  /** @nullable */
  months?: string[] | null;
}

export interface QuotePaymentResponse {
  amount?: number;
  /** @nullable */
  currency?: string | null;
}

export interface QuotePaymentRequest {
  durationMonths?: number;
  tariffId?: string;
}

export interface QuotaUsageInfo {
  /** @nullable */
  limit?: number | null;
  used?: number;
}

export interface PurchaseExtraCabinetsResponse {
  amountDue?: number;
  /** @nullable */
  confirmationUrl?: string | null;
  paymentId?: string;
  quantity?: number;
  remainingDays?: number;
}

export interface PurchaseExtraCabinetsRequest {
  quantity?: number;
}

export interface PublishRequest {
  /** @nullable */
  deleteAtMs?: number | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  imageUrl?: string | null;
  /** @nullable */
  mediaJson?: string | null;
  ordPadId?: string;
  /** @nullable */
  postId?: string | null;
  /** @nullable */
  publishAtMs?: number | null;
  /** @nullable */
  text?: string | null;
}

export interface ProximityAlertTriggered {
  distance?: number;
  traveler?: User;
  watcher?: User;
}

export interface ProviderBreakdown {
  /** @nullable */
  provider?: string | null;
  submittedCount?: number;
  total?: number;
  withActsCount?: number;
  withIssuesCount?: number;
}

export interface ProfileTariffResponse {
  /** @nullable */
  expiresAt?: number | null;
  /** @nullable */
  name?: string | null;
}

export interface ProblemDetails {
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  instance?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  [key: string]: unknown;
}

export interface PresignUploadWatermarkOverlayRequest {
  /** @nullable */
  fileExt?: string | null;
  postId?: string;
}

export interface PresignUploadVideoRequest {
  /** @nullable */
  fileExt?: string | null;
  postId?: string;
}

export interface PresignUploadRequest {
  /** @nullable */
  fileExt?: string | null;
  postId?: string;
}

export interface PresignUploadProcessedRequest {
  /** @nullable */
  fileExt?: string | null;
  /** @nullable */
  imageId?: string | null;
  postId?: string;
}

export interface PreferencesPutRequest {
  channels?: Channels;
  /** @nullable */
  frequency?: string | null;
  /** @nullable */
  typesEnabled?: string[] | null;
}

export interface PreCheckoutQuery {
  /** @nullable */
  currency?: string | null;
  from?: User;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  invoice_payload?: string | null;
  order_info?: OrderInfo;
  /** @nullable */
  shipping_option_id?: string | null;
  total_amount?: number;
}

export interface PostsExportRequest {
  /** @nullable */
  contractExternalId?: string | null;
  /** @nullable */
  dateFrom?: string | null;
  /** @nullable */
  dateTo?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  hasErid?: boolean | null;
  /** @nullable */
  isAd?: boolean | null;
  /** @nullable */
  providers?: string | null;
  /** @nullable */
  query?: string | null;
  /** @nullable */
  source?: string | null;
}

/**
 * @nullable
 */
export type PostListItemDtoAnalysis = unknown | null;

export interface PostListItemDto {
  /** @nullable */
  adPeriodEndMs?: number | null;
  /** @nullable */
  adPeriodStartMs?: number | null;
  /** @nullable */
  analysis?: PostListItemDtoAnalysis;
  /** @nullable */
  authorName?: string | null;
  /** @nullable */
  channelUsername?: string | null;
  /** @nullable */
  contentText?: string | null;
  /** @nullable */
  contractExternalId?: string | null;
  /** @nullable */
  createdAt?: number | null;
  /** @nullable */
  createdAtTimestamp?: string | null;
  /** @nullable */
  creativeExternalId?: string | null;
  /** @nullable */
  demoErid?: string | null;
  /** @nullable */
  erid?: string | null;
  eridGenerationStatus?: EridGenerationStatus;
  erirStatus?: ErirStatusDto;
  id?: string;
  /** @nullable */
  labelingReceived?: boolean | null;
  /** @nullable */
  labelingReceivedAt?: number | null;
  /** @nullable */
  padId?: string | null;
  /** @nullable */
  padIds?: string[] | null;
  /** @nullable */
  padName?: string | null;
  /** @nullable */
  padNames?: string[] | null;
  /** @nullable */
  platformPreset?: string | null;
  /** @nullable */
  provider?: string | null;
  /** @nullable */
  reach?: number | null;
  /** @nullable */
  reachUpdatedAtMs?: number | null;
  /** @nullable */
  rtVideoLinked?: boolean | null;
  /** @nullable */
  rtVideoStatus?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  tgLink?: string | null;
  tgMonitoring?: boolean;
  tgPublished?: boolean;
  /** @nullable */
  tgPublishedAt?: number | null;
  /** @nullable */
  ytVideoLinked?: boolean | null;
  /** @nullable */
  ytVideoStatus?: string | null;
}

export interface PostsListResult {
  /** @nullable */
  items: PostListItemDto[] | null;
  page?: number;
  size?: number;
  total?: number;
  totalPages?: number;
}

export interface PostDetailDto {
  /** @nullable */
  adPeriodEndMs?: number | null;
  /** @nullable */
  adPeriodStartMs?: number | null;
  /** @nullable */
  advUrl?: string | null;
  /** @nullable */
  authorName?: string | null;
  /** @nullable */
  channelUsername?: string | null;
  /** @nullable */
  contentText?: string | null;
  /** @nullable */
  contentTexts?: string[] | null;
  /** @nullable */
  createdAt?: number | null;
  /** @nullable */
  createdAtTimestamp?: string | null;
  /** @nullable */
  creativeExternalId?: string | null;
  /** @nullable */
  creativeForm?: string | null;
  /** @nullable */
  creativeFormLabel?: string | null;
  /** @nullable */
  demoErid?: string | null;
  /** @nullable */
  draftStateJson?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  eridGenerationStatus?: string | null;
  erirStatus?: ErirStatusDto;
  id?: string;
  /** @nullable */
  images?: string[] | null;
  /** @nullable */
  imagesOriginal?: string[] | null;
  /** @nullable */
  inputHash?: string | null;
  /** @nullable */
  labelingReceived?: boolean | null;
  /** @nullable */
  labelingReceivedAt?: number | null;
  /** @nullable */
  linkText?: string | null;
  /** @nullable */
  ordProvider?: string | null;
  /** @nullable */
  padId?: string | null;
  /** @nullable */
  padIds?: string[] | null;
  /** @nullable */
  padNames?: string[] | null;
  /** @nullable */
  reach?: number | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  tgDeleteAtMs?: number | null;
  /** @nullable */
  tgLink?: string | null;
  tgMonitoring?: boolean;
  tgPublished?: boolean;
  /** @nullable */
  tgPublishedAt?: number | null;
  /** @nullable */
  tgScheduledAt?: number | null;
  /** @nullable */
  videoKey?: string | null;
  /** @nullable */
  videoKeys?: string[] | null;
  /** @nullable */
  videoUrl?: string | null;
}

export type PollType = typeof PollType[keyof typeof PollType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PollType = {
  regular: 'regular',
  quiz: 'quiz',
} as const;

export interface PollOption {
  /** @nullable */
  text?: string | null;
  /** @nullable */
  text_entities?: MessageEntity[] | null;
  voter_count?: number;
}

export interface PollAnswer {
  /** @nullable */
  option_ids?: number[] | null;
  /** @nullable */
  poll_id?: string | null;
  user?: User;
  voter_chat?: Chat;
}

export interface Poll {
  allows_multiple_answers?: boolean;
  /** @nullable */
  close_date?: string | null;
  /** @nullable */
  correct_option_id?: number | null;
  /** @nullable */
  explanation?: string | null;
  /** @nullable */
  explanation_entities?: MessageEntity[] | null;
  /** @nullable */
  id?: string | null;
  is_anonymous?: boolean;
  is_closed?: boolean;
  /** @nullable */
  open_period?: number | null;
  /** @nullable */
  options?: PollOption[] | null;
  /** @nullable */
  question?: string | null;
  /** @nullable */
  question_entities?: MessageEntity[] | null;
  total_voter_count?: number;
  type?: PollType;
}

export type PlatformPreset = typeof PlatformPreset[keyof typeof PlatformPreset];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlatformPreset = {
  telegram: 'telegram',
  vk: 'vk',
  ok: 'ok',
  youTube: 'youTube',
  ruTube: 'ruTube',
  dzen: 'dzen',
  website: 'website',
  mobileApp: 'mobileApp',
  smartTV: 'smartTV',
  hbbTV: 'hbbTV',
  marketplace: 'marketplace',
  tikTok: 'tikTok',
  max: 'max',
  other: 'other',
} as const;

export interface PlatformOAuthStatus {
  /** @nullable */
  connectedAt?: string | null;
  isConnected: boolean;
  /** @nullable */
  lastError?: string | null;
  /** @nullable */
  lastUsedAt?: string | null;
  /** @nullable */
  platformUserId?: string | null;
}

export interface PhotoSize {
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
  height?: number;
  width?: number;
}

export interface PersonMyResponse {
  /** @nullable */
  address?: string | null;
  /** @nullable */
  companyName?: string | null;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  inn?: string | null;
  /** @nullable */
  isSelfPromotion?: boolean | null;
  /** @nullable */
  juridicalType?: string | null;
  /** @nullable */
  kpp?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  regionNumber?: string | null;
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  roles?: string[] | null;
  /** @nullable */
  taxId?: string | null;
}

export interface PersonMyWrapperResponse {
  organization?: PersonMyResponse;
}

export interface PermissionDto {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  displayNameRu?: string | null;
  /** @nullable */
  module?: string | null;
}

export interface PendingPayoutDto {
  amount?: number;
  createdAt?: string;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  notes?: string | null;
  partnerId?: string;
  /** @nullable */
  partnerPromoCode?: string | null;
  /** @nullable */
  partnerUserId?: string | null;
  /** @nullable */
  paymentDetails?: string | null;
  payoutId?: string;
}

export interface PaymentSyncResponse {
  /** @nullable */
  canceledAt?: string | null;
  id?: string;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  succeededAt?: string | null;
  updatedAt?: string;
}

export interface PaymentDetailResponse {
  amount?: number;
  /** @nullable */
  canceledAt?: string | null;
  createdAt?: string;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  description?: string | null;
  id?: string;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  succeededAt?: string | null;
}

export interface PassportFile {
  file_date?: string;
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
}

export interface PassportData {
  credentials?: EncryptedCredentials;
  /** @nullable */
  data?: EncryptedPassportElement[] | null;
}

export interface PartnerStatisticsDto {
  /** @nullable */
  activatedAt?: string | null;
  activeSubscriptions?: number;
  commissionRate?: number;
  createdAt?: string;
  currentBalance?: number;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  level?: string | null;
  lifetimeEarnings?: number;
  paidCommissions?: number;
  partnerId?: string;
  payoutCount?: number;
  pendingCommissions?: number;
  /** @nullable */
  promoCode?: string | null;
  /** @nullable */
  status?: string | null;
  totalCommissionsAccrued?: number;
  totalPayouts?: number;
  totalReferredClients?: number;
  totalRevenue?: number;
  /** @nullable */
  userId?: string | null;
}

export interface PartnerReferralDto {
  activeSubscriptions?: number;
  bindingId?: string;
  boundAt?: string;
  /** @nullable */
  clientEmail?: string | null;
  /** @nullable */
  clientUserId?: string | null;
  firstSeenAt?: string;
  paymentCount?: number;
  /** @nullable */
  source?: string | null;
  totalRevenue?: number;
  totalSubscriptions?: number;
}

export interface PartnerReferralsResponseDto {
  page?: number;
  pageSize?: number;
  /** @nullable */
  referrals?: PartnerReferralDto[] | null;
  totalCount?: number;
}

export interface PaidMessagePriceChanged {
  paid_message_star_count?: number;
}

export type PaidMediaType = typeof PaidMediaType[keyof typeof PaidMediaType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PaidMediaType = {
  preview: 'preview',
  photo: 'photo',
  video: 'video',
} as const;

export interface PaidMediaPurchased {
  from?: User;
  /** @nullable */
  paid_media_payload?: string | null;
}

export interface PaidMedia {
  type?: PaidMediaType;
}

export interface PaidMediaInfo {
  /** @nullable */
  paid_media?: PaidMedia[] | null;
  star_count?: number;
}

export interface PaginatedAuditResponse {
  /** @nullable */
  items?: UserAuditListItem[] | null;
  page?: number;
  pageSize?: number;
  total?: number;
}

export interface PageComplianceRow {
  actionRequiredCount?: number;
  filteredTotal?: number;
  /** @nullable */
  items?: ComplianceRow[] | null;
  needActsCount?: number;
  notSubmittedStatisticsCount?: number;
  /** @nullable */
  ordLoadErrors?: string[] | null;
  overdueCount?: number;
  page?: number;
  pageSize?: number;
  /** @nullable */
  providerBreakdowns?: ProviderBreakdown[] | null;
  readyToSubmitCount?: number;
  /** @nullable */
  reportingFinishedThisMonth?: ReportingFinishedItem[] | null;
  submittedCount?: number;
  total?: number;
}

export interface PadsListResponse {
  /** @nullable */
  items?: PadListItemDto[] | null;
  total?: number;
}

export interface PadSummary {
  /** @nullable */
  padExternalId?: string | null;
  /** @nullable */
  padName?: string | null;
  rows?: number;
}

export interface PadReadinessRequest {
  /** @nullable */
  ids?: string[] | null;
}

export interface PadReadinessItemDto {
  id?: string;
  ready?: boolean;
  /** @nullable */
  reason?: string | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  url?: string | null;
}

export interface PadReadinessResponse {
  /** @nullable */
  items?: PadReadinessItemDto[] | null;
}

/**
 * @nullable
 */
export type PadListItemDtoErirStatus = unknown | null;

export interface PadListItemDto {
  createdAt?: string;
  /** @nullable */
  distributionType?: string | null;
  /** @nullable */
  erirStatus?: PadListItemDtoErirStatus;
  /** @nullable */
  externalId?: string | null;
  id?: string;
  /** @nullable */
  isOwner?: boolean | null;
  /** @nullable */
  linkedAt?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  padId?: string | null;
  /** @nullable */
  personExternalId?: string | null;
  /** @nullable */
  platformPreset?: string | null;
  supportsAutoPosting?: boolean;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  username?: string | null;
}

/**
 * @nullable
 */
export type PadItemDtoErirStatus = unknown | null;

export interface PadItemDto {
  createdAt?: string;
  /** @nullable */
  distributionType?: string | null;
  /** @nullable */
  erirStatus?: PadItemDtoErirStatus;
  /** @nullable */
  externalId?: string | null;
  id?: string;
  /** @nullable */
  isOwner?: boolean | null;
  /** @nullable */
  linkedAt?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  padId?: string | null;
  /** @nullable */
  personExternalId?: string | null;
  /** @nullable */
  platformPreset?: string | null;
  ready?: boolean;
  /** @nullable */
  reason?: string | null;
  supportsAutoPosting?: boolean;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  username?: string | null;
}

export interface PadBreakdown {
  /** @nullable */
  erirStatus?: string | null;
  /** @nullable */
  impressions?: number | null;
  padId?: string;
  /** @nullable */
  padName?: string | null;
  /** @nullable */
  platformPreset?: string | null;
}

export interface OrderInfo {
  /** @nullable */
  email?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  phone_number?: string | null;
  shipping_address?: ShippingAddress;
}

export interface OrdErirIndicator {
  /** @nullable */
  providerStatus?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface OnboardingStateUpdateReq {
  /** @nullable */
  campaignType?: string | null;
  /** @nullable */
  completed?: string | null;
  /** @nullable */
  currentStep?: number | null;
  /** @nullable */
  padId?: string | null;
  /** @nullable */
  reminderEnabled?: boolean | null;
  /** @nullable */
  selectedContractId?: string | null;
  /** @nullable */
  skipped?: string | null;
  /** @nullable */
  userRole?: string | null;
}

export interface OnboardingPayload {
  /** @nullable */
  address?: string | null;
  /** @nullable */
  companyName?: string | null;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  inn?: string | null;
  isSelfPromotion?: boolean;
  /** @nullable */
  juridicalType?: string | null;
  /** @nullable */
  kpp?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  paymentNumber?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  regionNumber?: string | null;
  /** @nullable */
  registrationNumber?: string | null;
  /** @nullable */
  role?: string | null;
  /** @nullable */
  roles?: string[] | null;
  /** @nullable */
  rsUrl?: string | null;
  /** @nullable */
  taxId?: string | null;
}

export interface OkResponse {
  ok?: boolean;
}

export interface NotificationTypeSetting {
  email?: boolean;
  /** @nullable */
  frequency?: string | null;
  push?: boolean;
  telegram?: boolean;
}

export interface NotificationItemDto {
  /** @nullable */
  accountId?: string | null;
  /** @nullable */
  accountName?: string | null;
  createdAt?: number;
  id?: number;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  level?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  messagePlain?: string | null;
  /** @nullable */
  readAt?: number | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface NotificationsListResponse {
  /** @nullable */
  items?: NotificationItemDto[] | null;
}

export type NewsStatus = typeof NewsStatus[keyof typeof NewsStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NewsStatus = {
  draft: 'draft',
  published: 'published',
  archived: 'archived',
} as const;

export interface News {
  /** @minLength 1 */
  authorAdminId: string;
  /**
   * @minLength 1
   * @maxLength 10000
   */
  content: string;
  createdAt?: string;
  id?: string;
  /** @nullable */
  publishedAt?: string | null;
  status?: NewsStatus;
  /**
   * @minLength 1
   * @maxLength 200
   */
  title: string;
}

export interface MyPermissionsDto {
  /** @nullable */
  permissions?: string[] | null;
  roleId?: string;
  /** @nullable */
  roleName?: string | null;
  /** @nullable */
  systemKind?: string | null;
}

export interface MonthlyReachItem {
  /** @nullable */
  month?: string | null;
  views?: number;
}

export interface MonthlyReachResponse {
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  months?: MonthlyReachItem[] | null;
}

export interface MonitoringTaskDto {
  /** @nullable */
  channelTitle?: string | null;
  /** @nullable */
  channelUsername?: string | null;
  createdAt?: string;
  /** @nullable */
  deletedAt?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  expectedDeleteAt?: string | null;
  /** @nullable */
  expectedPublishAt?: string | null;
  id?: string;
  isActive?: boolean;
  /** @nullable */
  lastCheckedAt?: string | null;
  /** @nullable */
  platform?: string | null;
  /** @nullable */
  platformPostId?: string | null;
  /** @nullable */
  postLink?: string | null;
  /** @nullable */
  publishedAt?: string | null;
  /** @nullable */
  searchText?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface MonitoringTasksResponse {
  /** @nullable */
  items?: MonitoringTaskDto[] | null;
  page?: number;
  pageSize?: number;
  total?: number;
}

export interface MonitorBotUserDto {
  createdAt?: string;
  id?: string;
  isActive?: boolean;
  maxTasks?: number;
  /** @nullable */
  metkaAccountId?: string | null;
  tasksCount?: number;
  /** @nullable */
  telegramFirstName?: string | null;
  telegramUserId?: number;
  /** @nullable */
  telegramUsername?: string | null;
}

export interface MonitorBotUsersResponse {
  /** @nullable */
  items?: MonitorBotUserDto[] | null;
  page?: number;
  pageSize?: number;
  total?: number;
}

export interface MonitorBotTaskDto {
  /** @nullable */
  accountId?: string | null;
  /** @nullable */
  channelTitle?: string | null;
  /** @nullable */
  channelUsername?: string | null;
  /** @nullable */
  createdAt?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  expectedDeleteAt?: string | null;
  /** @nullable */
  expectedPublishAt?: string | null;
  id?: string;
  isActive?: boolean;
  /** @nullable */
  lastCheckedAt?: string | null;
  /** @nullable */
  nextCheckAt?: string | null;
  /** @nullable */
  platform?: string | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  telegramUserId?: number | null;
}

export interface MonitorBotTasksResponse {
  /** @nullable */
  items?: MonitorBotTaskDto[] | null;
  page?: number;
  pageSize?: number;
  total?: number;
}

export interface MonitorBotStatsResponse {
  activeTasks?: number;
  awaitingPublication?: number;
  checksLast24Hours?: number;
  deleted?: number;
  notDeletedOnTime?: number;
  notPublishedOnTime?: number;
  published?: number;
  tasksLast7Days?: number;
  totalUsers?: number;
}

export interface MessageReactionUpdated {
  actor_chat?: Chat;
  chat?: Chat;
  date?: string;
  message_id?: number;
  /** @nullable */
  new_reaction?: ReactionType[] | null;
  /** @nullable */
  old_reaction?: ReactionType[] | null;
  user?: User;
}

export interface MessageReactionCountUpdated {
  chat?: Chat;
  date?: string;
  message_id?: number;
  /** @nullable */
  reactions?: ReactionCount[] | null;
}

export type MessageOriginType = typeof MessageOriginType[keyof typeof MessageOriginType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageOriginType = {
  user: 'user',
  hiddenUser: 'hiddenUser',
  chat: 'chat',
  channel: 'channel',
} as const;

export interface MessageOrigin {
  date?: string;
  type?: MessageOriginType;
}

export type MessageEntityType = typeof MessageEntityType[keyof typeof MessageEntityType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MessageEntityType = {
  mention: 'mention',
  hashtag: 'hashtag',
  botCommand: 'botCommand',
  url: 'url',
  email: 'email',
  bold: 'bold',
  italic: 'italic',
  code: 'code',
  pre: 'pre',
  textLink: 'textLink',
  textMention: 'textMention',
  phoneNumber: 'phoneNumber',
  cashtag: 'cashtag',
  underline: 'underline',
  strikethrough: 'strikethrough',
  spoiler: 'spoiler',
  customEmoji: 'customEmoji',
  blockquote: 'blockquote',
  expandableBlockquote: 'expandableBlockquote',
} as const;

export interface MessageEntity {
  /** @nullable */
  custom_emoji_id?: string | null;
  /** @nullable */
  language?: string | null;
  length?: number;
  offset?: number;
  type?: MessageEntityType;
  /** @nullable */
  url?: string | null;
  user?: User;
}

export interface MessageAutoDeleteTimerChanged {
  message_auto_delete_time?: number;
}

export interface MemberDto {
  /** @nullable */
  cabinetAccountIds?: string[] | null;
  /** @nullable */
  displayName?: string | null;
  /** @nullable */
  email?: string | null;
  joinedAt?: string;
  /** @nullable */
  lastAccessedAt?: string | null;
  roleId?: string;
  /** @nullable */
  roleName?: string | null;
  /** @nullable */
  systemKind?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface MaxPostStatsResponse {
  collectedAtMs?: number;
  likes?: number;
  postId?: number;
  /** @nullable */
  postUrl?: string | null;
  /** @nullable */
  status?: string | null;
  views?: number;
}

export interface MaxMonthlyReachItem {
  /** @nullable */
  month?: string | null;
  views?: number;
}

export interface MaxMonthlyReachResponse {
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  months?: MaxMonthlyReachItem[] | null;
}

export interface MaxLinkPostResponse {
  /** @nullable */
  channel?: string | null;
  linkedAtMs?: number;
  postId?: number;
  /** @nullable */
  postUrl?: string | null;
  /** @nullable */
  slug?: string | null;
  views?: number;
}

export interface MaxLinkPostRequest {
  /** @nullable */
  postUrl?: string | null;
}

export interface MaxEridReachResponse {
  /** @nullable */
  erid?: string | null;
  reach?: number;
  /** @nullable */
  updatedAtMs?: number | null;
}

export type MaskPositionPoint = typeof MaskPositionPoint[keyof typeof MaskPositionPoint];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MaskPositionPoint = {
  forehead: 'forehead',
  eyes: 'eyes',
  mouth: 'mouth',
  chin: 'chin',
} as const;

export interface MaskPosition {
  point?: MaskPositionPoint;
  scale?: number;
  x_shift?: number;
  y_shift?: number;
}

export interface ManualStatisticResponse {
  /** @nullable */
  message?: string | null;
  ok?: boolean;
}

export interface ManualStatisticRequest {
  /** @nullable */
  amountWithVat?: number | null;
  /** @nullable */
  dateEnd?: string | null;
  /** @nullable */
  dateStart?: string | null;
  /** @nullable */
  eventCost?: number | null;
  /** @nullable */
  padExternalId?: string | null;
  /** @nullable */
  paidShows?: number | null;
  /** @nullable */
  paymentEventType?: string | null;
  postId?: string;
  shows?: number;
  /** @nullable */
  vatRate?: number | null;
}

export interface ManualImpressionsRequest {
  /** @minLength 1 */
  creativeId: string;
  /**
   * @minimum 0
   * @maximum 2147483647
   */
  impressions: number;
  /**
   * @minimum 1
   * @maximum 12
   */
  month: number;
  /**
   * @minimum 2020
   * @maximum 2100
   */
  year: number;
}

export interface LoginUrl {
  /** @nullable */
  bot_username?: string | null;
  /** @nullable */
  forward_text?: string | null;
  request_write_access?: boolean;
  /** @nullable */
  url?: string | null;
}

export interface Location {
  /** @nullable */
  heading?: number | null;
  /** @nullable */
  horizontal_accuracy?: number | null;
  latitude?: number;
  /** @nullable */
  live_period?: number | null;
  longitude?: number;
  /** @nullable */
  proximity_alert_radius?: number | null;
}

export interface LinkPreviewOptions {
  is_disabled?: boolean;
  prefer_large_media?: boolean;
  prefer_small_media?: boolean;
  show_above_text?: boolean;
  /** @nullable */
  url?: string | null;
}

export interface Message {
  animation?: Animation;
  audio?: Audio;
  /** @nullable */
  author_signature?: string | null;
  boost_added?: ChatBoostAdded;
  /** @nullable */
  business_connection_id?: string | null;
  /** @nullable */
  caption?: string | null;
  /** @nullable */
  caption_entities?: MessageEntity[] | null;
  /** @nullable */
  channel_chat_created?: boolean | null;
  chat?: Chat;
  chat_background_set?: ChatBackground;
  chat_owner_changed?: ChatOwnerChanged;
  chat_owner_left?: ChatOwnerLeft;
  chat_shared?: ChatShared;
  checklist?: Checklist;
  checklist_tasks_added?: ChecklistTasksAdded;
  checklist_tasks_done?: ChecklistTasksDone;
  /** @nullable */
  connected_website?: string | null;
  contact?: Contact;
  date?: string;
  /** @nullable */
  delete_chat_photo?: boolean | null;
  dice?: Dice;
  direct_message_price_changed?: DirectMessagePriceChanged;
  direct_messages_topic?: DirectMessagesTopic;
  document?: Document;
  /** @nullable */
  edit_date?: string | null;
  /** @nullable */
  effect_id?: string | null;
  /** @nullable */
  entities?: MessageEntity[] | null;
  external_reply?: ExternalReplyInfo;
  forum_topic_closed?: ForumTopicClosed;
  forum_topic_created?: ForumTopicCreated;
  forum_topic_edited?: ForumTopicEdited;
  forum_topic_reopened?: ForumTopicReopened;
  forward_origin?: MessageOrigin;
  from?: User;
  game?: Game;
  general_forum_topic_hidden?: GeneralForumTopicHidden;
  general_forum_topic_unhidden?: GeneralForumTopicUnhidden;
  gift?: GiftInfo;
  gift_upgrade_sent?: GiftInfo;
  giveaway?: Giveaway;
  giveaway_completed?: GiveawayCompleted;
  giveaway_created?: GiveawayCreated;
  giveaway_winners?: GiveawayWinners;
  /** @nullable */
  group_chat_created?: boolean | null;
  has_media_spoiler?: boolean;
  has_protected_content?: boolean;
  invoice?: Invoice;
  is_automatic_forward?: boolean;
  is_from_offline?: boolean;
  is_paid_post?: boolean;
  is_topic_message?: boolean;
  left_chat_member?: User;
  link_preview_options?: LinkPreviewOptions;
  location?: Location;
  /** @nullable */
  media_group_id?: string | null;
  message_auto_delete_timer_changed?: MessageAutoDeleteTimerChanged;
  message_id?: number;
  /** @nullable */
  message_thread_id?: number | null;
  /** @nullable */
  migrate_from_chat_id?: number | null;
  /** @nullable */
  migrate_to_chat_id?: number | null;
  /** @nullable */
  new_chat_members?: User[] | null;
  /** @nullable */
  new_chat_photo?: PhotoSize[] | null;
  /** @nullable */
  new_chat_title?: string | null;
  paid_media?: PaidMediaInfo;
  paid_message_price_changed?: PaidMessagePriceChanged;
  /** @nullable */
  paid_star_count?: number | null;
  passport_data?: PassportData;
  /** @nullable */
  photo?: PhotoSize[] | null;
  pinned_message?: Message;
  poll?: Poll;
  proximity_alert_triggered?: ProximityAlertTriggered;
  quote?: TextQuote;
  refunded_payment?: RefundedPayment;
  reply_markup?: InlineKeyboardMarkup;
  /** @nullable */
  reply_to_checklist_task_id?: number | null;
  reply_to_message?: Message;
  reply_to_story?: Story;
  /** @nullable */
  sender_boost_count?: number | null;
  sender_business_bot?: User;
  sender_chat?: Chat;
  show_caption_above_media?: boolean;
  sticker?: Sticker;
  story?: Story;
  successful_payment?: SuccessfulPayment;
  suggested_post_approval_failed?: SuggestedPostApprovalFailed;
  suggested_post_approved?: SuggestedPostApproved;
  suggested_post_declined?: SuggestedPostDeclined;
  suggested_post_info?: SuggestedPostInfo;
  suggested_post_paid?: SuggestedPostPaid;
  suggested_post_refunded?: SuggestedPostRefunded;
  /** @nullable */
  supergroup_chat_created?: boolean | null;
  /** @nullable */
  text?: string | null;
  unique_gift?: UniqueGiftInfo;
  users_shared?: UsersShared;
  venue?: Venue;
  via_bot?: User;
  video?: Video;
  video_chat_ended?: VideoChatEnded;
  video_chat_participants_invited?: VideoChatParticipantsInvited;
  video_chat_scheduled?: VideoChatScheduled;
  video_chat_started?: VideoChatStarted;
  video_note?: VideoNote;
  voice?: Voice;
  web_app_data?: WebAppData;
  write_access_allowed?: WriteAccessAllowed;
}

export interface LinkInvoiceBody {
  /** @nullable */
  month?: string | null;
}

export interface LinkInitialContractRequest {
  creativeId?: string;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  initialContractId?: string | null;
  /** @nullable */
  number?: string | null;
  /** @nullable */
  partyAExternalId?: string | null;
  /** @nullable */
  partyBExternalId?: string | null;
  type?: InitialContractType;
}

export interface LegalDocumentVersionsResponse {
  /** @nullable */
  privacyPolicy?: string | null;
  /** @nullable */
  publicOffer?: string | null;
  /** @nullable */
  termsOfService?: string | null;
}

export type LegalConsentType = typeof LegalConsentType[keyof typeof LegalConsentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LegalConsentType = {
  pdnProcessing: 'pdnProcessing',
  privacyPolicy: 'privacyPolicy',
  termsAndOffer: 'termsAndOffer',
} as const;

export type LegalConsentSource = typeof LegalConsentSource[keyof typeof LegalConsentSource];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LegalConsentSource = {
  signup: 'signup',
  contactForm: 'contactForm',
} as const;

export interface LegalConsentItem {
  type?: LegalConsentType;
  /** @nullable */
  version?: string | null;
}

export interface KktuItemDto {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  name?: string | null;
}

export type KeyboardButtonStyle = typeof KeyboardButtonStyle[keyof typeof KeyboardButtonStyle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const KeyboardButtonStyle = {
  danger: 'danger',
  success: 'success',
  primary: 'primary',
} as const;

export interface JsonNodeOptions {
  propertyNameCaseInsensitive?: boolean;
}

export interface JsonNode {
  options?: JsonNodeOptions;
  parent?: JsonNode;
  root?: JsonNode;
}

export interface InvoiceHeaderDto {
  /** @nullable */
  amountExcludingVat?: number | null;
  /** @nullable */
  amountIncludingVat?: number | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  contractDate?: string | null;
  /** @nullable */
  contractExternalId?: string | null;
  /** @nullable */
  contractKind?: string | null;
  /** @nullable */
  contractSerial?: string | null;
  /** @nullable */
  customerRole?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  dateEnd?: string | null;
  /** @nullable */
  dateStart?: string | null;
  /** @nullable */
  editableUntil?: string | null;
  /** @nullable */
  editableUntilSource?: string | null;
  erirStatus?: ErirStatusDto;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  hasAllocations?: boolean | null;
  /** @nullable */
  isSocial?: boolean | null;
  /** @nullable */
  isSocialQuota?: boolean | null;
  /** @nullable */
  performerRole?: string | null;
  /** @nullable */
  serial?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  vat?: number | null;
  /** @nullable */
  vatRate?: string | null;
}

export interface Invoice {
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  start_parameter?: string | null;
  /** @nullable */
  title?: string | null;
  total_amount?: number;
}

export interface InvitationCabinetDto {
  accountId?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  teamName?: string | null;
}

export interface InvitationPreviewDto {
  /** @nullable */
  accountName?: string | null;
  /** @nullable */
  cabinets?: InvitationCabinetDto[] | null;
  /** @nullable */
  inviteeEmail?: string | null;
  /** @nullable */
  inviterEmail?: string | null;
  requiresPasswordSetup?: boolean;
  roleKind?: SystemRoleKind;
  /** @nullable */
  roleName?: string | null;
  /** @nullable */
  teamName?: string | null;
}

export interface InvitationDto {
  createdAt?: string;
  /** @nullable */
  email?: string | null;
  expiresAt?: string;
  id?: string;
  /** @nullable */
  inviterEmail?: string | null;
  roleId?: string;
  /** @nullable */
  roleName?: string | null;
}

export type InnLookupType = typeof InnLookupType[keyof typeof InnLookupType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InnLookupType = {
  juridical: 'juridical',
  soleProprietor: 'soleProprietor',
} as const;

export type InnLookupStatus = typeof InnLookupStatus[keyof typeof InnLookupStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InnLookupStatus = {
  active: 'active',
  liquidated: 'liquidated',
  suspended: 'suspended',
} as const;

export interface InnLookupSuggestion {
  /** @nullable */
  address?: string | null;
  /** @nullable */
  inn?: string | null;
  /** @nullable */
  kpp?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  ogrn?: string | null;
  /** @nullable */
  ogrnip?: string | null;
  registrationDate?: string;
  status?: InnLookupStatus;
  type?: InnLookupType;
}

export interface InnLookupResponse {
  /** @nullable */
  suggestions?: InnLookupSuggestion[] | null;
}

export type InnLookupContext = typeof InnLookupContext[keyof typeof InnLookupContext];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InnLookupContext = {
  onboarding: 'onboarding',
  settings: 'settings',
} as const;

export interface InnLookupRequest {
  context?: InnLookupContext;
  /** @nullable */
  inn?: string | null;
  /** @nullable */
  kpp?: string | null;
}

export interface InlineQuery {
  chat_type?: ChatType;
  from?: User;
  /** @nullable */
  id?: string | null;
  location?: Location;
  /** @nullable */
  offset?: string | null;
  /** @nullable */
  query?: string | null;
}

export interface InlineKeyboardButton {
  /** @nullable */
  callback_data?: string | null;
  callback_game?: CallbackGame;
  copy_text?: CopyTextButton;
  /** @nullable */
  icon_custom_emoji_id?: string | null;
  login_url?: LoginUrl;
  pay?: boolean;
  style?: KeyboardButtonStyle;
  /** @nullable */
  switch_inline_query?: string | null;
  switch_inline_query_chosen_chat?: SwitchInlineQueryChosenChat;
  /** @nullable */
  switch_inline_query_current_chat?: string | null;
  /** @nullable */
  text?: string | null;
  /** @nullable */
  url?: string | null;
  web_app?: WebAppInfo;
}

export interface InlineKeyboardMarkup {
  /** @nullable */
  inline_keyboard?: InlineKeyboardButton[][] | null;
}

export type InitialContractType = typeof InitialContractType[keyof typeof InitialContractType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const InitialContractType = {
  agency: 'agency',
  services: 'services',
} as const;

export interface InitialContractIndicator {
  /** @nullable */
  matchScore?: number | null;
  /** @nullable */
  status?: string | null;
}

/**
 * @nullable
 */
export type HttpValidationProblemDetailsErrors = {[key: string]: string[]} | null;

export interface HttpValidationProblemDetails {
  /** @nullable */
  detail?: string | null;
  /** @nullable */
  errors?: HttpValidationProblemDetailsErrors;
  /** @nullable */
  instance?: string | null;
  /** @nullable */
  status?: number | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  type?: string | null;
  [key: string]: unknown;
}

export interface GrantTrialRequest {
  /** @nullable */
  durationDays?: number | null;
}

export interface GlobalChannels {
  email?: boolean;
  push?: boolean;
  telegram?: boolean;
}

export interface GiveawayWinners {
  /** @nullable */
  additional_chat_count?: number | null;
  chat?: Chat;
  giveaway_message_id?: number;
  only_new_members?: boolean;
  /** @nullable */
  premium_subscription_month_count?: number | null;
  /** @nullable */
  prize_description?: string | null;
  /** @nullable */
  prize_star_count?: number | null;
  /** @nullable */
  unclaimed_prize_count?: number | null;
  was_refunded?: boolean;
  winner_count?: number;
  /** @nullable */
  winners?: User[] | null;
  winners_selection_date?: string;
}

export interface GiveawayCreated {
  /** @nullable */
  prize_star_count?: number | null;
}

export interface GiveawayCompleted {
  giveaway_message?: Message;
  is_star_giveaway?: boolean;
  /** @nullable */
  unclaimed_prize_count?: number | null;
  winner_count?: number;
}

export interface Giveaway {
  /** @nullable */
  chats?: Chat[] | null;
  /** @nullable */
  country_codes?: string[] | null;
  has_public_winners?: boolean;
  only_new_members?: boolean;
  /** @nullable */
  premium_subscription_month_count?: number | null;
  /** @nullable */
  prize_description?: string | null;
  /** @nullable */
  prize_star_count?: number | null;
  winner_count?: number;
  winners_selection_date?: string;
}

export interface GiftInfo {
  can_be_upgraded?: boolean;
  /** @nullable */
  convert_star_count?: number | null;
  /** @nullable */
  entities?: MessageEntity[] | null;
  gift?: Gift;
  is_private?: boolean;
  is_upgrade_separate?: boolean;
  /** @nullable */
  owned_gift_id?: string | null;
  /** @nullable */
  prepaid_upgrade_star_count?: number | null;
  /** @nullable */
  text?: string | null;
  /** @nullable */
  unique_gift_number?: number | null;
}

export interface GiftBackground {
  center_color?: number;
  edge_color?: number;
  text_color?: number;
}

export interface Gift {
  background?: GiftBackground;
  has_colors?: boolean;
  /** @nullable */
  id?: string | null;
  is_premium?: boolean;
  /** @nullable */
  personal_remaining_count?: number | null;
  /** @nullable */
  personal_total_count?: number | null;
  publisher_chat?: Chat;
  /** @nullable */
  remaining_count?: number | null;
  star_count?: number;
  sticker?: Sticker;
  /** @nullable */
  total_count?: number | null;
  /** @nullable */
  unique_gift_variant_count?: number | null;
  /** @nullable */
  upgrade_star_count?: number | null;
}

export interface GenerateEridResponse {
  /** @nullable */
  creativeOrdId?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  markupText?: string | null;
  processing?: boolean;
}

export interface GenerateEridRequest {
  analysisId?: string;
  /** @nullable */
  brand?: string | null;
  /** @nullable */
  category?: string | null;
  /** @nullable */
  contentText?: string | null;
  /** @nullable */
  contentTexts?: string[] | null;
  /** @nullable */
  creativeName?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  imageUrls?: string[] | null;
  /** @nullable */
  kktus?: string[] | null;
  markedTextIndex?: number;
  /** @nullable */
  padId?: string | null;
  /** @nullable */
  padIds?: string[] | null;
  /** @nullable */
  postId?: string | null;
  /** @nullable */
  provider?: string | null;
  /** @nullable */
  selectedContractIds?: string[] | null;
  /** @nullable */
  selfPromo?: boolean | null;
  /** @nullable */
  socialAd?: boolean | null;
  /** @nullable */
  socialQuota?: boolean | null;
  targeting?: CreativeTargetingData;
  /** @nullable */
  targetUrls?: string[] | null;
  /** @nullable */
  userCorrections?: string | null;
  /** @nullable */
  videoUrls?: string[] | null;
}

export interface GeneralForumTopicUnhidden { [key: string]: unknown }

export interface GeneralForumTopicHidden { [key: string]: unknown }

export interface Game {
  animation?: Animation;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  photo?: PhotoSize[] | null;
  /** @nullable */
  text?: string | null;
  /** @nullable */
  text_entities?: MessageEntity[] | null;
  /** @nullable */
  title?: string | null;
}

export interface ForumTopicReopened { [key: string]: unknown }

export interface ForumTopicEdited {
  /** @nullable */
  icon_custom_emoji_id?: string | null;
  /** @nullable */
  name?: string | null;
}

export interface ForumTopicCreated {
  icon_color?: number;
  /** @nullable */
  icon_custom_emoji_id?: string | null;
  is_name_implicit?: boolean;
  /** @nullable */
  name?: string | null;
}

export interface ForumTopicClosed { [key: string]: unknown }

export interface FixMoovAtomResponse {
  /** @nullable */
  error?: string | null;
  success?: boolean;
  validationResult?: VideoValidationResponse;
  /** @nullable */
  videoKey?: string | null;
}

export interface FixMoovAtomRequest {
  /** @nullable */
  videoKey?: string | null;
}

export interface FinalizeVideoRequest {
  postId?: string;
  /** @nullable */
  uploadedAtMs?: number | null;
  /** @nullable */
  videoKey?: string | null;
}

export interface FinalizeCreativeRequest {
  /** @nullable */
  originalKey?: string | null;
  postId?: string;
  /** @nullable */
  processedKey?: string | null;
  /** @nullable */
  publishedAtMs?: number | null;
}

export interface FeedbackResponse {
  /** @nullable */
  message?: string | null;
  success?: boolean;
}

export interface FeedbackConsentItem {
  type?: LegalConsentType;
  /** @nullable */
  version?: string | null;
}

export interface FeedbackRequest {
  /** @nullable */
  company?: string | null;
  /** @nullable */
  consents?: FeedbackConsentItem[] | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  message?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  phone?: string | null;
}

export interface ExtraCabinetsInfoResponse {
  /** @nullable */
  expiresAt?: string | null;
  extraCabinetsCount?: number;
  isAgency?: boolean;
  pricePerMonthRub?: number;
  subscriptionId?: string;
  /** @nullable */
  tariffCode?: string | null;
}

export interface ExtraCabinetsCalculationResponse {
  amountDue?: number;
  expiresAt?: string;
  pricePerMonthRub?: number;
  quantity?: number;
  remainingDays?: number;
}

export interface ExternalReplyInfo {
  animation?: Animation;
  audio?: Audio;
  chat?: Chat;
  checklist?: Checklist;
  contact?: Contact;
  dice?: Dice;
  document?: Document;
  game?: Game;
  giveaway?: Giveaway;
  giveaway_winners?: GiveawayWinners;
  has_media_spoiler?: boolean;
  invoice?: Invoice;
  link_preview_options?: LinkPreviewOptions;
  location?: Location;
  /** @nullable */
  message_id?: number | null;
  origin?: MessageOrigin;
  paid_media?: PaidMediaInfo;
  /** @nullable */
  photo?: PhotoSize[] | null;
  poll?: Poll;
  sticker?: Sticker;
  story?: Story;
  venue?: Venue;
  video?: Video;
  video_note?: VideoNote;
  voice?: Voice;
}

export interface ExportStartRequest {
  /** @nullable */
  columns?: string[] | null;
  /** @nullable */
  columnsPreset?: string | null;
  /** @nullable */
  groupBy?: string | null;
  /** @nullable */
  month?: string | null;
  onlyActionRequired?: boolean;
}

export interface ExampleCreateRequest {
  /** @nullable */
  authorId?: string | null;
  /** @nullable */
  authorName?: string | null;
  /** @nullable */
  authorType?: string | null;
  /** @nullable */
  images?: unknown[] | null;
  /** @nullable */
  text?: string | null;
}

export interface ErirStatusDto {
  /** @nullable */
  finalizedTs?: string | null;
  /** @nullable */
  messages?: string[] | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  updatedByUserTs?: string | null;
}

export interface EridReachResponse {
  /** @nullable */
  erid?: string | null;
  reach?: number;
  /** @nullable */
  updatedAtMs?: number | null;
}

export type EridGenerationStatus = typeof EridGenerationStatus[keyof typeof EridGenerationStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EridGenerationStatus = {
  generating: 'generating',
  downloading: 'downloading',
  uploading: 'uploading',
  completed: 'completed',
  error: 'error',
} as const;

export type EncryptedPassportElementType = typeof EncryptedPassportElementType[keyof typeof EncryptedPassportElementType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const EncryptedPassportElementType = {
  personalDetails: 'personalDetails',
  passport: 'passport',
  driverLicense: 'driverLicense',
  identityCard: 'identityCard',
  internalPassport: 'internalPassport',
  address: 'address',
  utilityBill: 'utilityBill',
  bankStatement: 'bankStatement',
  rentalAgreement: 'rentalAgreement',
  passportRegistration: 'passportRegistration',
  temporaryRegistration: 'temporaryRegistration',
  phoneNumber: 'phoneNumber',
  email: 'email',
} as const;

export interface EncryptedPassportElement {
  /** @nullable */
  data?: string | null;
  /** @nullable */
  email?: string | null;
  /** @nullable */
  files?: PassportFile[] | null;
  front_side?: PassportFile;
  /** @nullable */
  hash?: string | null;
  /** @nullable */
  phone_number?: string | null;
  reverse_side?: PassportFile;
  selfie?: PassportFile;
  /** @nullable */
  translation?: PassportFile[] | null;
  type?: EncryptedPassportElementType;
}

export interface EncryptedCredentials {
  /** @nullable */
  data?: string | null;
  /** @nullable */
  hash?: string | null;
  /** @nullable */
  secret?: string | null;
}

export interface DuplicateInvoiceDto {
  /** @nullable */
  amountIncludingVat?: number | null;
  /** @nullable */
  contractSerial?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  serial?: string | null;
}

export interface DuplicateGroupDto {
  /** @nullable */
  amountIncludingVat?: number | null;
  /** @nullable */
  contractExternalId?: string | null;
  /** @nullable */
  contractSerial?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  invoices?: DuplicateInvoiceDto[] | null;
  /** @nullable */
  serial?: string | null;
}

export interface DuplicatesIndicator {
  groupCount?: number;
  /** @nullable */
  groups?: DuplicateGroupDto[] | null;
  /** @nullable */
  status?: string | null;
}

export interface Document {
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_name?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
  /** @nullable */
  mime_type?: string | null;
  thumbnail?: PhotoSize;
}

export type DistributionType = typeof DistributionType[keyof typeof DistributionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DistributionType = {
  site: 'site',
  app: 'app',
  smartTV: 'smartTV',
  hbbTV: 'hbbTV',
  marketplace: 'marketplace',
} as const;

export interface DirectMessagesTopic {
  topic_id?: number;
  user?: User;
}

export interface DirectMessagePriceChanged {
  are_direct_messages_enabled?: boolean;
  /** @nullable */
  direct_message_star_count?: number | null;
}

export interface Dice {
  /** @nullable */
  emoji?: string | null;
  value?: number;
}

export interface DeletePostResponse {
  deleted?: number;
  ok?: boolean;
}

export interface DeleteOkResponse {
  ok?: boolean;
}

export interface DeadlineIndicator {
  /** @nullable */
  daysLeft?: number | null;
  /** @nullable */
  status?: string | null;
}

export interface CurrentTariffResponse {
  autoRenew?: boolean;
  capabilities?: TariffCapabilitiesDto;
  /** @nullable */
  expiresAt?: string | null;
  isTrial?: boolean;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  tariffCode?: string | null;
  tariffId?: string;
  /** @nullable */
  tariffName?: string | null;
}

export interface CurrentSubscriptionResponse {
  autoRenew?: boolean;
  /** @nullable */
  expiresAt?: string | null;
  extraCabinetsCount?: number;
  isTrial?: boolean;
  startedAt?: string;
  /** @nullable */
  status?: string | null;
  subscriptionId?: string;
  /** @nullable */
  tariffCode?: string | null;
  /** @nullable */
  tariffName?: string | null;
  /** @nullable */
  trialEndsAt?: string | null;
}

export interface CsvImportPreviewRow {
  /** @nullable */
  channelUsername?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  expectedDeleteAt?: string | null;
  /** @nullable */
  expectedPublishAt?: string | null;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  platform?: string | null;
  rowNumber?: number;
  /** @nullable */
  searchText?: string | null;
}

export interface CsvImportErrorDto {
  /** @nullable */
  field?: string | null;
  /** @nullable */
  message?: string | null;
  rowNumber?: number;
}

export interface CsvImportPreviewResponse {
  /** @nullable */
  errors?: CsvImportErrorDto[] | null;
  truncated?: boolean;
  /** @nullable */
  validRows?: CsvImportPreviewRow[] | null;
}

export interface CsvImportConfirmRow {
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  expectedDeleteAt?: string | null;
  /** @nullable */
  expectedPublishAt?: string | null;
  isAlreadyPublished?: boolean;
  /** @nullable */
  link?: string | null;
  /** @nullable */
  searchText?: string | null;
}

export interface CsvImportConfirmResponse {
  created?: number;
  /** @nullable */
  limitMessage?: string | null;
  skipped?: number;
}

export interface CsvImportConfirmRequest {
  /** @nullable */
  rows?: CsvImportConfirmRow[] | null;
}

export interface CreativeTargetingData {
  /** @nullable */
  ageFrom?: number | null;
  /** @nullable */
  ageTo?: number | null;
  /** @nullable */
  geo?: string[] | null;
  /** @nullable */
  geoName?: string[] | null;
  readonly hasAnyValue?: boolean;
  /** @nullable */
  sex?: string | null;
}

export interface CreativePlatformStatsRequest {
  /** @nullable */
  amount?: string | null;
  /** @nullable */
  amountPerEvent?: string | null;
  /** @nullable */
  amountWithoutVat?: string | null;
  autoCalculate?: boolean;
  /** @nullable */
  dateEndActual?: string | null;
  /** @nullable */
  dateEndPlanned?: string | null;
  /** @nullable */
  dateStartActual?: string | null;
  /** @nullable */
  dateStartPlanned?: string | null;
  invoiceShowsCount?: number;
  /** @nullable */
  padExternalId?: string | null;
  /** @nullable */
  payType?: string | null;
  plannedMatchesActual?: boolean;
  showsCount?: number;
  /** @nullable */
  vatAmount?: string | null;
  /** @nullable */
  vatRate?: string | null;
}

export interface CreativeAllocationRequest {
  /** @nullable */
  creativeExternalId?: string | null;
  isCobranding?: boolean;
  platform?: CreativePlatformStatsRequest;
}

export interface CreateTariffRequest {
  /** @nullable */
  capabilitiesJson?: string | null;
  code?: TariffCode;
  /** @nullable */
  defaultDurationDays?: number | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  displayOrder?: number | null;
  /** @nullable */
  isRecommended?: boolean | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  oldPricePerMonthRub?: number | null;
  /** @nullable */
  price12MonthsRub?: number | null;
  /** @nullable */
  price3MonthsRub?: number | null;
  pricePerMonthRub?: number;
}

export interface CreateRoleRequest {
  /** @nullable */
  description?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  permissions?: string[] | null;
  /** @nullable */
  templateCode?: string | null;
}

export interface CreatePromoPresetRequest {
  /** @nullable */
  applicableTariffIds?: string[] | null;
  /** @nullable */
  applyAt?: string | null;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  name?: string | null;
  value?: number;
  /** @nullable */
  valueUnit?: string | null;
}

export interface CreatePromoCodeRequest {
  /** @nullable */
  applicableTariffIds?: string[] | null;
  /** @nullable */
  code?: string | null;
  /** @nullable */
  description?: string | null;
  /** @nullable */
  discountAmountRub?: number | null;
  /** @nullable */
  discountPercent?: number | null;
  /** @nullable */
  isActive?: boolean | null;
  /** @nullable */
  maxUses?: number | null;
  /** @nullable */
  minOrderAmountRub?: number | null;
  /** @nullable */
  partnerCommissionBonus?: number | null;
  /** @nullable */
  partnerId?: string | null;
  /** @nullable */
  type?: string | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
}

export interface CreatePaymentResponse {
  amount?: number;
  /** @nullable */
  confirmationUrl?: string | null;
  /** @nullable */
  currency?: string | null;
  paymentId?: string;
  /** @nullable */
  status?: string | null;
}

export interface CreatePaymentRequest {
  durationMonths?: number;
  /** @nullable */
  savePaymentMethod?: boolean | null;
  tariffId?: string;
}

export interface CreatePartnerPromoCodeRequest {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  presetId?: string | null;
}

export interface CreatePadRequest {
  distributionType?: DistributionType;
  /** @nullable */
  isOwner?: boolean | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  personExternalId?: string | null;
  platformPreset?: PlatformPreset;
  /** @nullable */
  provider?: string | null;
  /** @nullable */
  url?: string | null;
  /** @nullable */
  username?: string | null;
}

export interface CreateNewsRequest {
  /** @nullable */
  content?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface CreateMonitoringTaskRequest {
  /** @nullable */
  channelUsername?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  expectedDeleteAt?: string | null;
  /** @nullable */
  expectedPublishAt?: string | null;
  isAlreadyPublished?: boolean;
  /** @nullable */
  postLink?: string | null;
  /** @nullable */
  searchText?: string | null;
}

export interface CreateInvitationRequest {
  /** @nullable */
  accountIds?: string[] | null;
  /** @nullable */
  email?: string | null;
  roleId?: string;
}

export interface CreateDraftResponse {
  id?: string;
}

export interface CreateDraftRequest {
  /** @nullable */
  adPeriodEndMs?: number | null;
  /** @nullable */
  adPeriodStartMs?: number | null;
  /** @nullable */
  authorName?: string | null;
  /** @nullable */
  authorType?: string | null;
  /** @nullable */
  contentText?: string | null;
  /** @nullable */
  draftStateJson?: string | null;
  /** @nullable */
  images?: string[] | null;
}

export interface CreateContractLocalRequest {
  /** @nullable */
  actionType?: string | null;
  /** @nullable */
  amount?: string | null;
  /** @nullable */
  clientExternalId?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  contractorExternalId?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  dateEnd?: string | null;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  flags?: string[] | null;
  /** @nullable */
  parentContractExternalId?: string | null;
  /** @nullable */
  serial?: string | null;
  /** @nullable */
  subjectType?: string | null;
  /** @nullable */
  type?: string | null;
}

export interface CreateBlogTagRequest {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
}

export interface CreateBlogCategoryRequest {
  /** @nullable */
  description?: string | null;
  isHidden?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
  sortOrder?: number;
}

export interface CreateBlogAuthorRequest {
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  bio?: string | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface CreateBlogArticleRequest {
  /** @nullable */
  authorId?: string | null;
  categoryId?: string;
  /** @nullable */
  contentJson?: string | null;
  /** @nullable */
  coverImageAlt?: string | null;
  /** @nullable */
  coverImageUrl?: string | null;
  /** @nullable */
  excerpt?: string | null;
  isFeatured?: boolean;
  /** @nullable */
  scheduledAt?: string | null;
  /** @nullable */
  seoDescription?: string | null;
  /** @nullable */
  seoTitle?: string | null;
  showAuthor?: boolean;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  tagIds?: string[] | null;
  /** @nullable */
  title?: string | null;
}

export interface CreateAdminPromoCodeRequest {
  /** @nullable */
  code?: string | null;
  /** @nullable */
  maxUses?: number | null;
  /** @nullable */
  presetId?: string | null;
  /** @nullable */
  validFrom?: string | null;
  /** @nullable */
  validTo?: string | null;
}

export interface CreateAdditionalAccountRequest {
  /** @nullable */
  name?: string | null;
}

export interface CreateActLocalRequest {
  /** @nullable */
  actNumber?: string | null;
  /** @nullable */
  agentFee?: string | null;
  /** @nullable */
  amount?: string | null;
  /** @nullable */
  amountWithoutVat?: string | null;
  autoCalculate?: boolean;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  commissionExcludingVat?: string | null;
  /** @nullable */
  commissionIncludingVat?: string | null;
  /** @nullable */
  commissionVat?: string | null;
  /** @nullable */
  commissionVatRate?: string | null;
  /** @nullable */
  contractAddendumId?: string | null;
  /** @nullable */
  contractExternalId?: string | null;
  /** @nullable */
  customerRole?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  existingExternalId?: string | null;
  isSocial?: boolean;
  isSocialQuota?: boolean;
  /** @nullable */
  issueDate?: string | null;
  /** @nullable */
  parentContractExternalId?: string | null;
  /** @nullable */
  performerRole?: string | null;
  /** @nullable */
  periodEnd?: string | null;
  /** @nullable */
  periodStart?: string | null;
  /** @nullable */
  vatAmount?: string | null;
  /** @nullable */
  vatRate?: string | null;
}

export interface CreateAccountResponse {
  accountId?: string;
  /** @nullable */
  name?: string | null;
}

export interface CreateAccountRequest {
  /** @nullable */
  name?: string | null;
}

/**
 * @nullable
 */
export type CounterpartyListItemDtoErirStatus = unknown | null;

export interface CounterpartyListItemDto {
  /** @nullable */
  companyName?: string | null;
  /** @nullable */
  erirStatus?: CounterpartyListItemDtoErirStatus;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  inn?: string | null;
  /** @nullable */
  isSelfPromotion?: boolean | null;
  /** @nullable */
  juridicalType?: string | null;
  /** @nullable */
  kpp?: string | null;
  /** @nullable */
  phone?: string | null;
  /** @nullable */
  roles?: string[] | null;
  /** @nullable */
  rsUrl?: string | null;
}

export interface CounterpartiesListResponse {
  hasMore?: boolean;
  /** @nullable */
  items?: CounterpartyListItemDto[] | null;
  limit?: number;
  offset?: number;
  total?: number;
}

export interface CounterpartiesIdsResponse {
  /** @nullable */
  counterparties?: string[] | null;
}

export interface CopyTextButton {
  /** @nullable */
  text?: string | null;
}

export type ContractType = typeof ContractType[keyof typeof ContractType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ContractType = {
  agency: 'agency',
  services: 'services',
} as const;

export interface ContractStoreResponse {
  id?: string;
  ok?: boolean;
}

export interface ContractLocalListItemDto {
  /** @nullable */
  buyerCounterpartyId?: string | null;
  createdAtMs?: number;
  /** @nullable */
  externalId?: string | null;
  id?: string;
  isFramework?: boolean;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  sellerCounterpartyId?: string | null;
  /** @nullable */
  totalAmount?: number | null;
}

export interface ContractLocalListResponse {
  /** @nullable */
  items?: ContractLocalListItemDto[] | null;
}

/**
 * @nullable
 */
export type ContractListItemDtoErirStatus = unknown | null;

export interface ContractListItemDto {
  /** @nullable */
  amount?: string | null;
  /** @nullable */
  buyerCounterpartyId?: string | null;
  /** @nullable */
  buyerName?: string | null;
  /** @nullable */
  cid?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  erirStatus?: ContractListItemDtoErirStatus;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  sellerCounterpartyId?: string | null;
  /** @nullable */
  sellerName?: string | null;
  /** @nullable */
  serial?: string | null;
}

export interface ContractsListResponse {
  /** @nullable */
  items?: ContractListItemDto[] | null;
}

export interface ContractDetailsResponse {
  /** @nullable */
  actionType?: string | null;
  /** @nullable */
  amount?: string | null;
  /** @nullable */
  cid?: string | null;
  /** @nullable */
  clientExternalId?: string | null;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  contractorExternalId?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  dateEnd?: string | null;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  flags?: string[] | null;
  /** @nullable */
  parentContractExternalId?: string | null;
  /** @nullable */
  serial?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  subjectType?: string | null;
  /** @nullable */
  type?: string | null;
}

export interface ContractCreateResponse {
  /** @nullable */
  contractId?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface ContainerDetails {
  /** @nullable */
  format?: string | null;
  /** @nullable */
  moovAtStart?: boolean | null;
}

export interface Contact {
  /** @nullable */
  first_name?: string | null;
  /** @nullable */
  last_name?: string | null;
  /** @nullable */
  phone_number?: string | null;
  /** @nullable */
  user_id?: number | null;
  /** @nullable */
  vcard?: string | null;
}

export interface ConnectUrlResponse {
  /** @nullable */
  url?: string | null;
}

export interface ConnectRequest {
  /** @nullable */
  platform?: string | null;
  /** @nullable */
  username?: string | null;
}

export interface ConnectChannelRequest {
  /** @nullable */
  channelName?: string | null;
  /** @nullable */
  isOwner?: boolean | null;
  /** @nullable */
  personExternalId?: string | null;
  /** @nullable */
  telegramUsername?: string | null;
}

export interface ComplianceSummaryMonth {
  actionRequiredCount?: number;
  /** @nullable */
  computedAt?: string | null;
  /** @nullable */
  month?: string | null;
  needActsCount?: number;
  notSubmittedStatisticsCount?: number;
  overdueCount?: number;
  pending?: boolean;
  readyToSubmitCount?: number;
  submittedCount?: number;
  totalCount?: number;
}

export interface ComplianceSummaryResponse {
  /** @nullable */
  months?: ComplianceSummaryMonth[] | null;
}

export interface ComplianceIndicator {
  category?: CategoryIndicator;
  deadline?: DeadlineIndicator;
  duplicates?: DuplicatesIndicator;
  initialContract?: InitialContractIndicator;
  ordErir?: OrdErirIndicator;
  /** @nullable */
  summary?: string | null;
  threePercent?: ThreePercentIndicator;
}

export interface ComplianceRow {
  /** @nullable */
  actAmount?: number | null;
  /** @nullable */
  actDate?: string | null;
  /** @nullable */
  actNumber?: string | null;
  /** @nullable */
  actVatRate?: string | null;
  /** @nullable */
  adPeriodEnd?: string | null;
  /** @nullable */
  adPeriodStart?: string | null;
  /** @nullable */
  advertiserInn?: string | null;
  /** @nullable */
  advertiserName?: string | null;
  /** @nullable */
  channelUsername?: string | null;
  cobrandingContractCount?: number;
  /** @nullable */
  contractDate?: string | null;
  /** @nullable */
  contractExternalId?: string | null;
  /** @nullable */
  contractName?: string | null;
  /** @nullable */
  contractNumber?: string | null;
  /** @nullable */
  contractorInn?: string | null;
  /** @nullable */
  contractorName?: string | null;
  /** @nullable */
  contractType?: string | null;
  creativeId?: string;
  /** @nullable */
  creativeName?: string | null;
  /** @nullable */
  erid?: string | null;
  erirStatus?: ErirStatusDto;
  /** @nullable */
  fullText?: string | null;
  hasAct?: boolean;
  hasDeallocation?: boolean;
  hasDeallocationStats?: boolean;
  hasInitialContract?: boolean;
  /** @nullable */
  impressions?: number | null;
  indicators?: ComplianceIndicator;
  isCobranding?: boolean;
  isSelfPromotion?: boolean;
  /** @nullable */
  month?: string | null;
  needsResubmit?: boolean;
  /** @nullable */
  ordDateEnd?: string | null;
  /** @nullable */
  ordDateStart?: string | null;
  /** @nullable */
  ordShows?: number | null;
  /** @nullable */
  padBreakdowns?: PadBreakdown[] | null;
  /** @nullable */
  padTitle?: string | null;
  /** @nullable */
  platformId?: string | null;
  /** @nullable */
  platformPreset?: string | null;
  /** @nullable */
  provider?: string | null;
  /** @nullable */
  publishedAt?: string | null;
  reportingNotRequired?: boolean;
  /** @nullable */
  reportingObligationEndsAt?: string | null;
  requiresInitialContract?: boolean;
  /** @nullable */
  statisticsSource?: string | null;
  /** @nullable */
  submissionStatus?: string | null;
  /** @nullable */
  submittedShows?: number | null;
  /** @nullable */
  suggestedPeriodEndMs?: number | null;
  /** @nullable */
  suggestedPeriodStartMs?: number | null;
}

export interface CodecDetails {
  /** @nullable */
  name?: string | null;
  /** @nullable */
  profile?: string | null;
}

export interface ChosenInlineResult {
  from?: User;
  /** @nullable */
  inline_message_id?: string | null;
  location?: Location;
  /** @nullable */
  query?: string | null;
  /** @nullable */
  result_id?: string | null;
}

export interface ChecklistTasksDone {
  checklist_message?: Message;
  /** @nullable */
  marked_as_done_task_ids?: number[] | null;
  /** @nullable */
  marked_as_not_done_task_ids?: number[] | null;
}

export interface ChecklistTask {
  completed_by_chat?: Chat;
  completed_by_user?: User;
  /** @nullable */
  completion_date?: string | null;
  id?: number;
  /** @nullable */
  text?: string | null;
  /** @nullable */
  text_entities?: MessageEntity[] | null;
}

export interface ChecklistTasksAdded {
  checklist_message?: Message;
  /** @nullable */
  tasks?: ChecklistTask[] | null;
}

export interface Checklist {
  others_can_add_tasks?: boolean;
  others_can_mark_tasks_as_done?: boolean;
  /** @nullable */
  tasks?: ChecklistTask[] | null;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  title_entities?: MessageEntity[] | null;
}

export type ChatType = typeof ChatType[keyof typeof ChatType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatType = {
  private: 'private',
  group: 'group',
  channel: 'channel',
  supergroup: 'supergroup',
  sender: 'sender',
} as const;

export interface ChatShared {
  chat_id?: number;
  /** @nullable */
  photo?: PhotoSize[] | null;
  request_id?: number;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  username?: string | null;
}

export interface ChatOwnerLeft {
  new_owner?: User;
}

export interface ChatOwnerChanged {
  new_owner?: User;
}

export type ChatMemberStatus = typeof ChatMemberStatus[keyof typeof ChatMemberStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatMemberStatus = {
  creator: 'creator',
  administrator: 'administrator',
  member: 'member',
  left: 'left',
  kicked: 'kicked',
  restricted: 'restricted',
} as const;

export interface ChatMember {
  status?: ChatMemberStatus;
  user?: User;
}

export interface ChatInviteLink {
  creates_join_request?: boolean;
  creator?: User;
  /** @nullable */
  expire_date?: string | null;
  /** @nullable */
  invite_link?: string | null;
  is_primary?: boolean;
  is_revoked?: boolean;
  /** @nullable */
  member_limit?: number | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  pending_join_request_count?: number | null;
  /** @nullable */
  subscription_period?: number | null;
  /** @nullable */
  subscription_price?: number | null;
}

export interface ChatMemberUpdated {
  chat?: Chat;
  date?: string;
  from?: User;
  invite_link?: ChatInviteLink;
  new_chat_member?: ChatMember;
  old_chat_member?: ChatMember;
  via_chat_folder_invite_link?: boolean;
  via_join_request?: boolean;
}

export interface ChatBoostUpdated {
  boost?: ChatBoost;
  chat?: Chat;
}

export type ChatBoostSourceType = typeof ChatBoostSourceType[keyof typeof ChatBoostSourceType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChatBoostSourceType = {
  premium: 'premium',
  giftCode: 'giftCode',
  giveaway: 'giveaway',
} as const;

export interface ChatBoostSource {
  source?: ChatBoostSourceType;
}

export interface ChatBoostRemoved {
  /** @nullable */
  boost_id?: string | null;
  chat?: Chat;
  remove_date?: string;
  source?: ChatBoostSource;
}

export interface ChatBoostAdded {
  boost_count?: number;
}

export interface ChatBoost {
  add_date?: string;
  /** @nullable */
  boost_id?: string | null;
  expiration_date?: string;
  source?: ChatBoostSource;
}

export interface ChatBackground {
  type?: BackgroundType;
}

export interface Chat {
  /** @nullable */
  first_name?: string | null;
  id?: number;
  is_direct_messages?: boolean;
  is_forum?: boolean;
  /** @nullable */
  last_name?: string | null;
  /** @nullable */
  title?: string | null;
  type?: ChatType;
  /** @nullable */
  username?: string | null;
}

export interface ChatJoinRequest {
  /** @nullable */
  bio?: string | null;
  chat?: Chat;
  date?: string;
  from?: User;
  invite_link?: ChatInviteLink;
  user_chat_id?: number;
}

export interface Channels {
  email?: boolean;
  push?: boolean;
  telegram?: boolean;
}

export interface ChangeTariffResponse {
  amountDue?: number;
  effectiveDate?: string;
  newPeriodEnd?: string;
  /** @nullable */
  paymentId?: string | null;
  requiresPayment?: boolean;
  tariffChangeId?: string;
}

export interface ChangeTariffRequest {
  durationMonths?: number;
  newTariffId?: string;
  /** @nullable */
  promoCode?: string | null;
}

export interface ChangeRoleRequest {
  roleId?: string;
}

export interface ChangePasswordValidationErrorsResponse {
  /** @nullable */
  errors?: ValidationError[] | null;
}

export interface ChangePasswordRequest {
  /** @minLength 1 */
  confirmPassword: string;
  /** @minLength 1 */
  currentPassword: string;
  /** @minLength 8 */
  newPassword: string;
  signOutEverywhere?: boolean;
}

export interface CategoryIndicator {
  /** @nullable */
  note?: string | null;
  /** @nullable */
  status?: string | null;
}

export interface CallbackQuery {
  /** @nullable */
  chat_instance?: string | null;
  /** @nullable */
  data?: string | null;
  from?: User;
  /** @nullable */
  game_short_name?: string | null;
  /** @nullable */
  id?: string | null;
  /** @nullable */
  inline_message_id?: string | null;
  message?: Message;
}

export interface CallbackGame { [key: string]: unknown }

export interface CalculateTariffChangeResponse {
  amountDue?: number;
  /** @nullable */
  discount?: number | null;
  finalAmount?: number;
  newPeriodAmount?: number;
  newPeriodEnd?: string;
  prorationCredit?: number;
  remainingDays?: number;
}

export interface CalculateTariffChangeRequest {
  durationMonths?: number;
  newTariffId?: string;
  /** @nullable */
  promoCode?: string | null;
}

export interface BusinessMessagesDeleted {
  /** @nullable */
  business_connection_id?: string | null;
  chat?: Chat;
  /** @nullable */
  message_ids?: number[] | null;
}

export interface BusinessBotRights {
  can_change_gift_settings?: boolean;
  can_convert_gifts_to_stars?: boolean;
  can_delete_all_messages?: boolean;
  can_delete_sent_messages?: boolean;
  can_edit_bio?: boolean;
  can_edit_name?: boolean;
  can_edit_profile_photo?: boolean;
  can_edit_username?: boolean;
  can_manage_stories?: boolean;
  can_read_messages?: boolean;
  can_reply?: boolean;
  can_transfer_and_upgrade_gifts?: boolean;
  can_transfer_stars?: boolean;
  can_view_gifts_and_stars?: boolean;
}

export interface BusinessConnection {
  date?: string;
  /** @nullable */
  id?: string | null;
  is_enabled?: boolean;
  rights?: BusinessBotRights;
  user?: User;
  user_chat_id?: number;
}

export interface BulkUpsertKktuRequest {
  /** @nullable */
  items?: KktuItemDto[] | null;
}

export interface BulkDeleteResponse {
  deleted?: number;
  ok?: boolean;
}

export interface BulkDeleteRequest {
  /** @nullable */
  ids?: string[] | null;
}

export interface BroadcastResult {
  failed?: number;
  sent?: number;
  total?: number;
}

export interface BroadcastRequest {
  /** @nullable */
  text?: string | null;
}

export interface BroadcastNotificationResponse {
  dryRun?: boolean;
  failedCount?: number;
  sentCount?: number;
  totalTargeted?: number;
}

export interface BroadcastNotificationRequest {
  /** @nullable */
  accountId?: string | null;
  confirmBroadcastAll?: boolean;
  dryRun?: boolean;
  /** @nullable */
  kind?: string | null;
  /** @nullable */
  message?: string | null;
  sendExternal?: boolean;
  /** @nullable */
  title?: string | null;
  /** @nullable */
  userIds?: string[] | null;
}

export interface BroadcastEmailResponse {
  errors?: number;
  sent?: number;
  skippedNoEmail?: number;
  targetUsers?: number;
}

export interface BroadcastEmailRequest {
  /** @nullable */
  accountId?: string | null;
  /** @nullable */
  bodyHtml?: string | null;
  /** @nullable */
  bodyText?: string | null;
  /** @nullable */
  emails?: string[] | null;
  /** @nullable */
  subject?: string | null;
  /** @nullable */
  userIds?: string[] | null;
}

export interface BlogTagDto {
  id?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
}

/**
 * @nullable
 */
export type BlogMediaPresignResponseUploadHeaders = {[key: string]: string} | null;

export interface BlogMediaPresignResponse {
  /** @nullable */
  objectKey?: string | null;
  /** @nullable */
  publicUrl?: string | null;
  /** @nullable */
  uploadHeaders?: BlogMediaPresignResponseUploadHeaders;
  /** @nullable */
  uploadUrl?: string | null;
}

export interface BlogMediaPresignRequest {
  /** @nullable */
  contentType?: string | null;
  /** @nullable */
  kind?: string | null;
}

export interface BlogCategoryShortDto {
  id?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
}

export interface BlogCategoryDto {
  articleCount?: number;
  createdAt?: string;
  /** @nullable */
  description?: string | null;
  id?: string;
  isHidden?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
  sortOrder?: number;
  updatedAt?: string;
}

export interface BlogAuthorShortDto {
  /** @nullable */
  avatarUrl?: string | null;
  id?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  title?: string | null;
}

export interface BlogAuthorDto {
  articleCount?: number;
  /** @nullable */
  avatarUrl?: string | null;
  /** @nullable */
  bio?: string | null;
  createdAt?: string;
  id?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  title?: string | null;
  updatedAt?: string;
}

export interface BlogArticleListItemDto {
  author?: BlogAuthorShortDto;
  category?: BlogCategoryShortDto;
  /** @nullable */
  coverImageAlt?: string | null;
  /** @nullable */
  coverImageUrl?: string | null;
  /** @nullable */
  excerpt?: string | null;
  id?: string;
  isFeatured?: boolean;
  /** @nullable */
  publishedAt?: string | null;
  readTimeMinutes?: number;
  showAuthor?: boolean;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  tags?: BlogTagDto[] | null;
  /** @nullable */
  title?: string | null;
  updatedAt?: string;
}

export interface BlogArticleListResponse {
  /** @nullable */
  items?: BlogArticleListItemDto[] | null;
  page?: number;
  pageSize?: number;
  total?: number;
}

export interface BlogArticleDto {
  author?: BlogAuthorShortDto;
  category?: BlogCategoryShortDto;
  /** @nullable */
  contentHtml?: string | null;
  /** @nullable */
  contentJson?: string | null;
  /** @nullable */
  coverImageAlt?: string | null;
  /** @nullable */
  coverImageUrl?: string | null;
  createdAt?: string;
  /** @nullable */
  excerpt?: string | null;
  id?: string;
  isFeatured?: boolean;
  /** @nullable */
  previewToken?: string | null;
  /** @nullable */
  publishedAt?: string | null;
  readTimeMinutes?: number;
  /** @nullable */
  scheduledAt?: string | null;
  /** @nullable */
  seoDescription?: string | null;
  /** @nullable */
  seoTitle?: string | null;
  showAuthor?: boolean;
  /** @nullable */
  slug?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  tags?: BlogTagDto[] | null;
  /** @nullable */
  title?: string | null;
  updatedAt?: string;
}

export interface BitrateDetails {
  audio?: number;
  video?: number;
}

export interface BatchErirStatusItem {
  /** @nullable */
  dataType?: string | null;
  /** @nullable */
  erirStatus?: string | null;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  finalizedTs?: string | null;
  /** @nullable */
  messages?: string[] | null;
  /** @nullable */
  updatedByUserTs?: string | null;
}

export interface BatchErirStatusResult {
  /** @nullable */
  items?: BatchErirStatusItem[] | null;
  totalItemsCount?: number;
}

export interface BatchDeleteActsRequest {
  /** @nullable */
  externalIds?: string[] | null;
}

export type BackgroundTypeKind = typeof BackgroundTypeKind[keyof typeof BackgroundTypeKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BackgroundTypeKind = {
  fill: 'fill',
  wallpaper: 'wallpaper',
  pattern: 'pattern',
  chatTheme: 'chatTheme',
} as const;

export interface BackgroundType {
  type?: BackgroundTypeKind;
}

export interface AuditLogItem {
  /** @nullable */
  action?: string | null;
  createdAt?: string;
  durationMs?: number;
  httpCode?: number;
  id?: string;
  /** @nullable */
  ipAddress?: string | null;
  /** @nullable */
  metaJson?: string | null;
  /** @nullable */
  resourceHref?: string | null;
  /** @nullable */
  resourceId?: string | null;
  /** @nullable */
  resourceLabel?: string | null;
  /** @nullable */
  route?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  userAgent?: string | null;
  /** @nullable */
  userDisplayName?: string | null;
  /** @nullable */
  userEmail?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface AuditLogPage {
  /** @nullable */
  items?: AuditLogItem[] | null;
  /** @nullable */
  nextCursor?: string | null;
}

export interface AudioDetails {
  bitrate?: number;
  channels?: number;
  /** @nullable */
  codec?: string | null;
  sampleRate?: number;
}

export interface Audio {
  duration?: number;
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_name?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
  /** @nullable */
  mime_type?: string | null;
  /** @nullable */
  performer?: string | null;
  thumbnail?: PhotoSize;
  /** @nullable */
  title?: string | null;
}

export interface AssignTariffRequest {
  /** @nullable */
  durationDays?: number | null;
  /** @nullable */
  expiresAt?: string | null;
  /** @nullable */
  reason?: string | null;
  tariffId?: string;
}

export interface AssignPlacementPeriodRequest {
  endDateMs?: number;
  /** @nullable */
  erid?: string | null;
  startDateMs?: number;
}

export interface AssignPadsRequest {
  /** @minLength 1 */
  erid: string;
  /** @minItems 1 */
  padIds: string[];
}

export interface AssignPadRequest {
  /** @minLength 1 */
  erid: string;
  padId: string;
}

/**
 * @nullable
 */
export type ArchiveSubmitRequestMeta = {[key: string]: unknown} | null;

export type ArchiveSubmitRequestMessagesItem = {[key: string]: unknown};

export interface ArchiveSubmitRequest {
  /** @nullable */
  messages?: ArchiveSubmitRequestMessagesItem[] | null;
  /** @nullable */
  meta?: ArchiveSubmitRequestMeta;
  /** @nullable */
  type?: string | null;
}

export interface ArchiveAccountResponse {
  /** @nullable */
  defaultAccountId?: string | null;
  ok?: boolean;
}

export interface Animation {
  duration?: number;
  /** @nullable */
  file_id?: string | null;
  /** @nullable */
  file_name?: string | null;
  /** @nullable */
  file_size?: number | null;
  /** @nullable */
  file_unique_id?: string | null;
  height?: number;
  /** @nullable */
  mime_type?: string | null;
  thumbnail?: PhotoSize;
  width?: number;
}

/**
 * @nullable
 */
export type AnalysisListItemId = unknown | null;

export interface AnalysisListItem {
  /** @nullable */
  authorName?: string | null;
  /** @nullable */
  confidence?: number | null;
  createdAt?: number;
  /** @nullable */
  demoErid?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  id?: AnalysisListItemId;
  /** @nullable */
  isAd?: boolean | null;
  /** @nullable */
  labelingReceived?: boolean | null;
  /** @nullable */
  labelingReceivedAt?: number | null;
  /** @nullable */
  requiresLabeling?: boolean | null;
  /** @nullable */
  source?: string | null;
  /** @nullable */
  workflowName?: string | null;
}

export interface AnalysisListResponse {
  /** @nullable */
  items?: AnalysisListItem[] | null;
}

/**
 * @nullable
 */
export type AnalysisDetailResponseReasons = unknown | null;

/**
 * @nullable
 */
export type AnalysisDetailResponseLabelEditor = unknown | null;

/**
 * @nullable
 */
export type AnalysisDetailResponseImages = unknown | null;

/**
 * @nullable
 */
export type AnalysisDetailResponseCitations = unknown | null;

export interface AnalysisDetailResponse {
  /** @nullable */
  authorId?: string | null;
  /** @nullable */
  authorName?: string | null;
  /** @nullable */
  authorType?: string | null;
  /** @nullable */
  citations?: AnalysisDetailResponseCitations;
  /** @nullable */
  comment?: string | null;
  /** @nullable */
  confidence?: number | null;
  createdAt?: number;
  /** @nullable */
  demoErid?: string | null;
  /** @nullable */
  erid?: string | null;
  /** @nullable */
  eridCreatedAt?: number | null;
  id?: string;
  /** @nullable */
  images?: AnalysisDetailResponseImages;
  /** @nullable */
  inputText?: string | null;
  /** @nullable */
  isAd?: boolean | null;
  /** @nullable */
  labelEditor?: AnalysisDetailResponseLabelEditor;
  /** @nullable */
  labelingReceived?: boolean | null;
  /** @nullable */
  labelingReceivedAt?: number | null;
  /** @nullable */
  rawResponse?: string | null;
  /** @nullable */
  reasons?: AnalysisDetailResponseReasons;
  /** @nullable */
  requiresLabeling?: boolean | null;
  /** @nullable */
  webhookUrl?: string | null;
  /** @nullable */
  workflowName?: string | null;
}

export interface AllocateToContractRequest {
  /** @nullable */
  amount?: string | null;
  /** @nullable */
  amountWithoutVat?: string | null;
  autoCalculate?: boolean;
  /** @nullable */
  contractExternalId?: string | null;
  /** @nullable */
  creativeExternalIds?: string[] | null;
  /** @nullable */
  creatives?: CreativeAllocationRequest[] | null;
  isSocial?: boolean;
  isSocialQuota?: boolean;
  /** @nullable */
  vatAmount?: string | null;
  /** @nullable */
  vatRate?: string | null;
}

export interface AdminUserMembershipDto {
  accountId?: string;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  organizationId?: string | null;
  /** @nullable */
  ownerUserId?: string | null;
  roleId?: string;
  /** @nullable */
  teamName?: string | null;
}

export interface AdminTeamMemberDto {
  /** @nullable */
  email?: string | null;
  isOwner?: boolean;
  /** @nullable */
  joinedAt?: string | null;
  /** @nullable */
  lastAccessedAt?: string | null;
  ownTariff?: UserTariffSnapshot;
  /** @nullable */
  roleName?: string | null;
  /** @nullable */
  roleSystemKind?: string | null;
  /** @nullable */
  userId?: string | null;
}

export interface AdminTeamDto {
  accountId?: string;
  createdAt?: string;
  effectiveTariff?: UserTariffSnapshot;
  /** @nullable */
  members?: AdminTeamMemberDto[] | null;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  organizationId?: string | null;
  /** @nullable */
  ownerEmail?: string | null;
  /** @nullable */
  ownerUserId?: string | null;
  /** @nullable */
  teamName?: string | null;
}

export interface AdminTeamsPage {
  /** @nullable */
  items?: AdminTeamDto[] | null;
  page?: number;
  size?: number;
  total?: number;
}

export interface AdminTariffDto {
  /** @nullable */
  archivedAt?: string | null;
  /** @nullable */
  capabilitiesJson?: string | null;
  /** @nullable */
  code?: string | null;
  createdAt?: string;
  /** @nullable */
  defaultDurationDays?: number | null;
  /** @nullable */
  description?: string | null;
  displayOrder?: number;
  id?: string;
  isActive?: boolean;
  isRecommended?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  oldPricePerMonthRub?: number | null;
  /** @nullable */
  previousVersionId?: string | null;
  /** @nullable */
  price12MonthsRub?: number | null;
  /** @nullable */
  price3MonthsRub?: number | null;
  pricePerMonthRub?: number;
  /** @nullable */
  publishedAt?: string | null;
  /** @nullable */
  status?: string | null;
  updatedAt?: string;
  version?: number;
}

export interface AdminJobsTriggerResponse {
  /** @nullable */
  jobId: string | null;
  /** @nullable */
  jobName: string | null;
  /** @nullable */
  message: string | null;
}

export interface AddressCorrectResponse {
  /** @nullable */
  address?: string | null;
}

export interface AddendumUpdateRequest {
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  number?: string | null;
}

export interface AddendumDto {
  /** @nullable */
  amount?: number | null;
  contractId?: string;
  createdAt?: string;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  externalId?: string | null;
  id?: string;
  /** @nullable */
  number?: string | null;
}

export interface AddendumsListResponse {
  /** @nullable */
  items?: AddendumDto[] | null;
}

export interface AddendumCreateRequest {
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  externalId?: string | null;
  /** @nullable */
  number?: string | null;
}

export interface ActivateTrialResponse {
  /** @nullable */
  message?: string | null;
  subscriptionId?: string;
  /** @nullable */
  tariffName?: string | null;
  trialEndsAt?: string;
}

export interface ActivateTrialRequest {
  /** @nullable */
  referralCode?: string | null;
  /** @nullable */
  trialDays?: number | null;
}

export interface ActivatePartnerRequest {
  /** @nullable */
  consentVersion?: string | null;
}

export interface ActLinkRequest {
  /** @nullable */
  erid?: string | null;
  sourceActLogId?: string;
}

export interface ActCreateRequest {
  /** @nullable */
  agentFee?: number | null;
  /** @nullable */
  amount?: number | null;
  /** @nullable */
  contractExternalId?: string | null;
  contractType?: ContractType;
  creativeId?: string;
  /** @nullable */
  date?: string | null;
  /** @nullable */
  initialContractExternalId?: string | null;
  /** @nullable */
  invoiceExternalId?: string | null;
  /** @nullable */
  number?: string | null;
  /** @nullable */
  vatRate?: string | null;
}

export interface AccountItemDto {
  /** @nullable */
  createdAt?: number | null;
  id?: string;
  isPrimary?: boolean;
  /** @nullable */
  name?: string | null;
  /** @nullable */
  ownerEmail?: string | null;
  /** @nullable */
  ownerUserId?: string | null;
  /** @nullable */
  role?: string | null;
  /** @nullable */
  status?: string | null;
  /** @nullable */
  teamName?: string | null;
}

export interface AccountsListResponse {
  /** @nullable */
  defaultAccountId?: string | null;
  /** @nullable */
  items?: AccountItemDto[] | null;
}

export interface AcceptInvitationResult {
  accountId?: string;
  /** @nullable */
  accountName?: string | null;
  roleId?: string;
  /** @nullable */
  roleName?: string | null;
}



export type getApiV1ProfileTariffResponse = {
  data: ProfileTariffResponse;
  status: number;
}

export const getGetApiV1ProfileTariffUrl = () => {


  return `/api/v1/profile/tariff`
}

export const getApiV1ProfileTariff = async ( options?: RequestInit): Promise<getApiV1ProfileTariffResponse> => {
return customFetch<Promise<getApiV1ProfileTariffResponse>>(getGetApiV1ProfileTariffUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AccountChangePasswordResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AccountChangePasswordUrl = () => {


  return `/api/v1/account/change-password`
}

export const postApiV1AccountChangePassword = async (changePasswordRequest: ChangePasswordRequest, options?: RequestInit): Promise<postApiV1AccountChangePasswordResponse> => {
return customFetch<Promise<postApiV1AccountChangePasswordResponse>>(getPostApiV1AccountChangePasswordUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      changePasswordRequest,)
  }
);}


export type adminListNewsResponse = {
  data: News[];
  status: number;
}

export const getAdminListNewsUrl = (params?: AdminListNewsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/news?${normalizedParams.toString()}`
}

export const adminListNews = async (params?: AdminListNewsParams, options?: RequestInit): Promise<adminListNewsResponse> => {
return customFetch<Promise<adminListNewsResponse>>(getAdminListNewsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type createNewsResponse = {
  data: News;
  status: number;
}

export const getCreateNewsUrl = () => {


  return `/api/v1/admin/news`
}

export const createNews = async (createNewsRequest: CreateNewsRequest, options?: RequestInit): Promise<createNewsResponse> => {
return customFetch<Promise<createNewsResponse>>(getCreateNewsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createNewsRequest,)
  }
);}


export type adminGetNewsByIdResponse = {
  data: News;
  status: number;
}

export const getAdminGetNewsByIdUrl = (newsId: string,) => {


  return `/api/v1/admin/news/${newsId}`
}

export const adminGetNewsById = async (newsId: string, options?: RequestInit): Promise<adminGetNewsByIdResponse> => {
return customFetch<Promise<adminGetNewsByIdResponse>>(getAdminGetNewsByIdUrl(newsId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type updateNewsResponse = {
  data: News;
  status: number;
}

export const getUpdateNewsUrl = (newsId: string,) => {


  return `/api/v1/admin/news/${newsId}`
}

export const updateNews = async (newsId: string,
    updateNewsRequest: UpdateNewsRequest, options?: RequestInit): Promise<updateNewsResponse> => {
return customFetch<Promise<updateNewsResponse>>(getUpdateNewsUrl(newsId),
  {      
    ...options,
    method: 'PUT',
    body: JSON.stringify(
      updateNewsRequest,)
  }
);}


export type deleteNewsResponse = {
  data: void;
  status: number;
}

export const getDeleteNewsUrl = (newsId: string,) => {


  return `/api/v1/admin/news/${newsId}`
}

export const deleteNews = async (newsId: string, options?: RequestInit): Promise<deleteNewsResponse> => {
return customFetch<Promise<deleteNewsResponse>>(getDeleteNewsUrl(newsId),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type listUserAuditLogsResponse = {
  data: PaginatedAuditResponse;
  status: number;
}

export const getListUserAuditLogsUrl = (params?: ListUserAuditLogsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/audit?${normalizedParams.toString()}`
}

export const listUserAuditLogs = async (params?: ListUserAuditLogsParams, options?: RequestInit): Promise<listUserAuditLogsResponse> => {
return customFetch<Promise<listUserAuditLogsResponse>>(getListUserAuditLogsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getUserAuditLogByIdResponse = {
  data: UserAuditLog;
  status: number;
}

export const getGetUserAuditLogByIdUrl = (id: string,) => {


  return `/api/v1/admin/audit/${id}`
}

export const getUserAuditLogById = async (id: string, options?: RequestInit): Promise<getUserAuditLogByIdResponse> => {
return customFetch<Promise<getUserAuditLogByIdResponse>>(getGetUserAuditLogByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getUserActivityStatsResponse = {
  data: UserActivityStatsResponse;
  status: number;
}

export const getGetUserActivityStatsUrl = (params?: GetUserActivityStatsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/audit/activity?${normalizedParams.toString()}`
}

export const getUserActivityStats = async (params?: GetUserActivityStatsParams, options?: RequestInit): Promise<getUserActivityStatsResponse> => {
return customFetch<Promise<getUserActivityStatsResponse>>(getGetUserActivityStatsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getMonitorBotStatsResponse = {
  data: MonitorBotStatsResponse;
  status: number;
}

export const getGetMonitorBotStatsUrl = () => {


  return `/api/v1/admin/monitor-bot/stats`
}

export const getMonitorBotStats = async ( options?: RequestInit): Promise<getMonitorBotStatsResponse> => {
return customFetch<Promise<getMonitorBotStatsResponse>>(getGetMonitorBotStatsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type listMonitorBotTasksResponse = {
  data: MonitorBotTasksResponse;
  status: number;
}

export const getListMonitorBotTasksUrl = (params: ListMonitorBotTasksParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/monitor-bot/tasks?${normalizedParams.toString()}`
}

export const listMonitorBotTasks = async (params: ListMonitorBotTasksParams, options?: RequestInit): Promise<listMonitorBotTasksResponse> => {
return customFetch<Promise<listMonitorBotTasksResponse>>(getListMonitorBotTasksUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type listMonitorBotUsersResponse = {
  data: MonitorBotUsersResponse;
  status: number;
}

export const getListMonitorBotUsersUrl = (params: ListMonitorBotUsersParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/monitor-bot/users?${normalizedParams.toString()}`
}

export const listMonitorBotUsers = async (params: ListMonitorBotUsersParams, options?: RequestInit): Promise<listMonitorBotUsersResponse> => {
return customFetch<Promise<listMonitorBotUsersResponse>>(getListMonitorBotUsersUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type updateMonitorBotUserMaxTasksResponse = {
  data: void;
  status: number;
}

export const getUpdateMonitorBotUserMaxTasksUrl = (userId: string,) => {


  return `/api/v1/admin/monitor-bot/users/${userId}/max-tasks`
}

export const updateMonitorBotUserMaxTasks = async (userId: string,
    updateMaxTasksRequest: UpdateMaxTasksRequest, options?: RequestInit): Promise<updateMonitorBotUserMaxTasksResponse> => {
return customFetch<Promise<updateMonitorBotUserMaxTasksResponse>>(getUpdateMonitorBotUserMaxTasksUrl(userId),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      updateMaxTasksRequest,)
  }
);}


export type broadcastMonitorBotMessageResponse = {
  data: BroadcastResult;
  status: number;
}

export const getBroadcastMonitorBotMessageUrl = () => {


  return `/api/v1/admin/monitor-bot/broadcast`
}

export const broadcastMonitorBotMessage = async (broadcastRequest: BroadcastRequest, options?: RequestInit): Promise<broadcastMonitorBotMessageResponse> => {
return customFetch<Promise<broadcastMonitorBotMessageResponse>>(getBroadcastMonitorBotMessageUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      broadcastRequest,)
  }
);}


export type getApiV1AdminBlogArticlesResponse = {
  data: BlogArticleListResponse;
  status: number;
}

export const getGetApiV1AdminBlogArticlesUrl = (params?: GetApiV1AdminBlogArticlesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/blog/articles?${normalizedParams.toString()}`
}

export const getApiV1AdminBlogArticles = async (params?: GetApiV1AdminBlogArticlesParams, options?: RequestInit): Promise<getApiV1AdminBlogArticlesResponse> => {
return customFetch<Promise<getApiV1AdminBlogArticlesResponse>>(getGetApiV1AdminBlogArticlesUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminBlogArticlesResponse = {
  data: BlogArticleDto;
  status: number;
}

export const getPostApiV1AdminBlogArticlesUrl = () => {


  return `/api/v1/admin/blog/articles`
}

export const postApiV1AdminBlogArticles = async (createBlogArticleRequest: CreateBlogArticleRequest, options?: RequestInit): Promise<postApiV1AdminBlogArticlesResponse> => {
return customFetch<Promise<postApiV1AdminBlogArticlesResponse>>(getPostApiV1AdminBlogArticlesUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createBlogArticleRequest,)
  }
);}


export type getApiV1AdminBlogArticlesIdResponse = {
  data: BlogArticleDto;
  status: number;
}

export const getGetApiV1AdminBlogArticlesIdUrl = (id: string,) => {


  return `/api/v1/admin/blog/articles/${id}`
}

export const getApiV1AdminBlogArticlesId = async (id: string, options?: RequestInit): Promise<getApiV1AdminBlogArticlesIdResponse> => {
return customFetch<Promise<getApiV1AdminBlogArticlesIdResponse>>(getGetApiV1AdminBlogArticlesIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type patchApiV1AdminBlogArticlesIdResponse = {
  data: BlogArticleDto;
  status: number;
}

export const getPatchApiV1AdminBlogArticlesIdUrl = (id: string,) => {


  return `/api/v1/admin/blog/articles/${id}`
}

export const patchApiV1AdminBlogArticlesId = async (id: string,
    updateBlogArticleRequest: UpdateBlogArticleRequest, options?: RequestInit): Promise<patchApiV1AdminBlogArticlesIdResponse> => {
return customFetch<Promise<patchApiV1AdminBlogArticlesIdResponse>>(getPatchApiV1AdminBlogArticlesIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      updateBlogArticleRequest,)
  }
);}


export type deleteApiV1AdminBlogArticlesIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1AdminBlogArticlesIdUrl = (id: string,) => {


  return `/api/v1/admin/blog/articles/${id}`
}

export const deleteApiV1AdminBlogArticlesId = async (id: string, options?: RequestInit): Promise<deleteApiV1AdminBlogArticlesIdResponse> => {
return customFetch<Promise<deleteApiV1AdminBlogArticlesIdResponse>>(getDeleteApiV1AdminBlogArticlesIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type postApiV1AdminBlogArticlesIdPublishResponse = {
  data: BlogArticleDto;
  status: number;
}

export const getPostApiV1AdminBlogArticlesIdPublishUrl = (id: string,) => {


  return `/api/v1/admin/blog/articles/${id}/publish`
}

export const postApiV1AdminBlogArticlesIdPublish = async (id: string, options?: RequestInit): Promise<postApiV1AdminBlogArticlesIdPublishResponse> => {
return customFetch<Promise<postApiV1AdminBlogArticlesIdPublishResponse>>(getPostApiV1AdminBlogArticlesIdPublishUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1AdminBlogArticlesIdUnpublishResponse = {
  data: BlogArticleDto;
  status: number;
}

export const getPostApiV1AdminBlogArticlesIdUnpublishUrl = (id: string,) => {


  return `/api/v1/admin/blog/articles/${id}/unpublish`
}

export const postApiV1AdminBlogArticlesIdUnpublish = async (id: string, options?: RequestInit): Promise<postApiV1AdminBlogArticlesIdUnpublishResponse> => {
return customFetch<Promise<postApiV1AdminBlogArticlesIdUnpublishResponse>>(getPostApiV1AdminBlogArticlesIdUnpublishUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1AdminBlogArticlesIdRotatePreviewTokenResponse = {
  data: BlogArticleDto;
  status: number;
}

export const getPostApiV1AdminBlogArticlesIdRotatePreviewTokenUrl = (id: string,) => {


  return `/api/v1/admin/blog/articles/${id}/rotate-preview-token`
}

export const postApiV1AdminBlogArticlesIdRotatePreviewToken = async (id: string, options?: RequestInit): Promise<postApiV1AdminBlogArticlesIdRotatePreviewTokenResponse> => {
return customFetch<Promise<postApiV1AdminBlogArticlesIdRotatePreviewTokenResponse>>(getPostApiV1AdminBlogArticlesIdRotatePreviewTokenUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getApiV1AdminBlogAuthorsResponse = {
  data: BlogAuthorDto[];
  status: number;
}

export const getGetApiV1AdminBlogAuthorsUrl = () => {


  return `/api/v1/admin/blog/authors`
}

export const getApiV1AdminBlogAuthors = async ( options?: RequestInit): Promise<getApiV1AdminBlogAuthorsResponse> => {
return customFetch<Promise<getApiV1AdminBlogAuthorsResponse>>(getGetApiV1AdminBlogAuthorsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminBlogAuthorsResponse = {
  data: BlogAuthorDto;
  status: number;
}

export const getPostApiV1AdminBlogAuthorsUrl = () => {


  return `/api/v1/admin/blog/authors`
}

export const postApiV1AdminBlogAuthors = async (createBlogAuthorRequest: CreateBlogAuthorRequest, options?: RequestInit): Promise<postApiV1AdminBlogAuthorsResponse> => {
return customFetch<Promise<postApiV1AdminBlogAuthorsResponse>>(getPostApiV1AdminBlogAuthorsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createBlogAuthorRequest,)
  }
);}


export type patchApiV1AdminBlogAuthorsIdResponse = {
  data: BlogAuthorDto;
  status: number;
}

export const getPatchApiV1AdminBlogAuthorsIdUrl = (id: string,) => {


  return `/api/v1/admin/blog/authors/${id}`
}

export const patchApiV1AdminBlogAuthorsId = async (id: string,
    updateBlogAuthorRequest: UpdateBlogAuthorRequest, options?: RequestInit): Promise<patchApiV1AdminBlogAuthorsIdResponse> => {
return customFetch<Promise<patchApiV1AdminBlogAuthorsIdResponse>>(getPatchApiV1AdminBlogAuthorsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      updateBlogAuthorRequest,)
  }
);}


export type deleteApiV1AdminBlogAuthorsIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1AdminBlogAuthorsIdUrl = (id: string,) => {


  return `/api/v1/admin/blog/authors/${id}`
}

export const deleteApiV1AdminBlogAuthorsId = async (id: string, options?: RequestInit): Promise<deleteApiV1AdminBlogAuthorsIdResponse> => {
return customFetch<Promise<deleteApiV1AdminBlogAuthorsIdResponse>>(getDeleteApiV1AdminBlogAuthorsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1AdminBlogCategoriesResponse = {
  data: BlogCategoryDto[];
  status: number;
}

export const getGetApiV1AdminBlogCategoriesUrl = () => {


  return `/api/v1/admin/blog/categories`
}

export const getApiV1AdminBlogCategories = async ( options?: RequestInit): Promise<getApiV1AdminBlogCategoriesResponse> => {
return customFetch<Promise<getApiV1AdminBlogCategoriesResponse>>(getGetApiV1AdminBlogCategoriesUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminBlogCategoriesResponse = {
  data: BlogCategoryDto;
  status: number;
}

export const getPostApiV1AdminBlogCategoriesUrl = () => {


  return `/api/v1/admin/blog/categories`
}

export const postApiV1AdminBlogCategories = async (createBlogCategoryRequest: CreateBlogCategoryRequest, options?: RequestInit): Promise<postApiV1AdminBlogCategoriesResponse> => {
return customFetch<Promise<postApiV1AdminBlogCategoriesResponse>>(getPostApiV1AdminBlogCategoriesUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createBlogCategoryRequest,)
  }
);}


export type patchApiV1AdminBlogCategoriesIdResponse = {
  data: BlogCategoryDto;
  status: number;
}

export const getPatchApiV1AdminBlogCategoriesIdUrl = (id: string,) => {


  return `/api/v1/admin/blog/categories/${id}`
}

export const patchApiV1AdminBlogCategoriesId = async (id: string,
    updateBlogCategoryRequest: UpdateBlogCategoryRequest, options?: RequestInit): Promise<patchApiV1AdminBlogCategoriesIdResponse> => {
return customFetch<Promise<patchApiV1AdminBlogCategoriesIdResponse>>(getPatchApiV1AdminBlogCategoriesIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      updateBlogCategoryRequest,)
  }
);}


export type deleteApiV1AdminBlogCategoriesIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1AdminBlogCategoriesIdUrl = (id: string,) => {


  return `/api/v1/admin/blog/categories/${id}`
}

export const deleteApiV1AdminBlogCategoriesId = async (id: string, options?: RequestInit): Promise<deleteApiV1AdminBlogCategoriesIdResponse> => {
return customFetch<Promise<deleteApiV1AdminBlogCategoriesIdResponse>>(getDeleteApiV1AdminBlogCategoriesIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type postApiV1AdminBlogMediaPresignUploadResponse = {
  data: BlogMediaPresignResponse;
  status: number;
}

export const getPostApiV1AdminBlogMediaPresignUploadUrl = () => {


  return `/api/v1/admin/blog/media/presign-upload`
}

export const postApiV1AdminBlogMediaPresignUpload = async (blogMediaPresignRequest: BlogMediaPresignRequest, options?: RequestInit): Promise<postApiV1AdminBlogMediaPresignUploadResponse> => {
return customFetch<Promise<postApiV1AdminBlogMediaPresignUploadResponse>>(getPostApiV1AdminBlogMediaPresignUploadUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      blogMediaPresignRequest,)
  }
);}


export type getApiV1AdminBlogTagsResponse = {
  data: BlogTagDto[];
  status: number;
}

export const getGetApiV1AdminBlogTagsUrl = () => {


  return `/api/v1/admin/blog/tags`
}

export const getApiV1AdminBlogTags = async ( options?: RequestInit): Promise<getApiV1AdminBlogTagsResponse> => {
return customFetch<Promise<getApiV1AdminBlogTagsResponse>>(getGetApiV1AdminBlogTagsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminBlogTagsResponse = {
  data: BlogTagDto;
  status: number;
}

export const getPostApiV1AdminBlogTagsUrl = () => {


  return `/api/v1/admin/blog/tags`
}

export const postApiV1AdminBlogTags = async (createBlogTagRequest: CreateBlogTagRequest, options?: RequestInit): Promise<postApiV1AdminBlogTagsResponse> => {
return customFetch<Promise<postApiV1AdminBlogTagsResponse>>(getPostApiV1AdminBlogTagsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createBlogTagRequest,)
  }
);}


export type patchApiV1AdminBlogTagsIdResponse = {
  data: BlogTagDto;
  status: number;
}

export const getPatchApiV1AdminBlogTagsIdUrl = (id: string,) => {


  return `/api/v1/admin/blog/tags/${id}`
}

export const patchApiV1AdminBlogTagsId = async (id: string,
    updateBlogTagRequest: UpdateBlogTagRequest, options?: RequestInit): Promise<patchApiV1AdminBlogTagsIdResponse> => {
return customFetch<Promise<patchApiV1AdminBlogTagsIdResponse>>(getPatchApiV1AdminBlogTagsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      updateBlogTagRequest,)
  }
);}


export type deleteApiV1AdminBlogTagsIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1AdminBlogTagsIdUrl = (id: string,) => {


  return `/api/v1/admin/blog/tags/${id}`
}

export const deleteApiV1AdminBlogTagsId = async (id: string, options?: RequestInit): Promise<deleteApiV1AdminBlogTagsIdResponse> => {
return customFetch<Promise<deleteApiV1AdminBlogTagsIdResponse>>(getDeleteApiV1AdminBlogTagsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type adminEmailBroadcastResponse = {
  data: BroadcastEmailResponse;
  status: number;
}

export const getAdminEmailBroadcastUrl = () => {


  return `/api/v1/admin/email/broadcast`
}

export const adminEmailBroadcast = async (broadcastEmailRequest: BroadcastEmailRequest, options?: RequestInit): Promise<adminEmailBroadcastResponse> => {
return customFetch<Promise<adminEmailBroadcastResponse>>(getAdminEmailBroadcastUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      broadcastEmailRequest,)
  }
);}


export type triggerJobResponse = {
  data: AdminJobsTriggerResponse;
  status: number;
}

export const getTriggerJobUrl = (jobName: string,) => {


  return `/api/v1/admin/jobs/trigger/${jobName}`
}

export const triggerJob = async (jobName: string, options?: RequestInit): Promise<triggerJobResponse> => {
return customFetch<Promise<triggerJobResponse>>(getTriggerJobUrl(jobName),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getRecurringJobsResponse = {
  data: RecurringJobInfo[];
  status: number;
}

export const getGetRecurringJobsUrl = () => {


  return `/api/v1/admin/jobs/recurring`
}

export const getRecurringJobs = async ( options?: RequestInit): Promise<getRecurringJobsResponse> => {
return customFetch<Promise<getRecurringJobsResponse>>(getGetRecurringJobsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type rebuildCommissionForPaymentResponse = {
  data: RebuildCommissionResponse;
  status: number;
}

export const getRebuildCommissionForPaymentUrl = (paymentId: string,) => {


  return `/api/v1/admin/jobs/partners/rebuild-commission/${paymentId}`
}

export const rebuildCommissionForPayment = async (paymentId: string, options?: RequestInit): Promise<rebuildCommissionForPaymentResponse> => {
return customFetch<Promise<rebuildCommissionForPaymentResponse>>(getRebuildCommissionForPaymentUrl(paymentId),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type adminNotificationsBroadcastResponse = {
  data: BroadcastNotificationResponse;
  status: number;
}

export const getAdminNotificationsBroadcastUrl = () => {


  return `/api/v1/admin/notifications/broadcast`
}

export const adminNotificationsBroadcast = async (broadcastNotificationRequest: BroadcastNotificationRequest, options?: RequestInit): Promise<adminNotificationsBroadcastResponse> => {
return customFetch<Promise<adminNotificationsBroadcastResponse>>(getAdminNotificationsBroadcastUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      broadcastNotificationRequest,)
  }
);}


/**
 * Trigger posts-from-creatives sync for a specific user (admin only)
 */
export type adminSyncPostsFromCreativesResponse = {
  data: void;
  status: number;
}

export const getAdminSyncPostsFromCreativesUrl = (userId: string,
    params?: AdminSyncPostsFromCreativesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/ord/sync/posts-from-creatives/${userId}?${normalizedParams.toString()}`
}

export const adminSyncPostsFromCreatives = async (userId: string,
    params?: AdminSyncPostsFromCreativesParams, options?: RequestInit): Promise<adminSyncPostsFromCreativesResponse> => {
return customFetch<Promise<adminSyncPostsFromCreativesResponse>>(getAdminSyncPostsFromCreativesUrl(userId,params),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type setPartnerBalanceResponse = {
  data: void;
  status: number;
}

export const getSetPartnerBalanceUrl = (userId: string,) => {


  return `/api/v1/admin/partner/${userId}/balance`
}

export const setPartnerBalance = async (userId: string,
    setBalanceReq: SetBalanceReq, options?: RequestInit): Promise<setPartnerBalanceResponse> => {
return customFetch<Promise<setPartnerBalanceResponse>>(getSetPartnerBalanceUrl(userId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      setBalanceReq,)
  }
);}


export type getPartnersStatisticsResponse = {
  data: PartnerStatisticsDto[];
  status: number;
}

export const getGetPartnersStatisticsUrl = (params?: GetPartnersStatisticsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/partner/statistics?${normalizedParams.toString()}`
}

export const getPartnersStatistics = async (params?: GetPartnersStatisticsParams, options?: RequestInit): Promise<getPartnersStatisticsResponse> => {
return customFetch<Promise<getPartnersStatisticsResponse>>(getGetPartnersStatisticsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getPendingPartnerPayoutsResponse = {
  data: PendingPayoutDto[];
  status: number;
}

export const getGetPendingPartnerPayoutsUrl = (params?: GetPendingPartnerPayoutsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/partner/payouts/pending?${normalizedParams.toString()}`
}

export const getPendingPartnerPayouts = async (params?: GetPendingPartnerPayoutsParams, options?: RequestInit): Promise<getPendingPartnerPayoutsResponse> => {
return customFetch<Promise<getPendingPartnerPayoutsResponse>>(getGetPendingPartnerPayoutsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getPartnerReferralsResponse = {
  data: PartnerReferralsResponseDto;
  status: number;
}

export const getGetPartnerReferralsUrl = (partnerId: string,
    params?: GetPartnerReferralsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/partner/${partnerId}/referrals?${normalizedParams.toString()}`
}

export const getPartnerReferrals = async (partnerId: string,
    params?: GetPartnerReferralsParams, options?: RequestInit): Promise<getPartnerReferralsResponse> => {
return customFetch<Promise<getPartnerReferralsResponse>>(getGetPartnerReferralsUrl(partnerId,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type deletePartnerClientBindingResponse = {
  data: void;
  status: number;
}

export const getDeletePartnerClientBindingUrl = (bindingId: string,) => {


  return `/api/v1/admin/partner/binding/${bindingId}`
}

export const deletePartnerClientBinding = async (bindingId: string, options?: RequestInit): Promise<deletePartnerClientBindingResponse> => {
return customFetch<Promise<deletePartnerClientBindingResponse>>(getDeletePartnerClientBindingUrl(bindingId),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1AdminMarketingCodesResponse = {
  data: void;
  status: number;
}

export const getGetApiV1AdminMarketingCodesUrl = () => {


  return `/api/v1/admin/marketing-codes`
}

export const getApiV1AdminMarketingCodes = async ( options?: RequestInit): Promise<getApiV1AdminMarketingCodesResponse> => {
return customFetch<Promise<getApiV1AdminMarketingCodesResponse>>(getGetApiV1AdminMarketingCodesUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminMarketingCodesResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminMarketingCodesUrl = () => {


  return `/api/v1/admin/marketing-codes`
}

export const postApiV1AdminMarketingCodes = async (createAdminPromoCodeRequest: CreateAdminPromoCodeRequest, options?: RequestInit): Promise<postApiV1AdminMarketingCodesResponse> => {
return customFetch<Promise<postApiV1AdminMarketingCodesResponse>>(getPostApiV1AdminMarketingCodesUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createAdminPromoCodeRequest,)
  }
);}


export type deleteApiV1AdminMarketingCodesIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1AdminMarketingCodesIdUrl = (id: string,) => {


  return `/api/v1/admin/marketing-codes/${id}`
}

export const deleteApiV1AdminMarketingCodesId = async (id: string, options?: RequestInit): Promise<deleteApiV1AdminMarketingCodesIdResponse> => {
return customFetch<Promise<deleteApiV1AdminMarketingCodesIdResponse>>(getDeleteApiV1AdminMarketingCodesIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1AdminPromoPresetsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1AdminPromoPresetsUrl = (params: GetApiV1AdminPromoPresetsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/promo-presets?${normalizedParams.toString()}`
}

export const getApiV1AdminPromoPresets = async (params: GetApiV1AdminPromoPresetsParams, options?: RequestInit): Promise<getApiV1AdminPromoPresetsResponse> => {
return customFetch<Promise<getApiV1AdminPromoPresetsResponse>>(getGetApiV1AdminPromoPresetsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminPromoPresetsResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminPromoPresetsUrl = () => {


  return `/api/v1/admin/promo-presets`
}

export const postApiV1AdminPromoPresets = async (createPromoPresetRequest: CreatePromoPresetRequest, options?: RequestInit): Promise<postApiV1AdminPromoPresetsResponse> => {
return customFetch<Promise<postApiV1AdminPromoPresetsResponse>>(getPostApiV1AdminPromoPresetsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createPromoPresetRequest,)
  }
);}


export type postApiV1AdminPromoPresetsIdDeactivateResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminPromoPresetsIdDeactivateUrl = (id: string,) => {


  return `/api/v1/admin/promo-presets/${id}/deactivate`
}

export const postApiV1AdminPromoPresetsIdDeactivate = async (id: string, options?: RequestInit): Promise<postApiV1AdminPromoPresetsIdDeactivateResponse> => {
return customFetch<Promise<postApiV1AdminPromoPresetsIdDeactivateResponse>>(getPostApiV1AdminPromoPresetsIdDeactivateUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type listAllTariffsResponse = {
  data: AdminTariffDto[];
  status: number;
}

export const getListAllTariffsUrl = (params?: ListAllTariffsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/tariffs?${normalizedParams.toString()}`
}

export const listAllTariffs = async (params?: ListAllTariffsParams, options?: RequestInit): Promise<listAllTariffsResponse> => {
return customFetch<Promise<listAllTariffsResponse>>(getListAllTariffsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type createTariffResponse = {
  data: AdminTariffDto;
  status: number;
}

export const getCreateTariffUrl = () => {


  return `/api/v1/admin/tariffs`
}

export const createTariff = async (createTariffRequest: CreateTariffRequest, options?: RequestInit): Promise<createTariffResponse> => {
return customFetch<Promise<createTariffResponse>>(getCreateTariffUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createTariffRequest,)
  }
);}


export type getTariffByIdResponse = {
  data: AdminTariffDto;
  status: number;
}

export const getGetTariffByIdUrl = (id: string,) => {


  return `/api/v1/admin/tariffs/${id}`
}

export const getTariffById = async (id: string, options?: RequestInit): Promise<getTariffByIdResponse> => {
return customFetch<Promise<getTariffByIdResponse>>(getGetTariffByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type updateTariffResponse = {
  data: AdminTariffDto;
  status: number;
}

export const getUpdateTariffUrl = (id: string,) => {


  return `/api/v1/admin/tariffs/${id}`
}

export const updateTariff = async (id: string,
    updateTariffRequest: UpdateTariffRequest, options?: RequestInit): Promise<updateTariffResponse> => {
return customFetch<Promise<updateTariffResponse>>(getUpdateTariffUrl(id),
  {      
    ...options,
    method: 'PUT',
    body: JSON.stringify(
      updateTariffRequest,)
  }
);}


export type deleteTariffResponse = {
  data: void;
  status: number;
}

export const getDeleteTariffUrl = (id: string,) => {


  return `/api/v1/admin/tariffs/${id}`
}

export const deleteTariff = async (id: string, options?: RequestInit): Promise<deleteTariffResponse> => {
return customFetch<Promise<deleteTariffResponse>>(getDeleteTariffUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type publishTariffResponse = {
  data: AdminTariffDto;
  status: number;
}

export const getPublishTariffUrl = (id: string,) => {


  return `/api/v1/admin/tariffs/${id}/publish`
}

export const publishTariff = async (id: string, options?: RequestInit): Promise<publishTariffResponse> => {
return customFetch<Promise<publishTariffResponse>>(getPublishTariffUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type archiveTariffResponse = {
  data: AdminTariffDto;
  status: number;
}

export const getArchiveTariffUrl = (id: string,) => {


  return `/api/v1/admin/tariffs/${id}/archive`
}

export const archiveTariff = async (id: string, options?: RequestInit): Promise<archiveTariffResponse> => {
return customFetch<Promise<archiveTariffResponse>>(getArchiveTariffUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getAdminTeamsResponse = {
  data: AdminTeamsPage;
  status: number;
}

export const getGetAdminTeamsUrl = (params?: GetAdminTeamsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/teams?${normalizedParams.toString()}`
}

export const getAdminTeams = async (params?: GetAdminTeamsParams, options?: RequestInit): Promise<getAdminTeamsResponse> => {
return customFetch<Promise<getAdminTeamsResponse>>(getGetAdminTeamsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getUserTariffsBatchResponse = {
  data: GetUserTariffsBatch200;
  status: number;
}

export const getGetUserTariffsBatchUrl = () => {


  return `/api/v1/admin/users/tariffs/batch`
}

export const getUserTariffsBatch = async (userTariffsBatchRequest: UserTariffsBatchRequest, options?: RequestInit): Promise<getUserTariffsBatchResponse> => {
return customFetch<Promise<getUserTariffsBatchResponse>>(getGetUserTariffsBatchUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      userTariffsBatchRequest,)
  }
);}


export type assignTariffToUserResponse = {
  data: TariffAssignmentDto;
  status: number;
}

export const getAssignTariffToUserUrl = (userId: string,) => {


  return `/api/v1/admin/users/${userId}/tariff-assignments`
}

export const assignTariffToUser = async (userId: string,
    assignTariffRequest: AssignTariffRequest, options?: RequestInit): Promise<assignTariffToUserResponse> => {
return customFetch<Promise<assignTariffToUserResponse>>(getAssignTariffToUserUrl(userId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      assignTariffRequest,)
  }
);}


export type grantTrialSubscriptionResponse = {
  data: TrialGrantedDto;
  status: number;
}

export const getGrantTrialSubscriptionUrl = (userId: string,) => {


  return `/api/v1/admin/users/${userId}/grant-trial`
}

export const grantTrialSubscription = async (userId: string,
    grantTrialRequest: GrantTrialRequest, options?: RequestInit): Promise<grantTrialSubscriptionResponse> => {
return customFetch<Promise<grantTrialSubscriptionResponse>>(getGrantTrialSubscriptionUrl(userId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      grantTrialRequest,)
  }
);}


export type getAdminUserMembershipsResponse = {
  data: AdminUserMembershipDto[];
  status: number;
}

export const getGetAdminUserMembershipsUrl = (userId: string,) => {


  return `/api/v1/admin/users/${userId}/memberships`
}

export const getAdminUserMemberships = async (userId: string, options?: RequestInit): Promise<getAdminUserMembershipsResponse> => {
return customFetch<Promise<getAdminUserMembershipsResponse>>(getGetAdminUserMembershipsUrl(userId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


/**
 * Export archive records with filters (NDJSON or CSV format)
 */
export type exportArchivesResponse = {
  data: void;
  status: number;
}

export const getExportArchivesUrl = (params?: ExportArchivesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/archives/export?${normalizedParams.toString()}`
}

export const exportArchives = async (params?: ExportArchivesParams, options?: RequestInit): Promise<exportArchivesResponse> => {
return customFetch<Promise<exportArchivesResponse>>(getExportArchivesUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1AccountsIdAuditResponse = {
  data: AuditLogPage;
  status: number;
}

export const getGetApiV1AccountsIdAuditUrl = (id: string,
    params: GetApiV1AccountsIdAuditParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/accounts/${id}/audit?${normalizedParams.toString()}`
}

export const getApiV1AccountsIdAudit = async (id: string,
    params: GetApiV1AccountsIdAuditParams, options?: RequestInit): Promise<getApiV1AccountsIdAuditResponse> => {
return customFetch<Promise<getApiV1AccountsIdAuditResponse>>(getGetApiV1AccountsIdAuditUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1BlogCategoriesResponse = {
  data: BlogCategoryDto[];
  status: number;
}

export const getGetApiV1BlogCategoriesUrl = () => {


  return `/api/v1/blog/categories`
}

export const getApiV1BlogCategories = async ( options?: RequestInit): Promise<getApiV1BlogCategoriesResponse> => {
return customFetch<Promise<getApiV1BlogCategoriesResponse>>(getGetApiV1BlogCategoriesUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1BlogArticlesResponse = {
  data: BlogArticleListResponse;
  status: number;
}

export const getGetApiV1BlogArticlesUrl = (params?: GetApiV1BlogArticlesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/blog/articles?${normalizedParams.toString()}`
}

export const getApiV1BlogArticles = async (params?: GetApiV1BlogArticlesParams, options?: RequestInit): Promise<getApiV1BlogArticlesResponse> => {
return customFetch<Promise<getApiV1BlogArticlesResponse>>(getGetApiV1BlogArticlesUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1BlogArticlesSlugResponse = {
  data: BlogArticleDto;
  status: number;
}

export const getGetApiV1BlogArticlesSlugUrl = (slug: string,) => {


  return `/api/v1/blog/articles/${slug}`
}

export const getApiV1BlogArticlesSlug = async (slug: string, options?: RequestInit): Promise<getApiV1BlogArticlesSlugResponse> => {
return customFetch<Promise<getApiV1BlogArticlesSlugResponse>>(getGetApiV1BlogArticlesSlugUrl(slug),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1BlogPreviewTokenResponse = {
  data: BlogArticleDto;
  status: number;
}

export const getGetApiV1BlogPreviewTokenUrl = (token: string,) => {


  return `/api/v1/blog/preview/${token}`
}

export const getApiV1BlogPreviewToken = async (token: string, options?: RequestInit): Promise<getApiV1BlogPreviewTokenResponse> => {
return customFetch<Promise<getApiV1BlogPreviewTokenResponse>>(getGetApiV1BlogPreviewTokenUrl(token),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1BlogMediaKeyResponse = {
  data: unknown;
  status: number;
}

export const getGetApiV1BlogMediaKeyUrl = (key: string,) => {


  return `/api/v1/blog/media/${key}`
}

export const getApiV1BlogMediaKey = async (key: string, options?: RequestInit): Promise<getApiV1BlogMediaKeyResponse> => {
return customFetch<Promise<getApiV1BlogMediaKeyResponse>>(getGetApiV1BlogMediaKeyUrl(key),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1ComplianceReportResponse = {
  data: PageComplianceRow;
  status: number;
}

export const getGetApiV1ComplianceReportUrl = (params: GetApiV1ComplianceReportParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/compliance/report?${normalizedParams.toString()}`
}

export const getApiV1ComplianceReport = async (params: GetApiV1ComplianceReportParams, options?: RequestInit): Promise<getApiV1ComplianceReportResponse> => {
return customFetch<Promise<getApiV1ComplianceReportResponse>>(getGetApiV1ComplianceReportUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1ComplianceReportRowEridResponse = {
  data: SingleRowResponse;
  status: number;
}

export const getGetApiV1ComplianceReportRowEridUrl = (erid: string,
    params: GetApiV1ComplianceReportRowEridParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/compliance/report/row/${erid}?${normalizedParams.toString()}`
}

export const getApiV1ComplianceReportRowErid = async (erid: string,
    params: GetApiV1ComplianceReportRowEridParams, options?: RequestInit): Promise<getApiV1ComplianceReportRowEridResponse> => {
return customFetch<Promise<getApiV1ComplianceReportRowEridResponse>>(getGetApiV1ComplianceReportRowEridUrl(erid,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1ComplianceSummaryResponse = {
  data: ComplianceSummaryResponse;
  status: number;
}

export const getGetApiV1ComplianceSummaryUrl = (params?: GetApiV1ComplianceSummaryParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/compliance/summary?${normalizedParams.toString()}`
}

export const getApiV1ComplianceSummary = async (params?: GetApiV1ComplianceSummaryParams, options?: RequestInit): Promise<getApiV1ComplianceSummaryResponse> => {
return customFetch<Promise<getApiV1ComplianceSummaryResponse>>(getGetApiV1ComplianceSummaryUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ComplianceActsResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceActsUrl = () => {


  return `/api/v1/compliance/acts`
}

export const postApiV1ComplianceActs = async (actCreateRequest: ActCreateRequest, options?: RequestInit): Promise<postApiV1ComplianceActsResponse> => {
return customFetch<Promise<postApiV1ComplianceActsResponse>>(getPostApiV1ComplianceActsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      actCreateRequest,)
  }
);}


export type getApiV1ComplianceActsByContractResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ComplianceActsByContractUrl = (params: GetApiV1ComplianceActsByContractParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/compliance/acts/by-contract?${normalizedParams.toString()}`
}

export const getApiV1ComplianceActsByContract = async (params: GetApiV1ComplianceActsByContractParams, options?: RequestInit): Promise<getApiV1ComplianceActsByContractResponse> => {
return customFetch<Promise<getApiV1ComplianceActsByContractResponse>>(getGetApiV1ComplianceActsByContractUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ComplianceActsLinkResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceActsLinkUrl = () => {


  return `/api/v1/compliance/acts/link`
}

export const postApiV1ComplianceActsLink = async (actLinkRequest: ActLinkRequest, options?: RequestInit): Promise<postApiV1ComplianceActsLinkResponse> => {
return customFetch<Promise<postApiV1ComplianceActsLinkResponse>>(getPostApiV1ComplianceActsLinkUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      actLinkRequest,)
  }
);}


export type postApiV1ComplianceStatsCollectResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceStatsCollectUrl = () => {


  return `/api/v1/compliance/stats/collect`
}

export const postApiV1ComplianceStatsCollect = async (simpleRequestByCreative: SimpleRequestByCreative, options?: RequestInit): Promise<postApiV1ComplianceStatsCollectResponse> => {
return customFetch<Promise<postApiV1ComplianceStatsCollectResponse>>(getPostApiV1ComplianceStatsCollectUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      simpleRequestByCreative,)
  }
);}


export type postApiV1ComplianceOrdResendResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceOrdResendUrl = () => {


  return `/api/v1/compliance/ord/resend`
}

export const postApiV1ComplianceOrdResend = async (simpleRequestByCreative: SimpleRequestByCreative, options?: RequestInit): Promise<postApiV1ComplianceOrdResendResponse> => {
return customFetch<Promise<postApiV1ComplianceOrdResendResponse>>(getPostApiV1ComplianceOrdResendUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      simpleRequestByCreative,)
  }
);}


export type postApiV1ComplianceInitialContractLinkResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceInitialContractLinkUrl = () => {


  return `/api/v1/compliance/initial-contract/link`
}

export const postApiV1ComplianceInitialContractLink = async (linkInitialContractRequest: LinkInitialContractRequest, options?: RequestInit): Promise<postApiV1ComplianceInitialContractLinkResponse> => {
return customFetch<Promise<postApiV1ComplianceInitialContractLinkResponse>>(getPostApiV1ComplianceInitialContractLinkUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      linkInitialContractRequest,)
  }
);}


export type getApiV1CompliancePlacementStatusResponse = {
  data: void;
  status: number;
}

export const getGetApiV1CompliancePlacementStatusUrl = (params?: GetApiV1CompliancePlacementStatusParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/compliance/placement/status?${normalizedParams.toString()}`
}

export const getApiV1CompliancePlacementStatus = async (params?: GetApiV1CompliancePlacementStatusParams, options?: RequestInit): Promise<getApiV1CompliancePlacementStatusResponse> => {
return customFetch<Promise<getApiV1CompliancePlacementStatusResponse>>(getGetApiV1CompliancePlacementStatusUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1ComplianceStatisticsByEridEridResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ComplianceStatisticsByEridEridUrl = (erid: string,) => {


  return `/api/v1/compliance/statistics/by-erid/${erid}`
}

export const getApiV1ComplianceStatisticsByEridErid = async (erid: string, options?: RequestInit): Promise<getApiV1ComplianceStatisticsByEridEridResponse> => {
return customFetch<Promise<getApiV1ComplianceStatisticsByEridEridResponse>>(getGetApiV1ComplianceStatisticsByEridEridUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1ComplianceStatisticsByCreativeCreativeIdResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ComplianceStatisticsByCreativeCreativeIdUrl = (creativeId: string,) => {


  return `/api/v1/compliance/statistics/by-creative/${creativeId}`
}

export const getApiV1ComplianceStatisticsByCreativeCreativeId = async (creativeId: string, options?: RequestInit): Promise<getApiV1ComplianceStatisticsByCreativeCreativeIdResponse> => {
return customFetch<Promise<getApiV1ComplianceStatisticsByCreativeCreativeIdResponse>>(getGetApiV1ComplianceStatisticsByCreativeCreativeIdUrl(creativeId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ComplianceReportSubmitBatchResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceReportSubmitBatchUrl = () => {


  return `/api/v1/compliance/report/submit-batch`
}

export const postApiV1ComplianceReportSubmitBatch = async (submitBatchRequest: SubmitBatchRequest, options?: RequestInit): Promise<postApiV1ComplianceReportSubmitBatchResponse> => {
return customFetch<Promise<postApiV1ComplianceReportSubmitBatchResponse>>(getPostApiV1ComplianceReportSubmitBatchUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      submitBatchRequest,)
  }
);}


export type postApiV1ComplianceTelegramVerifyResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceTelegramVerifyUrl = () => {


  return `/api/v1/compliance/telegram/verify`
}

export const postApiV1ComplianceTelegramVerify = async (simpleRequestByCreative: SimpleRequestByCreative, options?: RequestInit): Promise<postApiV1ComplianceTelegramVerifyResponse> => {
return customFetch<Promise<postApiV1ComplianceTelegramVerifyResponse>>(getPostApiV1ComplianceTelegramVerifyUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      simpleRequestByCreative,)
  }
);}


export type getApiV1ComplianceAuditResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ComplianceAuditUrl = (params: GetApiV1ComplianceAuditParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/compliance/audit?${normalizedParams.toString()}`
}

export const getApiV1ComplianceAudit = async (params: GetApiV1ComplianceAuditParams, options?: RequestInit): Promise<getApiV1ComplianceAuditResponse> => {
return customFetch<Promise<getApiV1ComplianceAuditResponse>>(getGetApiV1ComplianceAuditUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1ComplianceInvoicesResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ComplianceInvoicesUrl = (params?: GetApiV1ComplianceInvoicesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/compliance/invoices?${normalizedParams.toString()}`
}

export const getApiV1ComplianceInvoices = async (params?: GetApiV1ComplianceInvoicesParams, options?: RequestInit): Promise<getApiV1ComplianceInvoicesResponse> => {
return customFetch<Promise<getApiV1ComplianceInvoicesResponse>>(getGetApiV1ComplianceInvoicesUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ComplianceImpressionsManualResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceImpressionsManualUrl = () => {


  return `/api/v1/compliance/impressions/manual`
}

export const postApiV1ComplianceImpressionsManual = async (manualImpressionsRequest: ManualImpressionsRequest, options?: RequestInit): Promise<postApiV1ComplianceImpressionsManualResponse> => {
return customFetch<Promise<postApiV1ComplianceImpressionsManualResponse>>(getPostApiV1ComplianceImpressionsManualUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      manualImpressionsRequest,)
  }
);}


export type postApiV1ComplianceAssignPadsResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceAssignPadsUrl = () => {


  return `/api/v1/compliance/assign-pads`
}

export const postApiV1ComplianceAssignPads = async (assignPadsRequest: AssignPadsRequest, options?: RequestInit): Promise<postApiV1ComplianceAssignPadsResponse> => {
return customFetch<Promise<postApiV1ComplianceAssignPadsResponse>>(getPostApiV1ComplianceAssignPadsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      assignPadsRequest,)
  }
);}


export type postApiV1ComplianceAssignPadResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceAssignPadUrl = () => {


  return `/api/v1/compliance/assign-pad`
}

export const postApiV1ComplianceAssignPad = async (assignPadRequest: AssignPadRequest, options?: RequestInit): Promise<postApiV1ComplianceAssignPadResponse> => {
return customFetch<Promise<postApiV1ComplianceAssignPadResponse>>(getPostApiV1ComplianceAssignPadUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      assignPadRequest,)
  }
);}


export type postApiV1ComplianceAssignPlacementPeriodResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ComplianceAssignPlacementPeriodUrl = () => {


  return `/api/v1/compliance/assign-placement-period`
}

export const postApiV1ComplianceAssignPlacementPeriod = async (assignPlacementPeriodRequest: AssignPlacementPeriodRequest, options?: RequestInit): Promise<postApiV1ComplianceAssignPlacementPeriodResponse> => {
return customFetch<Promise<postApiV1ComplianceAssignPlacementPeriodResponse>>(getPostApiV1ComplianceAssignPlacementPeriodUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      assignPlacementPeriodRequest,)
  }
);}


export type getCreativeErirStatusResponse = {
  data: ErirStatusDto;
  status: number;
}

export const getGetCreativeErirStatusUrl = (creativeExternalId: string,
    params?: GetCreativeErirStatusParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/creative/${creativeExternalId}/erir-status?${normalizedParams.toString()}`
}

export const getCreativeErirStatus = async (creativeExternalId: string,
    params?: GetCreativeErirStatusParams, options?: RequestInit): Promise<getCreativeErirStatusResponse> => {
return customFetch<Promise<getCreativeErirStatusResponse>>(getGetCreativeErirStatusUrl(creativeExternalId,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getErirStatusResponse = {
  data: ErirStatusDto;
  status: number;
}

export const getGetErirStatusUrl = (dataType: string,
    externalId: string,
    params?: GetErirStatusParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/${dataType}/${externalId}/erir-status?${normalizedParams.toString()}`
}

export const getErirStatus = async (dataType: string,
    externalId: string,
    params?: GetErirStatusParams, options?: RequestInit): Promise<getErirStatusResponse> => {
return customFetch<Promise<getErirStatusResponse>>(getGetErirStatusUrl(dataType,externalId,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getErirStatusesByFilterResponse = {
  data: BatchErirStatusResult;
  status: number;
}

export const getGetErirStatusesByFilterUrl = (params: GetErirStatusesByFilterParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/erir-status/filter?${normalizedParams.toString()}`
}

export const getErirStatusesByFilter = async (params: GetErirStatusesByFilterParams, options?: RequestInit): Promise<getErirStatusesByFilterResponse> => {
return customFetch<Promise<getErirStatusesByFilterResponse>>(getGetErirStatusesByFilterUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ExportComplianceResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ExportComplianceUrl = () => {


  return `/api/v1/export/compliance`
}

export const postApiV1ExportCompliance = async (exportStartRequest: ExportStartRequest, options?: RequestInit): Promise<postApiV1ExportComplianceResponse> => {
return customFetch<Promise<postApiV1ExportComplianceResponse>>(getPostApiV1ExportComplianceUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      exportStartRequest,)
  }
);}


export type postApiV1ExportPostsResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ExportPostsUrl = () => {


  return `/api/v1/export/posts`
}

export const postApiV1ExportPosts = async (postsExportRequest: PostsExportRequest, options?: RequestInit): Promise<postApiV1ExportPostsResponse> => {
return customFetch<Promise<postApiV1ExportPostsResponse>>(getPostApiV1ExportPostsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      postsExportRequest,)
  }
);}


export type getApiV1ExportExportIdResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ExportExportIdUrl = (exportId: string,) => {


  return `/api/v1/export/${exportId}`
}

export const getApiV1ExportExportId = async (exportId: string, options?: RequestInit): Promise<getApiV1ExportExportIdResponse> => {
return customFetch<Promise<getApiV1ExportExportIdResponse>>(getGetApiV1ExportExportIdUrl(exportId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1SubscriptionsSubscriptionIdExtraCabinetsResponse = {
  data: ExtraCabinetsInfoResponse;
  status: number;
}

export const getGetApiV1SubscriptionsSubscriptionIdExtraCabinetsUrl = (subscriptionId: string,) => {


  return `/api/v1/subscriptions/${subscriptionId}/extra-cabinets`
}

export const getApiV1SubscriptionsSubscriptionIdExtraCabinets = async (subscriptionId: string, options?: RequestInit): Promise<getApiV1SubscriptionsSubscriptionIdExtraCabinetsResponse> => {
return customFetch<Promise<getApiV1SubscriptionsSubscriptionIdExtraCabinetsResponse>>(getGetApiV1SubscriptionsSubscriptionIdExtraCabinetsUrl(subscriptionId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1SubscriptionsSubscriptionIdExtraCabinetsResponse = {
  data: PurchaseExtraCabinetsResponse;
  status: number;
}

export const getPostApiV1SubscriptionsSubscriptionIdExtraCabinetsUrl = (subscriptionId: string,) => {


  return `/api/v1/subscriptions/${subscriptionId}/extra-cabinets`
}

export const postApiV1SubscriptionsSubscriptionIdExtraCabinets = async (subscriptionId: string,
    purchaseExtraCabinetsRequest: PurchaseExtraCabinetsRequest, options?: RequestInit): Promise<postApiV1SubscriptionsSubscriptionIdExtraCabinetsResponse> => {
return customFetch<Promise<postApiV1SubscriptionsSubscriptionIdExtraCabinetsResponse>>(getPostApiV1SubscriptionsSubscriptionIdExtraCabinetsUrl(subscriptionId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      purchaseExtraCabinetsRequest,)
  }
);}


export type postApiV1SubscriptionsSubscriptionIdExtraCabinetsCalculateResponse = {
  data: ExtraCabinetsCalculationResponse;
  status: number;
}

export const getPostApiV1SubscriptionsSubscriptionIdExtraCabinetsCalculateUrl = (subscriptionId: string,) => {


  return `/api/v1/subscriptions/${subscriptionId}/extra-cabinets/calculate`
}

export const postApiV1SubscriptionsSubscriptionIdExtraCabinetsCalculate = async (subscriptionId: string,
    purchaseExtraCabinetsRequest: PurchaseExtraCabinetsRequest, options?: RequestInit): Promise<postApiV1SubscriptionsSubscriptionIdExtraCabinetsCalculateResponse> => {
return customFetch<Promise<postApiV1SubscriptionsSubscriptionIdExtraCabinetsCalculateResponse>>(getPostApiV1SubscriptionsSubscriptionIdExtraCabinetsCalculateUrl(subscriptionId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      purchaseExtraCabinetsRequest,)
  }
);}


/**
 * Отправка формы обратной связи с лендинга
 */
export type submitFeedbackResponse = {
  data: FeedbackResponse;
  status: number;
}

export const getSubmitFeedbackUrl = () => {


  return `/api/v1/feedback`
}

export const submitFeedback = async (feedbackRequest: FeedbackRequest, options?: RequestInit): Promise<submitFeedbackResponse> => {
return customFetch<Promise<submitFeedbackResponse>>(getSubmitFeedbackUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      feedbackRequest,)
  }
);}


export type postApiV1InnLookupResponse = {
  data: InnLookupResponse;
  status: number;
}

export const getPostApiV1InnLookupUrl = () => {


  return `/api/v1/inn/lookup`
}

export const postApiV1InnLookup = async (innLookupRequest: InnLookupRequest, options?: RequestInit): Promise<postApiV1InnLookupResponse> => {
return customFetch<Promise<postApiV1InnLookupResponse>>(getPostApiV1InnLookupUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      innLookupRequest,)
  }
);}


export type postApiV1AccountsIdInvitationsResponse = {
  data: InvitationDto;
  status: number;
}

export const getPostApiV1AccountsIdInvitationsUrl = (id: string,) => {


  return `/api/v1/accounts/${id}/invitations`
}

export const postApiV1AccountsIdInvitations = async (id: string,
    createInvitationRequest: CreateInvitationRequest, options?: RequestInit): Promise<postApiV1AccountsIdInvitationsResponse> => {
return customFetch<Promise<postApiV1AccountsIdInvitationsResponse>>(getPostApiV1AccountsIdInvitationsUrl(id),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createInvitationRequest,)
  }
);}


export type getApiV1AccountsIdInvitationsResponse = {
  data: InvitationDto[];
  status: number;
}

export const getGetApiV1AccountsIdInvitationsUrl = (id: string,) => {


  return `/api/v1/accounts/${id}/invitations`
}

export const getApiV1AccountsIdInvitations = async (id: string, options?: RequestInit): Promise<getApiV1AccountsIdInvitationsResponse> => {
return customFetch<Promise<getApiV1AccountsIdInvitationsResponse>>(getGetApiV1AccountsIdInvitationsUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type deleteApiV1AccountsIdInvitationsInvIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1AccountsIdInvitationsInvIdUrl = (id: string,
    invId: string,) => {


  return `/api/v1/accounts/${id}/invitations/${invId}`
}

export const deleteApiV1AccountsIdInvitationsInvId = async (id: string,
    invId: string, options?: RequestInit): Promise<deleteApiV1AccountsIdInvitationsInvIdResponse> => {
return customFetch<Promise<deleteApiV1AccountsIdInvitationsInvIdResponse>>(getDeleteApiV1AccountsIdInvitationsInvIdUrl(id,invId),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type postApiV1InvitationsTokenAcceptResponse = {
  data: AcceptInvitationResult;
  status: number;
}

export const getPostApiV1InvitationsTokenAcceptUrl = (token: string,) => {


  return `/api/v1/invitations/${token}/accept`
}

export const postApiV1InvitationsTokenAccept = async (token: string, options?: RequestInit): Promise<postApiV1InvitationsTokenAcceptResponse> => {
return customFetch<Promise<postApiV1InvitationsTokenAcceptResponse>>(getPostApiV1InvitationsTokenAcceptUrl(token),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getApiV1InvitationsTokenPreviewResponse = {
  data: InvitationPreviewDto;
  status: number;
}

export const getGetApiV1InvitationsTokenPreviewUrl = (token: string,) => {


  return `/api/v1/invitations/${token}/preview`
}

export const getApiV1InvitationsTokenPreview = async (token: string, options?: RequestInit): Promise<getApiV1InvitationsTokenPreviewResponse> => {
return customFetch<Promise<getApiV1InvitationsTokenPreviewResponse>>(getGetApiV1InvitationsTokenPreviewUrl(token),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1InvitationsTokenSetPasswordResponse = {
  data: void;
  status: number;
}

export const getPostApiV1InvitationsTokenSetPasswordUrl = (token: string,) => {


  return `/api/v1/invitations/${token}/set-password`
}

export const postApiV1InvitationsTokenSetPassword = async (token: string,
    setInvitationPasswordRequest: SetInvitationPasswordRequest, options?: RequestInit): Promise<postApiV1InvitationsTokenSetPasswordResponse> => {
return customFetch<Promise<postApiV1InvitationsTokenSetPasswordResponse>>(getPostApiV1InvitationsTokenSetPasswordUrl(token),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      setInvitationPasswordRequest,)
  }
);}


/**
 * Текущие версии юридических документов (для frontend, чтобы знал какую версию проставлять при отправке согласия)
 */
export type getLegalDocumentVersionsResponse = {
  data: LegalDocumentVersionsResponse;
  status: number;
}

export const getGetLegalDocumentVersionsUrl = () => {


  return `/api/v1/legal-consents/versions`
}

export const getLegalDocumentVersions = async ( options?: RequestInit): Promise<getLegalDocumentVersionsResponse> => {
return customFetch<Promise<getLegalDocumentVersionsResponse>>(getGetLegalDocumentVersionsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


/**
 * Зафиксировать согласия пользователя с юридическими документами (signup или контактная форма)
 */
export type recordLegalConsentsResponse = {
  data: RecordLegalConsentsResponse;
  status: number;
}

export const getRecordLegalConsentsUrl = () => {


  return `/api/v1/legal-consents`
}

export const recordLegalConsents = async (recordLegalConsentsRequest: RecordLegalConsentsRequest, options?: RequestInit): Promise<recordLegalConsentsResponse> => {
return customFetch<Promise<recordLegalConsentsResponse>>(getRecordLegalConsentsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      recordLegalConsentsRequest,)
  }
);}


export type postApiV1MaxPostsPostIdLinkResponse = {
  data: MaxLinkPostResponse;
  status: number;
}

export const getPostApiV1MaxPostsPostIdLinkUrl = (postId: string,) => {


  return `/api/v1/max/posts/${postId}/link`
}

export const postApiV1MaxPostsPostIdLink = async (postId: string,
    maxLinkPostRequest: MaxLinkPostRequest, options?: RequestInit): Promise<postApiV1MaxPostsPostIdLinkResponse> => {
return customFetch<Promise<postApiV1MaxPostsPostIdLinkResponse>>(getPostApiV1MaxPostsPostIdLinkUrl(postId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      maxLinkPostRequest,)
  }
);}


export type deleteApiV1MaxPostsPostIdLinkResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1MaxPostsPostIdLinkUrl = (postId: string,) => {


  return `/api/v1/max/posts/${postId}/link`
}

export const deleteApiV1MaxPostsPostIdLink = async (postId: string, options?: RequestInit): Promise<deleteApiV1MaxPostsPostIdLinkResponse> => {
return customFetch<Promise<deleteApiV1MaxPostsPostIdLinkResponse>>(getDeleteApiV1MaxPostsPostIdLinkUrl(postId),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1MaxPostsPostIdStatsResponse = {
  data: MaxPostStatsResponse;
  status: number;
}

export const getGetApiV1MaxPostsPostIdStatsUrl = (postId: string,) => {


  return `/api/v1/max/posts/${postId}/stats`
}

export const getApiV1MaxPostsPostIdStats = async (postId: string, options?: RequestInit): Promise<getApiV1MaxPostsPostIdStatsResponse> => {
return customFetch<Promise<getApiV1MaxPostsPostIdStatsResponse>>(getGetApiV1MaxPostsPostIdStatsUrl(postId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1MaxReachEridEridLatestResponse = {
  data: MaxEridReachResponse;
  status: number;
}

export const getGetApiV1MaxReachEridEridLatestUrl = (erid: string,) => {


  return `/api/v1/max/reach/erid/${erid}/latest`
}

export const getApiV1MaxReachEridEridLatest = async (erid: string, options?: RequestInit): Promise<getApiV1MaxReachEridEridLatestResponse> => {
return customFetch<Promise<getApiV1MaxReachEridEridLatestResponse>>(getGetApiV1MaxReachEridEridLatestUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1MaxReachEridEridMonthlyResponse = {
  data: MaxMonthlyReachResponse;
  status: number;
}

export const getGetApiV1MaxReachEridEridMonthlyUrl = (erid: string,) => {


  return `/api/v1/max/reach/erid/${erid}/monthly`
}

export const getApiV1MaxReachEridEridMonthly = async (erid: string, options?: RequestInit): Promise<getApiV1MaxReachEridEridMonthlyResponse> => {
return customFetch<Promise<getApiV1MaxReachEridEridMonthlyResponse>>(getGetApiV1MaxReachEridEridMonthlyUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1MaxMetricsCollectNowResponse = {
  data: void;
  status: number;
}

export const getPostApiV1MaxMetricsCollectNowUrl = () => {


  return `/api/v1/max/metrics/collect-now`
}

export const postApiV1MaxMetricsCollectNow = async ( options?: RequestInit): Promise<postApiV1MaxMetricsCollectNowResponse> => {
return customFetch<Promise<postApiV1MaxMetricsCollectNowResponse>>(getPostApiV1MaxMetricsCollectNowUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getApiV1AccountsIdMembersResponse = {
  data: MemberDto[];
  status: number;
}

export const getGetApiV1AccountsIdMembersUrl = (id: string,) => {


  return `/api/v1/accounts/${id}/members`
}

export const getApiV1AccountsIdMembers = async (id: string, options?: RequestInit): Promise<getApiV1AccountsIdMembersResponse> => {
return customFetch<Promise<getApiV1AccountsIdMembersResponse>>(getGetApiV1AccountsIdMembersUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type patchApiV1AccountsIdMembersUserIdResponse = {
  data: void;
  status: number;
}

export const getPatchApiV1AccountsIdMembersUserIdUrl = (id: string,
    userId: string,) => {


  return `/api/v1/accounts/${id}/members/${userId}`
}

export const patchApiV1AccountsIdMembersUserId = async (id: string,
    userId: string,
    changeRoleRequest: ChangeRoleRequest, options?: RequestInit): Promise<patchApiV1AccountsIdMembersUserIdResponse> => {
return customFetch<Promise<patchApiV1AccountsIdMembersUserIdResponse>>(getPatchApiV1AccountsIdMembersUserIdUrl(id,userId),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      changeRoleRequest,)
  }
);}


export type deleteApiV1AccountsIdMembersUserIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1AccountsIdMembersUserIdUrl = (id: string,
    userId: string,) => {


  return `/api/v1/accounts/${id}/members/${userId}`
}

export const deleteApiV1AccountsIdMembersUserId = async (id: string,
    userId: string, options?: RequestInit): Promise<deleteApiV1AccountsIdMembersUserIdResponse> => {
return customFetch<Promise<deleteApiV1AccountsIdMembersUserIdResponse>>(getDeleteApiV1AccountsIdMembersUserIdUrl(id,userId),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type putApiV1AccountsIdMembersUserIdCabinetsResponse = {
  data: void;
  status: number;
}

export const getPutApiV1AccountsIdMembersUserIdCabinetsUrl = (id: string,
    userId: string,) => {


  return `/api/v1/accounts/${id}/members/${userId}/cabinets`
}

export const putApiV1AccountsIdMembersUserIdCabinets = async (id: string,
    userId: string,
    setCabinetAccessRequest: SetCabinetAccessRequest, options?: RequestInit): Promise<putApiV1AccountsIdMembersUserIdCabinetsResponse> => {
return customFetch<Promise<putApiV1AccountsIdMembersUserIdCabinetsResponse>>(getPutApiV1AccountsIdMembersUserIdCabinetsUrl(id,userId),
  {      
    ...options,
    method: 'PUT',
    body: JSON.stringify(
      setCabinetAccessRequest,)
  }
);}


export type getHealthResponse = {
  data: void;
  status: number;
}

export const getGetHealthUrl = () => {


  return `/health`
}

export const getHealth = async ( options?: RequestInit): Promise<getHealthResponse> => {
return customFetch<Promise<getHealthResponse>>(getGetHealthUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getHealthDbResponse = {
  data: void;
  status: number;
}

export const getGetHealthDbUrl = () => {


  return `/health/db`
}

export const getHealthDb = async ( options?: RequestInit): Promise<getHealthDbResponse> => {
return customFetch<Promise<getHealthDbResponse>>(getGetHealthDbUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1SubmitResponse = {
  data: void;
  status: number;
}

export const getPostApiV1SubmitUrl = () => {


  return `/api/v1/submit`
}

export const postApiV1Submit = async ( options?: RequestInit): Promise<postApiV1SubmitResponse> => {
return customFetch<Promise<postApiV1SubmitResponse>>(getPostApiV1SubmitUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1SubmitArchiveResponse = {
  data: void;
  status: number;
}

export const getPostApiV1SubmitArchiveUrl = () => {


  return `/api/v1/submit-archive`
}

export const postApiV1SubmitArchive = async (archiveSubmitRequest: ArchiveSubmitRequest, options?: RequestInit): Promise<postApiV1SubmitArchiveResponse> => {
return customFetch<Promise<postApiV1SubmitArchiveResponse>>(getPostApiV1SubmitArchiveUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      archiveSubmitRequest,)
  }
);}


export type getApiV1JobsIdResponse = {
  data: void;
  status: number;
}

export const getGetApiV1JobsIdUrl = (id: string,) => {


  return `/api/v1/jobs/${id}`
}

export const getApiV1JobsId = async (id: string, options?: RequestInit): Promise<getApiV1JobsIdResponse> => {
return customFetch<Promise<getApiV1JobsIdResponse>>(getGetApiV1JobsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1JobsIdEventsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1JobsIdEventsUrl = (id: string,) => {


  return `/api/v1/jobs/${id}/events`
}

export const getApiV1JobsIdEvents = async (id: string, options?: RequestInit): Promise<getApiV1JobsIdEventsResponse> => {
return customFetch<Promise<getApiV1JobsIdEventsResponse>>(getGetApiV1JobsIdEventsUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1AnalysisResponse = {
  data: AnalysisListResponse;
  status: number;
}

export const getGetApiV1AnalysisUrl = (params?: GetApiV1AnalysisParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/analysis?${normalizedParams.toString()}`
}

export const getApiV1Analysis = async (params?: GetApiV1AnalysisParams, options?: RequestInit): Promise<getApiV1AnalysisResponse> => {
return customFetch<Promise<getApiV1AnalysisResponse>>(getGetApiV1AnalysisUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1AnalysisFeedResponse = {
  data: AnalysisListResponse;
  status: number;
}

export const getGetApiV1AnalysisFeedUrl = (params?: GetApiV1AnalysisFeedParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/analysis-feed?${normalizedParams.toString()}`
}

export const getApiV1AnalysisFeed = async (params?: GetApiV1AnalysisFeedParams, options?: RequestInit): Promise<getApiV1AnalysisFeedResponse> => {
return customFetch<Promise<getApiV1AnalysisFeedResponse>>(getGetApiV1AnalysisFeedUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1AnalysisIdResponse = {
  data: AnalysisDetailResponse;
  status: number;
}

export const getGetApiV1AnalysisIdUrl = (id: string,) => {


  return `/api/v1/analysis/${id}`
}

export const getApiV1AnalysisId = async (id: string, options?: RequestInit): Promise<getApiV1AnalysisIdResponse> => {
return customFetch<Promise<getApiV1AnalysisIdResponse>>(getGetApiV1AnalysisIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type patchApiV1AnalysisIdResponse = {
  data: void;
  status: number;
}

export const getPatchApiV1AnalysisIdUrl = (id: string,) => {


  return `/api/v1/analysis/${id}`
}

export const patchApiV1AnalysisId = async (id: string,
    patchApiV1AnalysisIdBody: PatchApiV1AnalysisIdBody, options?: RequestInit): Promise<patchApiV1AnalysisIdResponse> => {
return customFetch<Promise<patchApiV1AnalysisIdResponse>>(getPatchApiV1AnalysisIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      patchApiV1AnalysisIdBody,)
  }
);}


export type getApiV1ExamplesResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ExamplesUrl = () => {


  return `/api/v1/examples`
}

export const getApiV1Examples = async ( options?: RequestInit): Promise<getApiV1ExamplesResponse> => {
return customFetch<Promise<getApiV1ExamplesResponse>>(getGetApiV1ExamplesUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ExamplesResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ExamplesUrl = () => {


  return `/api/v1/examples`
}

export const postApiV1Examples = async (exampleCreateRequest: ExampleCreateRequest, options?: RequestInit): Promise<postApiV1ExamplesResponse> => {
return customFetch<Promise<postApiV1ExamplesResponse>>(getPostApiV1ExamplesUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      exampleCreateRequest,)
  }
);}


export type deleteApiV1ExamplesResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1ExamplesUrl = () => {


  return `/api/v1/examples`
}

export const deleteApiV1Examples = async ( options?: RequestInit): Promise<deleteApiV1ExamplesResponse> => {
return customFetch<Promise<deleteApiV1ExamplesResponse>>(getDeleteApiV1ExamplesUrl(),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1ExamplesIdResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ExamplesIdUrl = (id: number,) => {


  return `/api/v1/examples/${id}`
}

export const getApiV1ExamplesId = async (id: number, options?: RequestInit): Promise<getApiV1ExamplesIdResponse> => {
return customFetch<Promise<getApiV1ExamplesIdResponse>>(getGetApiV1ExamplesIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1StatsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1StatsUrl = () => {


  return `/api/v1/stats`
}

export const getApiV1Stats = async ( options?: RequestInit): Promise<getApiV1StatsResponse> => {
return customFetch<Promise<getApiV1StatsResponse>>(getGetApiV1StatsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1SettingsPublicResponse = {
  data: void;
  status: number;
}

export const getGetApiV1SettingsPublicUrl = () => {


  return `/api/v1/settings/public`
}

export const getApiV1SettingsPublic = async ( options?: RequestInit): Promise<getApiV1SettingsPublicResponse> => {
return customFetch<Promise<getApiV1SettingsPublicResponse>>(getGetApiV1SettingsPublicUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1AccountsResponse = {
  data: AccountsListResponse;
  status: number;
}

export const getGetApiV1AccountsUrl = () => {


  return `/api/v1/accounts`
}

export const getApiV1Accounts = async ( options?: RequestInit): Promise<getApiV1AccountsResponse> => {
return customFetch<Promise<getApiV1AccountsResponse>>(getGetApiV1AccountsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AccountsIdSwitchResponse = {
  data: SwitchAccountResponse;
  status: number;
}

export const getPostApiV1AccountsIdSwitchUrl = (id: string,) => {


  return `/api/v1/accounts/${id}/switch`
}

export const postApiV1AccountsIdSwitch = async (id: string, options?: RequestInit): Promise<postApiV1AccountsIdSwitchResponse> => {
return customFetch<Promise<postApiV1AccountsIdSwitchResponse>>(getPostApiV1AccountsIdSwitchUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1AccountsCreateResponse = {
  data: CreateAccountResponse;
  status: number;
}

export const getPostApiV1AccountsCreateUrl = () => {


  return `/api/v1/accounts/create`
}

export const postApiV1AccountsCreate = async (createAdditionalAccountRequest: CreateAdditionalAccountRequest, options?: RequestInit): Promise<postApiV1AccountsCreateResponse> => {
return customFetch<Promise<postApiV1AccountsCreateResponse>>(getPostApiV1AccountsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createAdditionalAccountRequest,)
  }
);}


export type patchApiV1AccountsIdResponse = {
  data: RenameAccountResponse;
  status: number;
}

export const getPatchApiV1AccountsIdUrl = (id: string,) => {


  return `/api/v1/accounts/${id}`
}

export const patchApiV1AccountsId = async (id: string,
    renameAccountRequest: RenameAccountRequest, options?: RequestInit): Promise<patchApiV1AccountsIdResponse> => {
return customFetch<Promise<patchApiV1AccountsIdResponse>>(getPatchApiV1AccountsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      renameAccountRequest,)
  }
);}


export type deleteApiV1AccountsIdResponse = {
  data: ArchiveAccountResponse;
  status: number;
}

export const getDeleteApiV1AccountsIdUrl = (id: string,) => {


  return `/api/v1/accounts/${id}`
}

export const deleteApiV1AccountsId = async (id: string, options?: RequestInit): Promise<deleteApiV1AccountsIdResponse> => {
return customFetch<Promise<deleteApiV1AccountsIdResponse>>(getDeleteApiV1AccountsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type patchApiV1AccountsIdTeamNameResponse = {
  data: void;
  status: number;
}

export const getPatchApiV1AccountsIdTeamNameUrl = (id: string,) => {


  return `/api/v1/accounts/${id}/team-name`
}

export const patchApiV1AccountsIdTeamName = async (id: string,
    setTeamNameRequest: SetTeamNameRequest, options?: RequestInit): Promise<patchApiV1AccountsIdTeamNameResponse> => {
return customFetch<Promise<patchApiV1AccountsIdTeamNameResponse>>(getPatchApiV1AccountsIdTeamNameUrl(id),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      setTeamNameRequest,)
  }
);}


export type getRTokenResponse = {
  data: void;
  status: number;
}

export const getGetRTokenUrl = (token: string,) => {


  return `/r/${token}`
}

export const getRToken = async (token: string, options?: RequestInit): Promise<getRTokenResponse> => {
return customFetch<Promise<getRTokenResponse>>(getGetRTokenUrl(token),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ReferralsClaimResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ReferralsClaimUrl = (params?: PostApiV1ReferralsClaimParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/referrals/claim?${normalizedParams.toString()}`
}

export const postApiV1ReferralsClaim = async (params?: PostApiV1ReferralsClaimParams, options?: RequestInit): Promise<postApiV1ReferralsClaimResponse> => {
return customFetch<Promise<postApiV1ReferralsClaimResponse>>(getPostApiV1ReferralsClaimUrl(params),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getApiV1ReferralsInfoResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ReferralsInfoUrl = () => {


  return `/api/v1/referrals/info`
}

export const getApiV1ReferralsInfo = async ( options?: RequestInit): Promise<getApiV1ReferralsInfoResponse> => {
return customFetch<Promise<getApiV1ReferralsInfoResponse>>(getGetApiV1ReferralsInfoUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1NotificationsPreferencesResponse = {
  data: void;
  status: number;
}

export const getGetApiV1NotificationsPreferencesUrl = () => {


  return `/api/v1/notifications/preferences`
}

export const getApiV1NotificationsPreferences = async ( options?: RequestInit): Promise<getApiV1NotificationsPreferencesResponse> => {
return customFetch<Promise<getApiV1NotificationsPreferencesResponse>>(getGetApiV1NotificationsPreferencesUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type putApiV1NotificationsPreferencesResponse = {
  data: void;
  status: number;
}

export const getPutApiV1NotificationsPreferencesUrl = () => {


  return `/api/v1/notifications/preferences`
}

export const putApiV1NotificationsPreferences = async (preferencesPutRequest: PreferencesPutRequest, options?: RequestInit): Promise<putApiV1NotificationsPreferencesResponse> => {
return customFetch<Promise<putApiV1NotificationsPreferencesResponse>>(getPutApiV1NotificationsPreferencesUrl(),
  {      
    ...options,
    method: 'PUT',
    body: JSON.stringify(
      preferencesPutRequest,)
  }
);}


export type getApiV1NotificationsResponse = {
  data: NotificationsListResponse;
  status: number;
}

export const getGetApiV1NotificationsUrl = (params?: GetApiV1NotificationsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/notifications?${normalizedParams.toString()}`
}

export const getApiV1Notifications = async (params?: GetApiV1NotificationsParams, options?: RequestInit): Promise<getApiV1NotificationsResponse> => {
return customFetch<Promise<getApiV1NotificationsResponse>>(getGetApiV1NotificationsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1NotificationsReadResponse = {
  data: void;
  status: number;
}

export const getPostApiV1NotificationsReadUrl = () => {


  return `/api/v1/notifications/read`
}

export const postApiV1NotificationsRead = async (readReq: ReadReq, options?: RequestInit): Promise<postApiV1NotificationsReadResponse> => {
return customFetch<Promise<postApiV1NotificationsReadResponse>>(getPostApiV1NotificationsReadUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      readReq,)
  }
);}


export type getApiV1NotificationsStreamResponse = {
  data: void;
  status: number;
}

export const getGetApiV1NotificationsStreamUrl = () => {


  return `/api/v1/notifications/stream`
}

export const getApiV1NotificationsStream = async ( options?: RequestInit): Promise<getApiV1NotificationsStreamResponse> => {
return customFetch<Promise<getApiV1NotificationsStreamResponse>>(getGetApiV1NotificationsStreamUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1NotificationsSettingsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1NotificationsSettingsUrl = () => {


  return `/api/v1/notifications/settings`
}

export const getApiV1NotificationsSettings = async ( options?: RequestInit): Promise<getApiV1NotificationsSettingsResponse> => {
return customFetch<Promise<getApiV1NotificationsSettingsResponse>>(getGetApiV1NotificationsSettingsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1NotificationsSettingsResponse = {
  data: void;
  status: number;
}

export const getPostApiV1NotificationsSettingsUrl = () => {


  return `/api/v1/notifications/settings`
}

export const postApiV1NotificationsSettings = async (updateNotificationSettingsRequest: UpdateNotificationSettingsRequest, options?: RequestInit): Promise<postApiV1NotificationsSettingsResponse> => {
return customFetch<Promise<postApiV1NotificationsSettingsResponse>>(getPostApiV1NotificationsSettingsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      updateNotificationSettingsRequest,)
  }
);}


export type getApiV1NotificationsPreferencesV2Response = {
  data: void;
  status: number;
}

export const getGetApiV1NotificationsPreferencesV2Url = () => {


  return `/api/v1/notifications/preferences/v2`
}

export const getApiV1NotificationsPreferencesV2 = async ( options?: RequestInit): Promise<getApiV1NotificationsPreferencesV2Response> => {
return customFetch<Promise<getApiV1NotificationsPreferencesV2Response>>(getGetApiV1NotificationsPreferencesV2Url(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type putApiV1NotificationsPreferencesV2Response = {
  data: void;
  status: number;
}

export const getPutApiV1NotificationsPreferencesV2Url = () => {


  return `/api/v1/notifications/preferences/v2`
}

export const putApiV1NotificationsPreferencesV2 = async (updateNotificationPreferencesV2Request: UpdateNotificationPreferencesV2Request, options?: RequestInit): Promise<putApiV1NotificationsPreferencesV2Response> => {
return customFetch<Promise<putApiV1NotificationsPreferencesV2Response>>(getPutApiV1NotificationsPreferencesV2Url(),
  {      
    ...options,
    method: 'PUT',
    body: JSON.stringify(
      updateNotificationPreferencesV2Request,)
  }
);}


export type getApiV1AdminSettingsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1AdminSettingsUrl = () => {


  return `/api/v1/admin/settings`
}

export const getApiV1AdminSettings = async ( options?: RequestInit): Promise<getApiV1AdminSettingsResponse> => {
return customFetch<Promise<getApiV1AdminSettingsResponse>>(getGetApiV1AdminSettingsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminSettingsResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminSettingsUrl = () => {


  return `/api/v1/admin/settings`
}

export const postApiV1AdminSettings = async (setSettingReq: SetSettingReq, options?: RequestInit): Promise<postApiV1AdminSettingsResponse> => {
return customFetch<Promise<postApiV1AdminSettingsResponse>>(getPostApiV1AdminSettingsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      setSettingReq,)
  }
);}


export type getApiV1DictKktuResponse = {
  data: void;
  status: number;
}

export const getGetApiV1DictKktuUrl = (params?: GetApiV1DictKktuParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/dict/kktu?${normalizedParams.toString()}`
}

export const getApiV1DictKktu = async (params?: GetApiV1DictKktuParams, options?: RequestInit): Promise<getApiV1DictKktuResponse> => {
return customFetch<Promise<getApiV1DictKktuResponse>>(getGetApiV1DictKktuUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type deleteApiV1DictKktuResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1DictKktuUrl = () => {


  return `/api/v1/dict/kktu`
}

export const deleteApiV1DictKktu = async ( options?: RequestInit): Promise<deleteApiV1DictKktuResponse> => {
return customFetch<Promise<deleteApiV1DictKktuResponse>>(getDeleteApiV1DictKktuUrl(),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type postApiV1DictKktuSeedResponse = {
  data: void;
  status: number;
}

export const getPostApiV1DictKktuSeedUrl = () => {


  return `/api/v1/dict/kktu/seed`
}

export const postApiV1DictKktuSeed = async (seedKktuRequest: SeedKktuRequest, options?: RequestInit): Promise<postApiV1DictKktuSeedResponse> => {
return customFetch<Promise<postApiV1DictKktuSeedResponse>>(getPostApiV1DictKktuSeedUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      seedKktuRequest,)
  }
);}


export type getApiV1DictKktuCountResponse = {
  data: void;
  status: number;
}

export const getGetApiV1DictKktuCountUrl = () => {


  return `/api/v1/dict/kktu/count`
}

export const getApiV1DictKktuCount = async ( options?: RequestInit): Promise<getApiV1DictKktuCountResponse> => {
return customFetch<Promise<getApiV1DictKktuCountResponse>>(getGetApiV1DictKktuCountUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1DictKktuBulkResponse = {
  data: void;
  status: number;
}

export const getPostApiV1DictKktuBulkUrl = () => {


  return `/api/v1/dict/kktu/bulk`
}

export const postApiV1DictKktuBulk = async (bulkUpsertKktuRequest: BulkUpsertKktuRequest, options?: RequestInit): Promise<postApiV1DictKktuBulkResponse> => {
return customFetch<Promise<postApiV1DictKktuBulkResponse>>(getPostApiV1DictKktuBulkUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      bulkUpsertKktuRequest,)
  }
);}


export type deleteApiV1DictKktuGarbageResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1DictKktuGarbageUrl = () => {


  return `/api/v1/dict/kktu/garbage`
}

export const deleteApiV1DictKktuGarbage = async ( options?: RequestInit): Promise<deleteApiV1DictKktuGarbageResponse> => {
return customFetch<Promise<deleteApiV1DictKktuGarbageResponse>>(getDeleteApiV1DictKktuGarbageUrl(),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type postApiV1ContentGenerateEridResponse = {
  data: GenerateEridResponse;
  status: number;
}

export const getPostApiV1ContentGenerateEridUrl = () => {


  return `/api/v1/content/generate-erid`
}

export const postApiV1ContentGenerateErid = async (generateEridRequest: GenerateEridRequest, options?: RequestInit): Promise<postApiV1ContentGenerateEridResponse> => {
return customFetch<Promise<postApiV1ContentGenerateEridResponse>>(getPostApiV1ContentGenerateEridUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      generateEridRequest,)
  }
);}


export type postApiV1UsersOnboardingResponse = {
  data: void;
  status: number;
}

export const getPostApiV1UsersOnboardingUrl = (params?: PostApiV1UsersOnboardingParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/users/onboarding?${normalizedParams.toString()}`
}

export const postApiV1UsersOnboarding = async (onboardingPayload: OnboardingPayload,
    params?: PostApiV1UsersOnboardingParams, options?: RequestInit): Promise<postApiV1UsersOnboardingResponse> => {
return customFetch<Promise<postApiV1UsersOnboardingResponse>>(getPostApiV1UsersOnboardingUrl(params),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      onboardingPayload,)
  }
);}


export type postApiV1UsersOnboardingSelfPromotionResponse = {
  data: void;
  status: number;
}

export const getPostApiV1UsersOnboardingSelfPromotionUrl = (params?: PostApiV1UsersOnboardingSelfPromotionParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/users/onboarding-self-promotion?${normalizedParams.toString()}`
}

export const postApiV1UsersOnboardingSelfPromotion = async (onboardingPayload: OnboardingPayload,
    params?: PostApiV1UsersOnboardingSelfPromotionParams, options?: RequestInit): Promise<postApiV1UsersOnboardingSelfPromotionResponse> => {
return customFetch<Promise<postApiV1UsersOnboardingSelfPromotionResponse>>(getPostApiV1UsersOnboardingSelfPromotionUrl(params),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      onboardingPayload,)
  }
);}


export type getApiV1OrdAddressCorrectResponse = {
  data: AddressCorrectResponse;
  status: number;
}

export const getGetApiV1OrdAddressCorrectUrl = (params: GetApiV1OrdAddressCorrectParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/address/correct?${normalizedParams.toString()}`
}

export const getApiV1OrdAddressCorrect = async (params: GetApiV1OrdAddressCorrectParams, options?: RequestInit): Promise<getApiV1OrdAddressCorrectResponse> => {
return customFetch<Promise<getApiV1OrdAddressCorrectResponse>>(getGetApiV1OrdAddressCorrectUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdContractsListResponse = {
  data: ContractsListResponse;
  status: number;
}

export const getGetApiV1OrdContractsListUrl = (params?: GetApiV1OrdContractsListParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/contracts/list?${normalizedParams.toString()}`
}

export const getApiV1OrdContractsList = async (params?: GetApiV1OrdContractsListParams, options?: RequestInit): Promise<getApiV1OrdContractsListResponse> => {
return customFetch<Promise<getApiV1OrdContractsListResponse>>(getGetApiV1OrdContractsListUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdContractsResponse = {
  data: unknown[];
  status: number;
}

export const getGetApiV1OrdContractsUrl = () => {


  return `/api/v1/ord/contracts`
}

export const getApiV1OrdContracts = async ( options?: RequestInit): Promise<getApiV1OrdContractsResponse> => {
return customFetch<Promise<getApiV1OrdContractsResponse>>(getGetApiV1OrdContractsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ContractsCreateResponse = {
  data: ContractCreateResponse;
  status: number;
}

export const getPostApiV1ContractsCreateUrl = (params?: PostApiV1ContractsCreateParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/contracts/create?${normalizedParams.toString()}`
}

export const postApiV1ContractsCreate = async (createContractLocalRequest: CreateContractLocalRequest,
    params?: PostApiV1ContractsCreateParams, options?: RequestInit): Promise<postApiV1ContractsCreateResponse> => {
return customFetch<Promise<postApiV1ContractsCreateResponse>>(getPostApiV1ContractsCreateUrl(params),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createContractLocalRequest,)
  }
);}


export type postApiV1ContractsExternalIdCreateCidResponse = {
  data: unknown;
  status: number;
}

export const getPostApiV1ContractsExternalIdCreateCidUrl = (externalId: string,
    params?: PostApiV1ContractsExternalIdCreateCidParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/contracts/${externalId}/create-cid?${normalizedParams.toString()}`
}

export const postApiV1ContractsExternalIdCreateCid = async (externalId: string,
    params?: PostApiV1ContractsExternalIdCreateCidParams, options?: RequestInit): Promise<postApiV1ContractsExternalIdCreateCidResponse> => {
return customFetch<Promise<postApiV1ContractsExternalIdCreateCidResponse>>(getPostApiV1ContractsExternalIdCreateCidUrl(externalId,params),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1ContractsStoreResponse = {
  data: ContractStoreResponse;
  status: number;
}

export const getPostApiV1ContractsStoreUrl = () => {


  return `/api/v1/contracts/store`
}

export const postApiV1ContractsStore = async (storeContractReq: StoreContractReq, options?: RequestInit): Promise<postApiV1ContractsStoreResponse> => {
return customFetch<Promise<postApiV1ContractsStoreResponse>>(getPostApiV1ContractsStoreUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      storeContractReq,)
  }
);}


export type getApiV1ContractsListResponse = {
  data: ContractLocalListResponse;
  status: number;
}

export const getGetApiV1ContractsListUrl = () => {


  return `/api/v1/contracts/list`
}

export const getApiV1ContractsList = async ( options?: RequestInit): Promise<getApiV1ContractsListResponse> => {
return customFetch<Promise<getApiV1ContractsListResponse>>(getGetApiV1ContractsListUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ContractsContractIdAddendumsResponse = {
  data: AddendumDto;
  status: number;
}

export const getPostApiV1ContractsContractIdAddendumsUrl = (contractId: string,) => {


  return `/api/v1/contracts/${contractId}/addendums`
}

export const postApiV1ContractsContractIdAddendums = async (contractId: string,
    addendumCreateRequest: AddendumCreateRequest, options?: RequestInit): Promise<postApiV1ContractsContractIdAddendumsResponse> => {
return customFetch<Promise<postApiV1ContractsContractIdAddendumsResponse>>(getPostApiV1ContractsContractIdAddendumsUrl(contractId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      addendumCreateRequest,)
  }
);}


export type getApiV1ContractsContractIdAddendumsResponse = {
  data: AddendumsListResponse;
  status: number;
}

export const getGetApiV1ContractsContractIdAddendumsUrl = (contractId: string,) => {


  return `/api/v1/contracts/${contractId}/addendums`
}

export const getApiV1ContractsContractIdAddendums = async (contractId: string, options?: RequestInit): Promise<getApiV1ContractsContractIdAddendumsResponse> => {
return customFetch<Promise<getApiV1ContractsContractIdAddendumsResponse>>(getGetApiV1ContractsContractIdAddendumsUrl(contractId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type putApiV1ContractsContractIdAddendumsIdResponse = {
  data: OkResponse;
  status: number;
}

export const getPutApiV1ContractsContractIdAddendumsIdUrl = (contractId: string,
    id: string,) => {


  return `/api/v1/contracts/${contractId}/addendums/${id}`
}

export const putApiV1ContractsContractIdAddendumsId = async (contractId: string,
    id: string,
    addendumUpdateRequest: AddendumUpdateRequest, options?: RequestInit): Promise<putApiV1ContractsContractIdAddendumsIdResponse> => {
return customFetch<Promise<putApiV1ContractsContractIdAddendumsIdResponse>>(getPutApiV1ContractsContractIdAddendumsIdUrl(contractId,id),
  {      
    ...options,
    method: 'PUT',
    body: JSON.stringify(
      addendumUpdateRequest,)
  }
);}


export type deleteApiV1ContractsContractIdAddendumsIdResponse = {
  data: OkResponse;
  status: number;
}

export const getDeleteApiV1ContractsContractIdAddendumsIdUrl = (contractId: string,
    id: string,) => {


  return `/api/v1/contracts/${contractId}/addendums/${id}`
}

export const deleteApiV1ContractsContractIdAddendumsId = async (contractId: string,
    id: string, options?: RequestInit): Promise<deleteApiV1ContractsContractIdAddendumsIdResponse> => {
return customFetch<Promise<deleteApiV1ContractsContractIdAddendumsIdResponse>>(getDeleteApiV1ContractsContractIdAddendumsIdUrl(contractId,id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1ProfileContractResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ProfileContractUrl = () => {


  return `/api/v1/profile/contract`
}

export const getApiV1ProfileContract = async ( options?: RequestInit): Promise<getApiV1ProfileContractResponse> => {
return customFetch<Promise<getApiV1ProfileContractResponse>>(getGetApiV1ProfileContractUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ProfileContractResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ProfileContractUrl = () => {


  return `/api/v1/profile/contract`
}

export const postApiV1ProfileContract = async (setSelectedContractReq: SetSelectedContractReq, options?: RequestInit): Promise<postApiV1ProfileContractResponse> => {
return customFetch<Promise<postApiV1ProfileContractResponse>>(getPostApiV1ProfileContractUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      setSelectedContractReq,)
  }
);}


export type getApiV1ProfileKktuResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ProfileKktuUrl = () => {


  return `/api/v1/profile/kktu`
}

export const getApiV1ProfileKktu = async ( options?: RequestInit): Promise<getApiV1ProfileKktuResponse> => {
return customFetch<Promise<getApiV1ProfileKktuResponse>>(getGetApiV1ProfileKktuUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1OrdSyncContractsResponse = {
  data: void;
  status: number;
}

export const getPostApiV1OrdSyncContractsUrl = (params?: PostApiV1OrdSyncContractsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/sync/contracts?${normalizedParams.toString()}`
}

export const postApiV1OrdSyncContracts = async (params?: PostApiV1OrdSyncContractsParams, options?: RequestInit): Promise<postApiV1OrdSyncContractsResponse> => {
return customFetch<Promise<postApiV1OrdSyncContractsResponse>>(getPostApiV1OrdSyncContractsUrl(params),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1OrdSyncCounterpartiesResponse = {
  data: void;
  status: number;
}

export const getPostApiV1OrdSyncCounterpartiesUrl = (params?: PostApiV1OrdSyncCounterpartiesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/sync/counterparties?${normalizedParams.toString()}`
}

export const postApiV1OrdSyncCounterparties = async (params?: PostApiV1OrdSyncCounterpartiesParams, options?: RequestInit): Promise<postApiV1OrdSyncCounterpartiesResponse> => {
return customFetch<Promise<postApiV1OrdSyncCounterpartiesResponse>>(getPostApiV1OrdSyncCounterpartiesUrl(params),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1OrdSyncPostsFromCreativesResponse = {
  data: void;
  status: number;
}

export const getPostApiV1OrdSyncPostsFromCreativesUrl = (params?: PostApiV1OrdSyncPostsFromCreativesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/sync/posts-from-creatives?${normalizedParams.toString()}`
}

export const postApiV1OrdSyncPostsFromCreatives = async (params?: PostApiV1OrdSyncPostsFromCreativesParams, options?: RequestInit): Promise<postApiV1OrdSyncPostsFromCreativesResponse> => {
return customFetch<Promise<postApiV1OrdSyncPostsFromCreativesResponse>>(getPostApiV1OrdSyncPostsFromCreativesUrl(params),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getApiV1OrdCounterpartiesResponse = {
  data: CounterpartiesIdsResponse;
  status: number;
}

export const getGetApiV1OrdCounterpartiesUrl = (params?: GetApiV1OrdCounterpartiesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/counterparties?${normalizedParams.toString()}`
}

export const getApiV1OrdCounterparties = async (params?: GetApiV1OrdCounterpartiesParams, options?: RequestInit): Promise<getApiV1OrdCounterpartiesResponse> => {
return customFetch<Promise<getApiV1OrdCounterpartiesResponse>>(getGetApiV1OrdCounterpartiesUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdCounterpartiesListResponse = {
  data: CounterpartiesListResponse;
  status: number;
}

export const getGetApiV1OrdCounterpartiesListUrl = (params?: GetApiV1OrdCounterpartiesListParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/counterparties/list?${normalizedParams.toString()}`
}

export const getApiV1OrdCounterpartiesList = async (params?: GetApiV1OrdCounterpartiesListParams, options?: RequestInit): Promise<getApiV1OrdCounterpartiesListResponse> => {
return customFetch<Promise<getApiV1OrdCounterpartiesListResponse>>(getGetApiV1OrdCounterpartiesListUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1OrdProvidersProviderTokenResponse = {
  data: void;
  status: number;
}

export const getPostApiV1OrdProvidersProviderTokenUrl = (provider: string,) => {


  return `/api/v1/ord/providers/${provider}/token`
}

export const postApiV1OrdProvidersProviderToken = async (provider: string,
    setProviderTokenRequest: SetProviderTokenRequest, options?: RequestInit): Promise<postApiV1OrdProvidersProviderTokenResponse> => {
return customFetch<Promise<postApiV1OrdProvidersProviderTokenResponse>>(getPostApiV1OrdProvidersProviderTokenUrl(provider),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      setProviderTokenRequest,)
  }
);}


export type deleteApiV1OrdProvidersProviderTokenResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1OrdProvidersProviderTokenUrl = (provider: string,) => {


  return `/api/v1/ord/providers/${provider}/token`
}

export const deleteApiV1OrdProvidersProviderToken = async (provider: string, options?: RequestInit): Promise<deleteApiV1OrdProvidersProviderTokenResponse> => {
return customFetch<Promise<deleteApiV1OrdProvidersProviderTokenResponse>>(getDeleteApiV1OrdProvidersProviderTokenUrl(provider),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1OrdProvidersProviderTokenStatusResponse = {
  data: void;
  status: number;
}

export const getGetApiV1OrdProvidersProviderTokenStatusUrl = (provider: string,) => {


  return `/api/v1/ord/providers/${provider}/token/status`
}

export const getApiV1OrdProvidersProviderTokenStatus = async (provider: string, options?: RequestInit): Promise<getApiV1OrdProvidersProviderTokenStatusResponse> => {
return customFetch<Promise<getApiV1OrdProvidersProviderTokenStatusResponse>>(getGetApiV1OrdProvidersProviderTokenStatusUrl(provider),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdProvidersProviderTokenTestResponse = {
  data: void;
  status: number;
}

export const getGetApiV1OrdProvidersProviderTokenTestUrl = (provider: string,) => {


  return `/api/v1/ord/providers/${provider}/token/test`
}

export const getApiV1OrdProvidersProviderTokenTest = async (provider: string, options?: RequestInit): Promise<getApiV1OrdProvidersProviderTokenTestResponse> => {
return customFetch<Promise<getApiV1OrdProvidersProviderTokenTestResponse>>(getGetApiV1OrdProvidersProviderTokenTestUrl(provider),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1OrdProvidersProviderTokenVerifyResponse = {
  data: void;
  status: number;
}

export const getPostApiV1OrdProvidersProviderTokenVerifyUrl = (provider: string,) => {


  return `/api/v1/ord/providers/${provider}/token/verify`
}

export const postApiV1OrdProvidersProviderTokenVerify = async (provider: string,
    setProviderTokenRequest: SetProviderTokenRequest, options?: RequestInit): Promise<postApiV1OrdProvidersProviderTokenVerifyResponse> => {
return customFetch<Promise<postApiV1OrdProvidersProviderTokenVerifyResponse>>(getPostApiV1OrdProvidersProviderTokenVerifyUrl(provider),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      setProviderTokenRequest,)
  }
);}


export type postApiV1OrdProvidersProviderTokenCheckResponse = {
  data: void;
  status: number;
}

export const getPostApiV1OrdProvidersProviderTokenCheckUrl = (provider: string,) => {


  return `/api/v1/ord/providers/${provider}/token/check`
}

export const postApiV1OrdProvidersProviderTokenCheck = async (provider: string,
    setProviderTokenRequest: SetProviderTokenRequest, options?: RequestInit): Promise<postApiV1OrdProvidersProviderTokenCheckResponse> => {
return customFetch<Promise<postApiV1OrdProvidersProviderTokenCheckResponse>>(getPostApiV1OrdProvidersProviderTokenCheckUrl(provider),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      setProviderTokenRequest,)
  }
);}


export type getApiV1OrdProvidersResponse = {
  data: void;
  status: number;
}

export const getGetApiV1OrdProvidersUrl = () => {


  return `/api/v1/ord/providers`
}

export const getApiV1OrdProviders = async ( options?: RequestInit): Promise<getApiV1OrdProvidersResponse> => {
return customFetch<Promise<getApiV1OrdProvidersResponse>>(getGetApiV1OrdProvidersUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type putApiV1OrdProvidersPreferredResponse = {
  data: void;
  status: number;
}

export const getPutApiV1OrdProvidersPreferredUrl = () => {


  return `/api/v1/ord/providers/preferred`
}

export const putApiV1OrdProvidersPreferred = async (setPreferredProviderRequest: SetPreferredProviderRequest, options?: RequestInit): Promise<putApiV1OrdProvidersPreferredResponse> => {
return customFetch<Promise<putApiV1OrdProvidersPreferredResponse>>(getPutApiV1OrdProvidersPreferredUrl(),
  {      
    ...options,
    method: 'PUT',
    body: JSON.stringify(
      setPreferredProviderRequest,)
  }
);}


export type postApiV1ChannelsConnectResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ChannelsConnectUrl = (params?: PostApiV1ChannelsConnectParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/channels/connect?${normalizedParams.toString()}`
}

export const postApiV1ChannelsConnect = async (connectChannelRequest: ConnectChannelRequest,
    params?: PostApiV1ChannelsConnectParams, options?: RequestInit): Promise<postApiV1ChannelsConnectResponse> => {
return customFetch<Promise<postApiV1ChannelsConnectResponse>>(getPostApiV1ChannelsConnectUrl(params),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      connectChannelRequest,)
  }
);}


export type getApiV1ChannelsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ChannelsUrl = () => {


  return `/api/v1/channels`
}

export const getApiV1Channels = async ( options?: RequestInit): Promise<getApiV1ChannelsResponse> => {
return customFetch<Promise<getApiV1ChannelsResponse>>(getGetApiV1ChannelsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type deleteApiV1ChannelsIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1ChannelsIdUrl = (id: string,) => {


  return `/api/v1/channels/${id}`
}

export const deleteApiV1ChannelsId = async (id: string, options?: RequestInit): Promise<deleteApiV1ChannelsIdResponse> => {
return customFetch<Promise<deleteApiV1ChannelsIdResponse>>(getDeleteApiV1ChannelsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1OrdReachDraftMonthResponse = {
  data: void;
  status: number;
}

export const getGetApiV1OrdReachDraftMonthUrl = (month: string,) => {


  return `/api/v1/ord/reach/draft/${month}`
}

export const getApiV1OrdReachDraftMonth = async (month: string, options?: RequestInit): Promise<getApiV1OrdReachDraftMonthResponse> => {
return customFetch<Promise<getApiV1OrdReachDraftMonthResponse>>(getGetApiV1OrdReachDraftMonthUrl(month),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdReachDraftsMonthResponse = {
  data: void;
  status: number;
}

export const getGetApiV1OrdReachDraftsMonthUrl = (month: string,) => {


  return `/api/v1/ord/reach/drafts/${month}`
}

export const getApiV1OrdReachDraftsMonth = async (month: string, options?: RequestInit): Promise<getApiV1OrdReachDraftsMonthResponse> => {
return customFetch<Promise<getApiV1OrdReachDraftsMonthResponse>>(getGetApiV1OrdReachDraftsMonthUrl(month),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1OrdReachDraftsMonthResponse = {
  data: void;
  status: number;
}

export const getPostApiV1OrdReachDraftsMonthUrl = (month: string,) => {


  return `/api/v1/ord/reach/drafts/${month}`
}

export const postApiV1OrdReachDraftsMonth = async (month: string,
    postApiV1OrdReachDraftsMonthBody: PostApiV1OrdReachDraftsMonthBody, options?: RequestInit): Promise<postApiV1OrdReachDraftsMonthResponse> => {
return customFetch<Promise<postApiV1OrdReachDraftsMonthResponse>>(getPostApiV1OrdReachDraftsMonthUrl(month),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      postApiV1OrdReachDraftsMonthBody,)
  }
);}


export type postApiV1OrdReachDraftsMonthSubmitResponse = {
  data: void;
  status: number;
}

export const getPostApiV1OrdReachDraftsMonthSubmitUrl = (month: string,) => {


  return `/api/v1/ord/reach/drafts/${month}/submit`
}

export const postApiV1OrdReachDraftsMonthSubmit = async (month: string, options?: RequestInit): Promise<postApiV1OrdReachDraftsMonthSubmitResponse> => {
return customFetch<Promise<postApiV1OrdReachDraftsMonthSubmitResponse>>(getPostApiV1OrdReachDraftsMonthSubmitUrl(month),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getApiV1OrdInvoicesResponse = {
  data: void;
  status: number;
}

export const getGetApiV1OrdInvoicesUrl = (params?: GetApiV1OrdInvoicesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/invoices?${normalizedParams.toString()}`
}

export const getApiV1OrdInvoices = async (params?: GetApiV1OrdInvoicesParams, options?: RequestInit): Promise<getApiV1OrdInvoicesResponse> => {
return customFetch<Promise<getApiV1OrdInvoicesResponse>>(getGetApiV1OrdInvoicesUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1OrdInvoicesExternalIdLinkStatisticsResponse = {
  data: void;
  status: number;
}

export const getPostApiV1OrdInvoicesExternalIdLinkStatisticsUrl = (externalId: string,) => {


  return `/api/v1/ord/invoices/${externalId}/link-statistics`
}

export const postApiV1OrdInvoicesExternalIdLinkStatistics = async (externalId: string,
    linkInvoiceBody: LinkInvoiceBody, options?: RequestInit): Promise<postApiV1OrdInvoicesExternalIdLinkStatisticsResponse> => {
return customFetch<Promise<postApiV1OrdInvoicesExternalIdLinkStatisticsResponse>>(getPostApiV1OrdInvoicesExternalIdLinkStatisticsUrl(externalId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      linkInvoiceBody,)
  }
);}


export type postApiV1ActsCreateResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ActsCreateUrl = (params?: PostApiV1ActsCreateParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/acts/create?${normalizedParams.toString()}`
}

export const postApiV1ActsCreate = async (createActLocalRequest: CreateActLocalRequest,
    params?: PostApiV1ActsCreateParams, options?: RequestInit): Promise<postApiV1ActsCreateResponse> => {
return customFetch<Promise<postApiV1ActsCreateResponse>>(getPostApiV1ActsCreateUrl(params),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createActLocalRequest,)
  }
);}


export type deleteApiV1ActsExternalIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1ActsExternalIdUrl = (externalId: string,
    params?: DeleteApiV1ActsExternalIdParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/acts/${externalId}?${normalizedParams.toString()}`
}

export const deleteApiV1ActsExternalId = async (externalId: string,
    params?: DeleteApiV1ActsExternalIdParams, options?: RequestInit): Promise<deleteApiV1ActsExternalIdResponse> => {
return customFetch<Promise<deleteApiV1ActsExternalIdResponse>>(getDeleteApiV1ActsExternalIdUrl(externalId,params),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type postApiV1ActsBatchDeleteResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ActsBatchDeleteUrl = (params?: PostApiV1ActsBatchDeleteParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/acts/batch-delete?${normalizedParams.toString()}`
}

export const postApiV1ActsBatchDelete = async (batchDeleteActsRequest: BatchDeleteActsRequest,
    params?: PostApiV1ActsBatchDeleteParams, options?: RequestInit): Promise<postApiV1ActsBatchDeleteResponse> => {
return customFetch<Promise<postApiV1ActsBatchDeleteResponse>>(getPostApiV1ActsBatchDeleteUrl(params),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      batchDeleteActsRequest,)
  }
);}


export type getApiV1OrdInvoicesExternalIdResponse = {
  data: InvoiceHeaderDto;
  status: number;
}

export const getGetApiV1OrdInvoicesExternalIdUrl = (externalId: string,
    params?: GetApiV1OrdInvoicesExternalIdParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/invoices/${externalId}?${normalizedParams.toString()}`
}

export const getApiV1OrdInvoicesExternalId = async (externalId: string,
    params?: GetApiV1OrdInvoicesExternalIdParams, options?: RequestInit): Promise<getApiV1OrdInvoicesExternalIdResponse> => {
return customFetch<Promise<getApiV1OrdInvoicesExternalIdResponse>>(getGetApiV1OrdInvoicesExternalIdUrl(externalId,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ActsExternalIdSendToErirResponse = {
  data: SendActToErirResponse;
  status: number;
}

export const getPostApiV1ActsExternalIdSendToErirUrl = (externalId: string,
    params?: PostApiV1ActsExternalIdSendToErirParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/acts/${externalId}/send-to-erir?${normalizedParams.toString()}`
}

export const postApiV1ActsExternalIdSendToErir = async (externalId: string,
    params?: PostApiV1ActsExternalIdSendToErirParams, options?: RequestInit): Promise<postApiV1ActsExternalIdSendToErirResponse> => {
return customFetch<Promise<postApiV1ActsExternalIdSendToErirResponse>>(getPostApiV1ActsExternalIdSendToErirUrl(externalId,params),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getApiV1OnboardingStateResponse = {
  data: void;
  status: number;
}

export const getGetApiV1OnboardingStateUrl = () => {


  return `/api/v1/onboarding/state`
}

export const getApiV1OnboardingState = async ( options?: RequestInit): Promise<getApiV1OnboardingStateResponse> => {
return customFetch<Promise<getApiV1OnboardingStateResponse>>(getGetApiV1OnboardingStateUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1OnboardingStateResponse = {
  data: void;
  status: number;
}

export const getPostApiV1OnboardingStateUrl = () => {


  return `/api/v1/onboarding/state`
}

export const postApiV1OnboardingState = async (onboardingStateUpdateReq: OnboardingStateUpdateReq, options?: RequestInit): Promise<postApiV1OnboardingStateResponse> => {
return customFetch<Promise<postApiV1OnboardingStateResponse>>(getPostApiV1OnboardingStateUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      onboardingStateUpdateReq,)
  }
);}


export type postApiV1AdminUsersUtmBatchResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminUsersUtmBatchUrl = () => {


  return `/api/v1/admin/users/utm-batch`
}

export const postApiV1AdminUsersUtmBatch = async (utmBatchRequest: UtmBatchRequest, options?: RequestInit): Promise<postApiV1AdminUsersUtmBatchResponse> => {
return customFetch<Promise<postApiV1AdminUsersUtmBatchResponse>>(getPostApiV1AdminUsersUtmBatchUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      utmBatchRequest,)
  }
);}


export type deleteApiV1UsersMeResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1UsersMeUrl = () => {


  return `/api/v1/users/me`
}

export const deleteApiV1UsersMe = async ( options?: RequestInit): Promise<deleteApiV1UsersMeResponse> => {
return customFetch<Promise<deleteApiV1UsersMeResponse>>(getDeleteApiV1UsersMeUrl(),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1AdminTgMtAccountsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1AdminTgMtAccountsUrl = () => {


  return `/api/v1/admin/tg/mt-accounts`
}

export const getApiV1AdminTgMtAccounts = async ( options?: RequestInit): Promise<getApiV1AdminTgMtAccountsResponse> => {
return customFetch<Promise<getApiV1AdminTgMtAccountsResponse>>(getGetApiV1AdminTgMtAccountsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminTgMtAccountsStartLoginResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminTgMtAccountsStartLoginUrl = () => {


  return `/api/v1/admin/tg/mt-accounts/start-login`
}

export const postApiV1AdminTgMtAccountsStartLogin = async (startLoginRequest: StartLoginRequest, options?: RequestInit): Promise<postApiV1AdminTgMtAccountsStartLoginResponse> => {
return customFetch<Promise<postApiV1AdminTgMtAccountsStartLoginResponse>>(getPostApiV1AdminTgMtAccountsStartLoginUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      startLoginRequest,)
  }
);}


export type postApiV1AdminTgMtAccountsIdActivateResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminTgMtAccountsIdActivateUrl = (id: string,) => {


  return `/api/v1/admin/tg/mt-accounts/${id}/activate`
}

export const postApiV1AdminTgMtAccountsIdActivate = async (id: string, options?: RequestInit): Promise<postApiV1AdminTgMtAccountsIdActivateResponse> => {
return customFetch<Promise<postApiV1AdminTgMtAccountsIdActivateResponse>>(getPostApiV1AdminTgMtAccountsIdActivateUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1AdminTgMtAccountsIdDeactivateResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminTgMtAccountsIdDeactivateUrl = (id: string,) => {


  return `/api/v1/admin/tg/mt-accounts/${id}/deactivate`
}

export const postApiV1AdminTgMtAccountsIdDeactivate = async (id: string, options?: RequestInit): Promise<postApiV1AdminTgMtAccountsIdDeactivateResponse> => {
return customFetch<Promise<postApiV1AdminTgMtAccountsIdDeactivateResponse>>(getPostApiV1AdminTgMtAccountsIdDeactivateUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type deleteApiV1AdminTgMtAccountsIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1AdminTgMtAccountsIdUrl = (id: string,) => {


  return `/api/v1/admin/tg/mt-accounts/${id}`
}

export const deleteApiV1AdminTgMtAccountsId = async (id: string, options?: RequestInit): Promise<deleteApiV1AdminTgMtAccountsIdResponse> => {
return customFetch<Promise<deleteApiV1AdminTgMtAccountsIdResponse>>(getDeleteApiV1AdminTgMtAccountsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1AdminTgMtAccountsIdStatsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1AdminTgMtAccountsIdStatsUrl = (id: string,
    params?: GetApiV1AdminTgMtAccountsIdStatsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/tg/mt-accounts/${id}/stats?${normalizedParams.toString()}`
}

export const getApiV1AdminTgMtAccountsIdStats = async (id: string,
    params?: GetApiV1AdminTgMtAccountsIdStatsParams, options?: RequestInit): Promise<getApiV1AdminTgMtAccountsIdStatsResponse> => {
return customFetch<Promise<getApiV1AdminTgMtAccountsIdStatsResponse>>(getGetApiV1AdminTgMtAccountsIdStatsUrl(id,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type initiateTelegramConnectionResponse = {
  data: void;
  status: number;
}

export const getInitiateTelegramConnectionUrl = () => {


  return `/api/v1/telegram/connect`
}

export const initiateTelegramConnection = async ( options?: RequestInit): Promise<initiateTelegramConnectionResponse> => {
return customFetch<Promise<initiateTelegramConnectionResponse>>(getInitiateTelegramConnectionUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getTelegramStatusResponse = {
  data: void;
  status: number;
}

export const getGetTelegramStatusUrl = () => {


  return `/api/v1/telegram/status`
}

export const getTelegramStatus = async ( options?: RequestInit): Promise<getTelegramStatusResponse> => {
return customFetch<Promise<getTelegramStatusResponse>>(getGetTelegramStatusUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type disconnectTelegramResponse = {
  data: void;
  status: number;
}

export const getDisconnectTelegramUrl = () => {


  return `/api/v1/telegram/disconnect`
}

export const disconnectTelegram = async ( options?: RequestInit): Promise<disconnectTelegramResponse> => {
return customFetch<Promise<disconnectTelegramResponse>>(getDisconnectTelegramUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type sendPublicationToTelegramResponse = {
  data: void;
  status: number;
}

export const getSendPublicationToTelegramUrl = (postId: string,) => {


  return `/api/v1/telegram/send-publication/${postId}`
}

export const sendPublicationToTelegram = async (postId: string, options?: RequestInit): Promise<sendPublicationToTelegramResponse> => {
return customFetch<Promise<sendPublicationToTelegramResponse>>(getSendPublicationToTelegramUrl(postId),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type handleTelegramNotificationWebhookResponse = {
  data: void;
  status: number;
}

export const getHandleTelegramNotificationWebhookUrl = () => {


  return `/api/v1/telegram/notification-webhook`
}

export const handleTelegramNotificationWebhook = async ( options?: RequestInit): Promise<handleTelegramNotificationWebhookResponse> => {
return customFetch<Promise<handleTelegramNotificationWebhookResponse>>(getHandleTelegramNotificationWebhookUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1AccountCreateResponse = {
  data: CreateAccountResponse;
  status: number;
}

export const getPostApiV1AccountCreateUrl = () => {


  return `/api/v1/account/create`
}

export const postApiV1AccountCreate = async (createAccountRequest: CreateAccountRequest, options?: RequestInit): Promise<postApiV1AccountCreateResponse> => {
return customFetch<Promise<postApiV1AccountCreateResponse>>(getPostApiV1AccountCreateUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createAccountRequest,)
  }
);}


export type postApiV1PadsSyncFromOrdResponse = {
  data: SyncScheduledResponse;
  status: number;
}

export const getPostApiV1PadsSyncFromOrdUrl = (params?: PostApiV1PadsSyncFromOrdParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/pads/sync/from-ord?${normalizedParams.toString()}`
}

export const postApiV1PadsSyncFromOrd = async (params?: PostApiV1PadsSyncFromOrdParams, options?: RequestInit): Promise<postApiV1PadsSyncFromOrdResponse> => {
return customFetch<Promise<postApiV1PadsSyncFromOrdResponse>>(getPostApiV1PadsSyncFromOrdUrl(params),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type listMonitoringTasksResponse = {
  data: MonitoringTasksResponse;
  status: number;
}

export const getListMonitoringTasksUrl = (params?: ListMonitoringTasksParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/monitoring?${normalizedParams.toString()}`
}

export const listMonitoringTasks = async (params?: ListMonitoringTasksParams, options?: RequestInit): Promise<listMonitoringTasksResponse> => {
return customFetch<Promise<listMonitoringTasksResponse>>(getListMonitoringTasksUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type createMonitoringTaskResponse = {
  data: MonitoringTaskDto;
  status: number;
}

export const getCreateMonitoringTaskUrl = () => {


  return `/api/v1/monitoring`
}

export const createMonitoringTask = async (createMonitoringTaskRequest: CreateMonitoringTaskRequest, options?: RequestInit): Promise<createMonitoringTaskResponse> => {
return customFetch<Promise<createMonitoringTaskResponse>>(getCreateMonitoringTaskUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createMonitoringTaskRequest,)
  }
);}


export type deleteMonitoringTaskResponse = {
  data: void;
  status: number;
}

export const getDeleteMonitoringTaskUrl = (taskId: string,) => {


  return `/api/v1/monitoring/${taskId}`
}

export const deleteMonitoringTask = async (taskId: string, options?: RequestInit): Promise<deleteMonitoringTaskResponse> => {
return customFetch<Promise<deleteMonitoringTaskResponse>>(getDeleteMonitoringTaskUrl(taskId),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type previewCsvImportResponse = {
  data: CsvImportPreviewResponse;
  status: number;
}

export const getPreviewCsvImportUrl = () => {


  return `/api/v1/monitoring/import/preview`
}

export const previewCsvImport = async ( options?: RequestInit): Promise<previewCsvImportResponse> => {
return customFetch<Promise<previewCsvImportResponse>>(getPreviewCsvImportUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type confirmCsvImportResponse = {
  data: CsvImportConfirmResponse;
  status: number;
}

export const getConfirmCsvImportUrl = () => {


  return `/api/v1/monitoring/import/confirm`
}

export const confirmCsvImport = async (csvImportConfirmRequest: CsvImportConfirmRequest, options?: RequestInit): Promise<confirmCsvImportResponse> => {
return customFetch<Promise<confirmCsvImportResponse>>(getConfirmCsvImportUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      csvImportConfirmRequest,)
  }
);}


export type exportMonitoringCsvResponse = {
  data: Void;
  status: number;
}

export const getExportMonitoringCsvUrl = () => {


  return `/api/v1/monitoring/export`
}

export const exportMonitoringCsv = async ( options?: RequestInit): Promise<exportMonitoringCsvResponse> => {
return customFetch<Promise<exportMonitoringCsvResponse>>(getExportMonitoringCsvUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type downloadMonitoringTemplateResponse = {
  data: Void;
  status: number;
}

export const getDownloadMonitoringTemplateUrl = () => {


  return `/api/v1/monitoring/import/template`
}

export const downloadMonitoringTemplate = async ( options?: RequestInit): Promise<downloadMonitoringTemplateResponse> => {
return customFetch<Promise<downloadMonitoringTemplateResponse>>(getDownloadMonitoringTemplateUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getContractByExternalIdResponse = {
  data: ContractDetailsResponse;
  status: number;
}

export const getGetContractByExternalIdUrl = (externalId: string,
    params?: GetContractByExternalIdParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/contracts/${externalId}?${normalizedParams.toString()}`
}

export const getContractByExternalId = async (externalId: string,
    params?: GetContractByExternalIdParams, options?: RequestInit): Promise<getContractByExternalIdResponse> => {
return customFetch<Promise<getContractByExternalIdResponse>>(getGetContractByExternalIdUrl(externalId,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getCounterpartyByExternalIdResponse = {
  data: PersonMyResponse;
  status: number;
}

export const getGetCounterpartyByExternalIdUrl = (externalId: string,
    params?: GetCounterpartyByExternalIdParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/counterparties/${externalId}?${normalizedParams.toString()}`
}

export const getCounterpartyByExternalId = async (externalId: string,
    params?: GetCounterpartyByExternalIdParams, options?: RequestInit): Promise<getCounterpartyByExternalIdResponse> => {
return customFetch<Promise<getCounterpartyByExternalIdResponse>>(getGetCounterpartyByExternalIdUrl(externalId,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getPersonMyResponse = {
  data: PersonMyWrapperResponse;
  status: number;
}

export const getGetPersonMyUrl = (params?: GetPersonMyParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/person/my?${normalizedParams.toString()}`
}

export const getPersonMy = async (params?: GetPersonMyParams, options?: RequestInit): Promise<getPersonMyResponse> => {
return customFetch<Promise<getPersonMyResponse>>(getGetPersonMyUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type removeRrRoleFromMyCounterpartyResponse = {
  data: void;
  status: number;
}

export const getRemoveRrRoleFromMyCounterpartyUrl = () => {


  return `/api/v1/ord/counterparties/my/remove-rr-role`
}

export const removeRrRoleFromMyCounterparty = async ( options?: RequestInit): Promise<removeRrRoleFromMyCounterpartyResponse> => {
return customFetch<Promise<removeRrRoleFromMyCounterpartyResponse>>(getRemoveRrRoleFromMyCounterpartyUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getOwnCounterpartyStatusResponse = {
  data: void;
  status: number;
}

export const getGetOwnCounterpartyStatusUrl = (params?: GetOwnCounterpartyStatusParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/own-counterparty/status?${normalizedParams.toString()}`
}

export const getOwnCounterpartyStatus = async (params?: GetOwnCounterpartyStatusParams, options?: RequestInit): Promise<getOwnCounterpartyStatusResponse> => {
return customFetch<Promise<getOwnCounterpartyStatusResponse>>(getGetOwnCounterpartyStatusUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1ActsExternalIdAllocateResponse = {
  data: void;
  status: number;
}

export const getPostApiV1ActsExternalIdAllocateUrl = (externalId: string,
    params?: PostApiV1ActsExternalIdAllocateParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/acts/${externalId}/allocate?${normalizedParams.toString()}`
}

export const postApiV1ActsExternalIdAllocate = async (externalId: string,
    allocateToContractRequest: AllocateToContractRequest,
    params?: PostApiV1ActsExternalIdAllocateParams, options?: RequestInit): Promise<postApiV1ActsExternalIdAllocateResponse> => {
return customFetch<Promise<postApiV1ActsExternalIdAllocateResponse>>(getPostApiV1ActsExternalIdAllocateUrl(externalId,params),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      allocateToContractRequest,)
  }
);}


export type getApiV1ActsExternalIdSuggestAllocationResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ActsExternalIdSuggestAllocationUrl = (externalId: string,
    params?: GetApiV1ActsExternalIdSuggestAllocationParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/acts/${externalId}/suggest-allocation?${normalizedParams.toString()}`
}

export const getApiV1ActsExternalIdSuggestAllocation = async (externalId: string,
    params?: GetApiV1ActsExternalIdSuggestAllocationParams, options?: RequestInit): Promise<getApiV1ActsExternalIdSuggestAllocationResponse> => {
return customFetch<Promise<getApiV1ActsExternalIdSuggestAllocationResponse>>(getGetApiV1ActsExternalIdSuggestAllocationUrl(externalId,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1ActsExternalIdAllocationsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1ActsExternalIdAllocationsUrl = (externalId: string,
    params?: GetApiV1ActsExternalIdAllocationsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/acts/${externalId}/allocations?${normalizedParams.toString()}`
}

export const getApiV1ActsExternalIdAllocations = async (externalId: string,
    params?: GetApiV1ActsExternalIdAllocationsParams, options?: RequestInit): Promise<getApiV1ActsExternalIdAllocationsResponse> => {
return customFetch<Promise<getApiV1ActsExternalIdAllocationsResponse>>(getGetApiV1ActsExternalIdAllocationsUrl(externalId,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1CreativesResolveByEridResponse = {
  data: void;
  status: number;
}

export const getGetApiV1CreativesResolveByEridUrl = (params: GetApiV1CreativesResolveByEridParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/creatives/resolve-by-erid?${normalizedParams.toString()}`
}

export const getApiV1CreativesResolveByErid = async (params: GetApiV1CreativesResolveByEridParams, options?: RequestInit): Promise<getApiV1CreativesResolveByEridResponse> => {
return customFetch<Promise<getApiV1CreativesResolveByEridResponse>>(getGetApiV1CreativesResolveByEridUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdReachMonthResponse = {
  data: ReachListResponse;
  status: number;
}

export const getGetApiV1OrdReachMonthUrl = (month: string,
    params?: GetApiV1OrdReachMonthParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/reach/${month}?${normalizedParams.toString()}`
}

export const getApiV1OrdReachMonth = async (month: string,
    params?: GetApiV1OrdReachMonthParams, options?: RequestInit): Promise<getApiV1OrdReachMonthResponse> => {
return customFetch<Promise<getApiV1OrdReachMonthResponse>>(getGetApiV1OrdReachMonthUrl(month,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdReachMonthMissingResponse = {
  data: ReachMissingResponse;
  status: number;
}

export const getGetApiV1OrdReachMonthMissingUrl = (month: string,
    params?: GetApiV1OrdReachMonthMissingParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/reach/${month}/missing?${normalizedParams.toString()}`
}

export const getApiV1OrdReachMonthMissing = async (month: string,
    params?: GetApiV1OrdReachMonthMissingParams, options?: RequestInit): Promise<getApiV1OrdReachMonthMissingResponse> => {
return customFetch<Promise<getApiV1OrdReachMonthMissingResponse>>(getGetApiV1OrdReachMonthMissingUrl(month,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdReachAllowedMonthsResponse = {
  data: ReachAllowedMonthsResponse;
  status: number;
}

export const getGetApiV1OrdReachAllowedMonthsUrl = () => {


  return `/api/v1/ord/reach/allowed-months`
}

export const getApiV1OrdReachAllowedMonths = async ( options?: RequestInit): Promise<getApiV1OrdReachAllowedMonthsResponse> => {
return customFetch<Promise<getApiV1OrdReachAllowedMonthsResponse>>(getGetApiV1OrdReachAllowedMonthsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1OrdReachSubmitResponse = {
  data: ReachSubmitResponse;
  status: number;
}

export const getPostApiV1OrdReachSubmitUrl = () => {


  return `/api/v1/ord/reach/submit`
}

export const postApiV1OrdReachSubmit = async (reachSubmitRequest: ReachSubmitRequest, options?: RequestInit): Promise<postApiV1OrdReachSubmitResponse> => {
return customFetch<Promise<postApiV1OrdReachSubmitResponse>>(getPostApiV1OrdReachSubmitUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      reachSubmitRequest,)
  }
);}


export type postApiV1OrdStatisticsCreateResponse = {
  data: ManualStatisticResponse;
  status: number;
}

export const getPostApiV1OrdStatisticsCreateUrl = () => {


  return `/api/v1/ord/statistics/create`
}

export const postApiV1OrdStatisticsCreate = async (manualStatisticRequest: ManualStatisticRequest, options?: RequestInit): Promise<postApiV1OrdStatisticsCreateResponse> => {
return customFetch<Promise<postApiV1OrdStatisticsCreateResponse>>(getPostApiV1OrdStatisticsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      manualStatisticRequest,)
  }
);}


export type getApiV1OrdReachSubmissionsMonthResponse = {
  data: ReachSubmissionsResponse;
  status: number;
}

export const getGetApiV1OrdReachSubmissionsMonthUrl = (month: string,) => {


  return `/api/v1/ord/reach/submissions/${month}`
}

export const getApiV1OrdReachSubmissionsMonth = async (month: string, options?: RequestInit): Promise<getApiV1OrdReachSubmissionsMonthResponse> => {
return customFetch<Promise<getApiV1OrdReachSubmissionsMonthResponse>>(getGetApiV1OrdReachSubmissionsMonthUrl(month),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdReportingStatusMonthResponse = {
  data: ReportingStatusResponse;
  status: number;
}

export const getGetApiV1OrdReportingStatusMonthUrl = (month: string,
    params?: GetApiV1OrdReportingStatusMonthParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/reporting/status/${month}?${normalizedParams.toString()}`
}

export const getApiV1OrdReportingStatusMonth = async (month: string,
    params?: GetApiV1OrdReportingStatusMonthParams, options?: RequestInit): Promise<getApiV1OrdReportingStatusMonthResponse> => {
return customFetch<Promise<getApiV1OrdReportingStatusMonthResponse>>(getGetApiV1OrdReportingStatusMonthUrl(month,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1OrdStatisticsImportResponse = {
  data: StatisticsImportResult;
  status: number;
}

export const getPostApiV1OrdStatisticsImportUrl = (params?: PostApiV1OrdStatisticsImportParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/statistics/import?${normalizedParams.toString()}`
}

export const postApiV1OrdStatisticsImport = async (postApiV1OrdStatisticsImportBody: Blob,
    params?: PostApiV1OrdStatisticsImportParams, options?: RequestInit): Promise<postApiV1OrdStatisticsImportResponse> => {
return customFetch<Promise<postApiV1OrdStatisticsImportResponse>>(getPostApiV1OrdStatisticsImportUrl(params),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      postApiV1OrdStatisticsImportBody,)
  }
);}


export type getApiV1OrdStatisticsImportsResponse = {
  data: StatisticsImportListResponse;
  status: number;
}

export const getGetApiV1OrdStatisticsImportsUrl = (params: GetApiV1OrdStatisticsImportsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/ord/statistics/imports?${normalizedParams.toString()}`
}

export const getApiV1OrdStatisticsImports = async (params: GetApiV1OrdStatisticsImportsParams, options?: RequestInit): Promise<getApiV1OrdStatisticsImportsResponse> => {
return customFetch<Promise<getApiV1OrdStatisticsImportsResponse>>(getGetApiV1OrdStatisticsImportsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdStatisticsImportsIdResponse = {
  data: StatisticsImportDetailDto;
  status: number;
}

export const getGetApiV1OrdStatisticsImportsIdUrl = (id: string,) => {


  return `/api/v1/ord/statistics/imports/${id}`
}

export const getApiV1OrdStatisticsImportsId = async (id: string, options?: RequestInit): Promise<getApiV1OrdStatisticsImportsIdResponse> => {
return customFetch<Promise<getApiV1OrdStatisticsImportsIdResponse>>(getGetApiV1OrdStatisticsImportsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1OrdStatisticsImportsIdFileResponse = {
  data: void;
  status: number;
}

export const getGetApiV1OrdStatisticsImportsIdFileUrl = (id: string,) => {


  return `/api/v1/ord/statistics/imports/${id}/file`
}

export const getApiV1OrdStatisticsImportsIdFile = async (id: string, options?: RequestInit): Promise<getApiV1OrdStatisticsImportsIdFileResponse> => {
return customFetch<Promise<getApiV1OrdStatisticsImportsIdFileResponse>>(getGetApiV1OrdStatisticsImportsIdFileUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1PadsResponse = {
  data: PadsListResponse;
  status: number;
}

export const getGetApiV1PadsUrl = (params?: GetApiV1PadsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/pads?${normalizedParams.toString()}`
}

export const getApiV1Pads = async (params?: GetApiV1PadsParams, options?: RequestInit): Promise<getApiV1PadsResponse> => {
return customFetch<Promise<getApiV1PadsResponse>>(getGetApiV1PadsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1PadsResponse = {
  data: PadItemDto;
  status: number;
}

export const getPostApiV1PadsUrl = () => {


  return `/api/v1/pads`
}

export const postApiV1Pads = async (createPadRequest: CreatePadRequest, options?: RequestInit): Promise<postApiV1PadsResponse> => {
return customFetch<Promise<postApiV1PadsResponse>>(getPostApiV1PadsUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createPadRequest,)
  }
);}


export type postApiV1PadsReadinessResponse = {
  data: PadReadinessResponse;
  status: number;
}

export const getPostApiV1PadsReadinessUrl = () => {


  return `/api/v1/pads/readiness`
}

export const postApiV1PadsReadiness = async (padReadinessRequest: PadReadinessRequest, options?: RequestInit): Promise<postApiV1PadsReadinessResponse> => {
return customFetch<Promise<postApiV1PadsReadinessResponse>>(getPostApiV1PadsReadinessUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      padReadinessRequest,)
  }
);}


export type getApiV1PadsIdResponse = {
  data: PadItemDto;
  status: number;
}

export const getGetApiV1PadsIdUrl = (id: string,) => {


  return `/api/v1/pads/${id}`
}

export const getApiV1PadsId = async (id: string, options?: RequestInit): Promise<getApiV1PadsIdResponse> => {
return customFetch<Promise<getApiV1PadsIdResponse>>(getGetApiV1PadsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type putApiV1PadsIdResponse = {
  data: PadItemDto;
  status: number;
}

export const getPutApiV1PadsIdUrl = (id: string,) => {


  return `/api/v1/pads/${id}`
}

export const putApiV1PadsId = async (id: string,
    updatePadRequest: UpdatePadRequest, options?: RequestInit): Promise<putApiV1PadsIdResponse> => {
return customFetch<Promise<putApiV1PadsIdResponse>>(getPutApiV1PadsIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    body: JSON.stringify(
      updatePadRequest,)
  }
);}


export type deleteApiV1PadsIdResponse = {
  data: DeleteOkResponse;
  status: number;
}

export const getDeleteApiV1PadsIdUrl = (id: string,) => {


  return `/api/v1/pads/${id}`
}

export const deleteApiV1PadsId = async (id: string, options?: RequestInit): Promise<deleteApiV1PadsIdResponse> => {
return customFetch<Promise<deleteApiV1PadsIdResponse>>(getDeleteApiV1PadsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type postApiV1PadsResolveResponse = {
  data: ResolvePlatformResponse;
  status: number;
}

export const getPostApiV1PadsResolveUrl = () => {


  return `/api/v1/pads/resolve`
}

export const postApiV1PadsResolve = async (resolvePlatformRequest: ResolvePlatformRequest, options?: RequestInit): Promise<postApiV1PadsResolveResponse> => {
return customFetch<Promise<postApiV1PadsResolveResponse>>(getPostApiV1PadsResolveUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      resolvePlatformRequest,)
  }
);}


export type postApiV1PadsIdTelegramConnectResponse = {
  data: TelegramConnectResponse;
  status: number;
}

export const getPostApiV1PadsIdTelegramConnectUrl = (id: string,) => {


  return `/api/v1/pads/${id}/telegram/connect`
}

export const postApiV1PadsIdTelegramConnect = async (id: string, options?: RequestInit): Promise<postApiV1PadsIdTelegramConnectResponse> => {
return customFetch<Promise<postApiV1PadsIdTelegramConnectResponse>>(getPostApiV1PadsIdTelegramConnectUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getApiV1PartnerPromoCodesResponse = {
  data: void;
  status: number;
}

export const getGetApiV1PartnerPromoCodesUrl = () => {


  return `/api/v1/partner/promo-codes`
}

export const getApiV1PartnerPromoCodes = async ( options?: RequestInit): Promise<getApiV1PartnerPromoCodesResponse> => {
return customFetch<Promise<getApiV1PartnerPromoCodesResponse>>(getGetApiV1PartnerPromoCodesUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1PartnerPromoCodesResponse = {
  data: void;
  status: number;
}

export const getPostApiV1PartnerPromoCodesUrl = () => {


  return `/api/v1/partner/promo-codes`
}

export const postApiV1PartnerPromoCodes = async (createPartnerPromoCodeRequest: CreatePartnerPromoCodeRequest, options?: RequestInit): Promise<postApiV1PartnerPromoCodesResponse> => {
return customFetch<Promise<postApiV1PartnerPromoCodesResponse>>(getPostApiV1PartnerPromoCodesUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createPartnerPromoCodeRequest,)
  }
);}


export type patchApiV1PartnerPromoCodesIdResponse = {
  data: void;
  status: number;
}

export const getPatchApiV1PartnerPromoCodesIdUrl = (id: string,) => {


  return `/api/v1/partner/promo-codes/${id}`
}

export const patchApiV1PartnerPromoCodesId = async (id: string,
    updatePartnerPromoCodeRequest: UpdatePartnerPromoCodeRequest, options?: RequestInit): Promise<patchApiV1PartnerPromoCodesIdResponse> => {
return customFetch<Promise<patchApiV1PartnerPromoCodesIdResponse>>(getPatchApiV1PartnerPromoCodesIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      updatePartnerPromoCodeRequest,)
  }
);}


export type deleteApiV1PartnerPromoCodesIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1PartnerPromoCodesIdUrl = (id: string,) => {


  return `/api/v1/partner/promo-codes/${id}`
}

export const deleteApiV1PartnerPromoCodesId = async (id: string, options?: RequestInit): Promise<deleteApiV1PartnerPromoCodesIdResponse> => {
return customFetch<Promise<deleteApiV1PartnerPromoCodesIdResponse>>(getDeleteApiV1PartnerPromoCodesIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type activatePartnerResponse = {
  data: void;
  status: number;
}

export const getActivatePartnerUrl = () => {


  return `/api/v1/partners/activate`
}

export const activatePartner = async (activatePartnerRequest: ActivatePartnerRequest, options?: RequestInit): Promise<activatePartnerResponse> => {
return customFetch<Promise<activatePartnerResponse>>(getActivatePartnerUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      activatePartnerRequest,)
  }
);}


export type getApiV1PartnersDashboardResponse = {
  data: void;
  status: number;
}

export const getGetApiV1PartnersDashboardUrl = () => {


  return `/api/v1/partners/dashboard`
}

export const getApiV1PartnersDashboard = async ( options?: RequestInit): Promise<getApiV1PartnersDashboardResponse> => {
return customFetch<Promise<getApiV1PartnersDashboardResponse>>(getGetApiV1PartnersDashboardUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1PartnersClientsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1PartnersClientsUrl = (params?: GetApiV1PartnersClientsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/partners/clients?${normalizedParams.toString()}`
}

export const getApiV1PartnersClients = async (params?: GetApiV1PartnersClientsParams, options?: RequestInit): Promise<getApiV1PartnersClientsResponse> => {
return customFetch<Promise<getApiV1PartnersClientsResponse>>(getGetApiV1PartnersClientsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1PartnersCommissionsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1PartnersCommissionsUrl = (params?: GetApiV1PartnersCommissionsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/partners/commissions?${normalizedParams.toString()}`
}

export const getApiV1PartnersCommissions = async (params?: GetApiV1PartnersCommissionsParams, options?: RequestInit): Promise<getApiV1PartnersCommissionsResponse> => {
return customFetch<Promise<getApiV1PartnersCommissionsResponse>>(getGetApiV1PartnersCommissionsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1PartnersPayoutsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1PartnersPayoutsUrl = (params?: GetApiV1PartnersPayoutsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/partners/payouts?${normalizedParams.toString()}`
}

export const getApiV1PartnersPayouts = async (params?: GetApiV1PartnersPayoutsParams, options?: RequestInit): Promise<getApiV1PartnersPayoutsResponse> => {
return customFetch<Promise<getApiV1PartnersPayoutsResponse>>(getGetApiV1PartnersPayoutsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type requestPartnerPayoutResponse = {
  data: void;
  status: number;
}

export const getRequestPartnerPayoutUrl = () => {


  return `/api/v1/partners/payouts/request`
}

export const requestPartnerPayout = async ( options?: RequestInit): Promise<requestPartnerPayoutResponse> => {
return customFetch<Promise<requestPartnerPayoutResponse>>(getRequestPartnerPayoutUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1PaymentsCreateResponse = {
  data: CreatePaymentResponse;
  status: number;
}

export const getPostApiV1PaymentsCreateUrl = () => {


  return `/api/v1/payments/create`
}

export const postApiV1PaymentsCreate = async (createPaymentRequest: CreatePaymentRequest, options?: RequestInit): Promise<postApiV1PaymentsCreateResponse> => {
return customFetch<Promise<postApiV1PaymentsCreateResponse>>(getPostApiV1PaymentsCreateUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createPaymentRequest,)
  }
);}


export type getApiV1PaymentsIdResponse = {
  data: PaymentDetailResponse;
  status: number;
}

export const getGetApiV1PaymentsIdUrl = (id: string,) => {


  return `/api/v1/payments/${id}`
}

export const getApiV1PaymentsId = async (id: string, options?: RequestInit): Promise<getApiV1PaymentsIdResponse> => {
return customFetch<Promise<getApiV1PaymentsIdResponse>>(getGetApiV1PaymentsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1PaymentsResponse = {
  data: PaymentDetailResponse[];
  status: number;
}

export const getGetApiV1PaymentsUrl = (params?: GetApiV1PaymentsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/payments?${normalizedParams.toString()}`
}

export const getApiV1Payments = async (params?: GetApiV1PaymentsParams, options?: RequestInit): Promise<getApiV1PaymentsResponse> => {
return customFetch<Promise<getApiV1PaymentsResponse>>(getGetApiV1PaymentsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1PaymentsIdSyncResponse = {
  data: PaymentSyncResponse;
  status: number;
}

export const getPostApiV1PaymentsIdSyncUrl = (id: string,) => {


  return `/api/v1/payments/${id}/sync`
}

export const postApiV1PaymentsIdSync = async (id: string, options?: RequestInit): Promise<postApiV1PaymentsIdSyncResponse> => {
return customFetch<Promise<postApiV1PaymentsIdSyncResponse>>(getPostApiV1PaymentsIdSyncUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type quotePaymentResponse = {
  data: QuotePaymentResponse;
  status: number;
}

export const getQuotePaymentUrl = () => {


  return `/api/v1/payments/quote`
}

export const quotePayment = async (quotePaymentRequest: QuotePaymentRequest, options?: RequestInit): Promise<quotePaymentResponse> => {
return customFetch<Promise<quotePaymentResponse>>(getQuotePaymentUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      quotePaymentRequest,)
  }
);}


export type getApiV1PermissionsResponse = {
  data: PermissionDto[];
  status: number;
}

export const getGetApiV1PermissionsUrl = () => {


  return `/api/v1/permissions`
}

export const getApiV1Permissions = async ( options?: RequestInit): Promise<getApiV1PermissionsResponse> => {
return customFetch<Promise<getApiV1PermissionsResponse>>(getGetApiV1PermissionsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1RoleTemplatesResponse = {
  data: RoleTemplateDto[];
  status: number;
}

export const getGetApiV1RoleTemplatesUrl = () => {


  return `/api/v1/role-templates`
}

export const getApiV1RoleTemplates = async ( options?: RequestInit): Promise<getApiV1RoleTemplatesResponse> => {
return customFetch<Promise<getApiV1RoleTemplatesResponse>>(getGetApiV1RoleTemplatesUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1PermissionsMeResponse = {
  data: MyPermissionsDto;
  status: number;
}

export const getGetApiV1PermissionsMeUrl = (params?: GetApiV1PermissionsMeParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/permissions/me?${normalizedParams.toString()}`
}

export const getApiV1PermissionsMe = async (params?: GetApiV1PermissionsMeParams, options?: RequestInit): Promise<getApiV1PermissionsMeResponse> => {
return customFetch<Promise<getApiV1PermissionsMeResponse>>(getGetApiV1PermissionsMeUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getPlatformOAuthConnectUrlResponse = {
  data: ConnectUrlResponse;
  status: number;
}

export const getGetPlatformOAuthConnectUrlUrl = (platform: string,
    params?: GetPlatformOAuthConnectUrlParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/platforms/oauth/${platform}/connect-url?${normalizedParams.toString()}`
}

export const getPlatformOAuthConnectUrl = async (platform: string,
    params?: GetPlatformOAuthConnectUrlParams, options?: RequestInit): Promise<getPlatformOAuthConnectUrlResponse> => {
return customFetch<Promise<getPlatformOAuthConnectUrlResponse>>(getGetPlatformOAuthConnectUrlUrl(platform,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type handlePlatformOAuthCallbackResponse = {
  data: void;
  status: number;
}

export const getHandlePlatformOAuthCallbackUrl = (platform: string,
    params: HandlePlatformOAuthCallbackParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/platforms/oauth/${platform}/callback?${normalizedParams.toString()}`
}

export const handlePlatformOAuthCallback = async (platform: string,
    params: HandlePlatformOAuthCallbackParams, options?: RequestInit): Promise<handlePlatformOAuthCallbackResponse> => {
return customFetch<Promise<handlePlatformOAuthCallbackResponse>>(getHandlePlatformOAuthCallbackUrl(platform,params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getPlatformOAuthStatusResponse = {
  data: PlatformOAuthStatus;
  status: number;
}

export const getGetPlatformOAuthStatusUrl = (platform: string,) => {


  return `/api/v1/platforms/oauth/${platform}/status`
}

export const getPlatformOAuthStatus = async (platform: string, options?: RequestInit): Promise<getPlatformOAuthStatusResponse> => {
return customFetch<Promise<getPlatformOAuthStatusResponse>>(getGetPlatformOAuthStatusUrl(platform),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type disconnectPlatformOAuthResponse = {
  data: void;
  status: number;
}

export const getDisconnectPlatformOAuthUrl = (platform: string,) => {


  return `/api/v1/platforms/oauth/${platform}/disconnect`
}

export const disconnectPlatformOAuth = async (platform: string, options?: RequestInit): Promise<disconnectPlatformOAuthResponse> => {
return customFetch<Promise<disconnectPlatformOAuthResponse>>(getDisconnectPlatformOAuthUrl(platform),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type postApiV1PostsDraftResponse = {
  data: CreateDraftResponse;
  status: number;
}

export const getPostApiV1PostsDraftUrl = () => {


  return `/api/v1/posts/draft`
}

export const postApiV1PostsDraft = async (createDraftRequest: CreateDraftRequest, options?: RequestInit): Promise<postApiV1PostsDraftResponse> => {
return customFetch<Promise<postApiV1PostsDraftResponse>>(getPostApiV1PostsDraftUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createDraftRequest,)
  }
);}


export type getApiV1PostsResponse = {
  data: PostsListResult;
  status: number;
}

export const getGetApiV1PostsUrl = (params?: GetApiV1PostsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/posts?${normalizedParams.toString()}`
}

export const getApiV1Posts = async (params?: GetApiV1PostsParams, options?: RequestInit): Promise<getApiV1PostsResponse> => {
return customFetch<Promise<getApiV1PostsResponse>>(getGetApiV1PostsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1PostsIdResponse = {
  data: PostDetailDto;
  status: number;
}

export const getGetApiV1PostsIdUrl = (id: string,) => {


  return `/api/v1/posts/${id}`
}

export const getApiV1PostsId = async (id: string, options?: RequestInit): Promise<getApiV1PostsIdResponse> => {
return customFetch<Promise<getApiV1PostsIdResponse>>(getGetApiV1PostsIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type patchApiV1PostsIdResponse = {
  data: UpdatePostResponse;
  status: number;
}

export const getPatchApiV1PostsIdUrl = (id: string,) => {


  return `/api/v1/posts/${id}`
}

export const patchApiV1PostsId = async (id: string,
    updatePostRequest: UpdatePostRequest, options?: RequestInit): Promise<patchApiV1PostsIdResponse> => {
return customFetch<Promise<patchApiV1PostsIdResponse>>(getPatchApiV1PostsIdUrl(id),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      updatePostRequest,)
  }
);}


export type deleteApiV1PostsIdResponse = {
  data: DeletePostResponse;
  status: number;
}

export const getDeleteApiV1PostsIdUrl = (id: string,) => {


  return `/api/v1/posts/${id}`
}

export const deleteApiV1PostsId = async (id: string, options?: RequestInit): Promise<deleteApiV1PostsIdResponse> => {
return customFetch<Promise<deleteApiV1PostsIdResponse>>(getDeleteApiV1PostsIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1PostsByEridResponse = {
  data: PostDetailDto;
  status: number;
}

export const getGetApiV1PostsByEridUrl = (params: GetApiV1PostsByEridParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/posts/by-erid?${normalizedParams.toString()}`
}

export const getApiV1PostsByErid = async (params: GetApiV1PostsByEridParams, options?: RequestInit): Promise<getApiV1PostsByEridResponse> => {
return customFetch<Promise<getApiV1PostsByEridResponse>>(getGetApiV1PostsByEridUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1PostsIdTgAutodeleteResponse = {
  data: UpdateAutoDeleteResponse;
  status: number;
}

export const getPostApiV1PostsIdTgAutodeleteUrl = (id: string,) => {


  return `/api/v1/posts/${id}/tg/autodelete`
}

export const postApiV1PostsIdTgAutodelete = async (id: string,
    updateAutoDeleteRequest: UpdateAutoDeleteRequest, options?: RequestInit): Promise<postApiV1PostsIdTgAutodeleteResponse> => {
return customFetch<Promise<postApiV1PostsIdTgAutodeleteResponse>>(getPostApiV1PostsIdTgAutodeleteUrl(id),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      updateAutoDeleteRequest,)
  }
);}


export type getApiV1PostsIdArchiveResponse = {
  data: Blob;
  status: number;
}

export const getGetApiV1PostsIdArchiveUrl = (id: string,) => {


  return `/api/v1/posts/${id}/archive`
}

export const getApiV1PostsIdArchive = async (id: string, options?: RequestInit): Promise<getApiV1PostsIdArchiveResponse> => {
return customFetch<Promise<getApiV1PostsIdArchiveResponse>>(getGetApiV1PostsIdArchiveUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1AdminPostsResponse = {
  data: PostsListResult;
  status: number;
}

export const getGetApiV1AdminPostsUrl = (params?: GetApiV1AdminPostsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/posts?${normalizedParams.toString()}`
}

export const getApiV1AdminPosts = async (params?: GetApiV1AdminPostsParams, options?: RequestInit): Promise<getApiV1AdminPostsResponse> => {
return customFetch<Promise<getApiV1AdminPostsResponse>>(getGetApiV1AdminPostsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminPostsDeleteResponse = {
  data: BulkDeleteResponse;
  status: number;
}

export const getPostApiV1AdminPostsDeleteUrl = () => {


  return `/api/v1/admin/posts/delete`
}

export const postApiV1AdminPostsDelete = async (bulkDeleteRequest: BulkDeleteRequest, options?: RequestInit): Promise<postApiV1AdminPostsDeleteResponse> => {
return customFetch<Promise<postApiV1AdminPostsDeleteResponse>>(getPostApiV1AdminPostsDeleteUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      bulkDeleteRequest,)
  }
);}


export type getApiV1PromoPresetsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1PromoPresetsUrl = () => {


  return `/api/v1/promo-presets`
}

export const getApiV1PromoPresets = async ( options?: RequestInit): Promise<getApiV1PromoPresetsResponse> => {
return customFetch<Promise<getApiV1PromoPresetsResponse>>(getGetApiV1PromoPresetsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1PromoCodesValidateResponse = {
  data: void;
  status: number;
}

export const getPostApiV1PromoCodesValidateUrl = () => {


  return `/api/v1/promo-codes/validate`
}

export const postApiV1PromoCodesValidate = async (validatePromoCodeRequest: ValidatePromoCodeRequest, options?: RequestInit): Promise<postApiV1PromoCodesValidateResponse> => {
return customFetch<Promise<postApiV1PromoCodesValidateResponse>>(getPostApiV1PromoCodesValidateUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      validatePromoCodeRequest,)
  }
);}


export type getApiV1AdminPromoCodesResponse = {
  data: void;
  status: number;
}

export const getGetApiV1AdminPromoCodesUrl = (params?: GetApiV1AdminPromoCodesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/admin/promo-codes?${normalizedParams.toString()}`
}

export const getApiV1AdminPromoCodes = async (params?: GetApiV1AdminPromoCodesParams, options?: RequestInit): Promise<getApiV1AdminPromoCodesResponse> => {
return customFetch<Promise<getApiV1AdminPromoCodesResponse>>(getGetApiV1AdminPromoCodesUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminPromoCodesResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminPromoCodesUrl = () => {


  return `/api/v1/admin/promo-codes`
}

export const postApiV1AdminPromoCodes = async (createPromoCodeRequest: CreatePromoCodeRequest, options?: RequestInit): Promise<postApiV1AdminPromoCodesResponse> => {
return customFetch<Promise<postApiV1AdminPromoCodesResponse>>(getPostApiV1AdminPromoCodesUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createPromoCodeRequest,)
  }
);}


export type getApiV1AdminPromoCodesIdResponse = {
  data: void;
  status: number;
}

export const getGetApiV1AdminPromoCodesIdUrl = (id: string,) => {


  return `/api/v1/admin/promo-codes/${id}`
}

export const getApiV1AdminPromoCodesId = async (id: string, options?: RequestInit): Promise<getApiV1AdminPromoCodesIdResponse> => {
return customFetch<Promise<getApiV1AdminPromoCodesIdResponse>>(getGetApiV1AdminPromoCodesIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type putApiV1AdminPromoCodesIdResponse = {
  data: void;
  status: number;
}

export const getPutApiV1AdminPromoCodesIdUrl = (id: string,) => {


  return `/api/v1/admin/promo-codes/${id}`
}

export const putApiV1AdminPromoCodesId = async (id: string,
    updatePromoCodeRequest: UpdatePromoCodeRequest, options?: RequestInit): Promise<putApiV1AdminPromoCodesIdResponse> => {
return customFetch<Promise<putApiV1AdminPromoCodesIdResponse>>(getPutApiV1AdminPromoCodesIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    body: JSON.stringify(
      updatePromoCodeRequest,)
  }
);}


export type deleteApiV1AdminPromoCodesIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1AdminPromoCodesIdUrl = (id: string,) => {


  return `/api/v1/admin/promo-codes/${id}`
}

export const deleteApiV1AdminPromoCodesId = async (id: string, options?: RequestInit): Promise<deleteApiV1AdminPromoCodesIdResponse> => {
return customFetch<Promise<deleteApiV1AdminPromoCodesIdResponse>>(getDeleteApiV1AdminPromoCodesIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type postApiV1AdminPromoCodesIdDeactivateResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminPromoCodesIdDeactivateUrl = (id: string,) => {


  return `/api/v1/admin/promo-codes/${id}/deactivate`
}

export const postApiV1AdminPromoCodesIdDeactivate = async (id: string, options?: RequestInit): Promise<postApiV1AdminPromoCodesIdDeactivateResponse> => {
return customFetch<Promise<postApiV1AdminPromoCodesIdDeactivateResponse>>(getPostApiV1AdminPromoCodesIdDeactivateUrl(id),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type listPublishedNewsResponse = {
  data: News[];
  status: number;
}

export const getListPublishedNewsUrl = () => {


  return `/api/v1/news`
}

export const listPublishedNews = async ( options?: RequestInit): Promise<listPublishedNewsResponse> => {
return customFetch<Promise<listPublishedNewsResponse>>(getListPublishedNewsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1PublishResponse = {
  data: UnifiedPublishResponse;
  status: number;
}

export const getPostApiV1PublishUrl = () => {


  return `/api/v1/publish`
}

export const postApiV1Publish = async (unifiedPublishApiRequest: UnifiedPublishApiRequest, options?: RequestInit): Promise<postApiV1PublishResponse> => {
return customFetch<Promise<postApiV1PublishResponse>>(getPostApiV1PublishUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      unifiedPublishApiRequest,)
  }
);}


export type getApiV1ReachEridEridLatestResponse = {
  data: EridReachResponse;
  status: number;
}

export const getGetApiV1ReachEridEridLatestUrl = (erid: string,) => {


  return `/api/v1/reach/erid/${erid}/latest`
}

export const getApiV1ReachEridEridLatest = async (erid: string, options?: RequestInit): Promise<getApiV1ReachEridEridLatestResponse> => {
return customFetch<Promise<getApiV1ReachEridEridLatestResponse>>(getGetApiV1ReachEridEridLatestUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1ReachEridEridMonthlyResponse = {
  data: MonthlyReachResponse;
  status: number;
}

export const getGetApiV1ReachEridEridMonthlyUrl = (erid: string,) => {


  return `/api/v1/reach/erid/${erid}/monthly`
}

export const getApiV1ReachEridEridMonthly = async (erid: string, options?: RequestInit): Promise<getApiV1ReachEridEridMonthlyResponse> => {
return customFetch<Promise<getApiV1ReachEridEridMonthlyResponse>>(getGetApiV1ReachEridEridMonthlyUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1AccountsIdRolesResponse = {
  data: RoleDto[];
  status: number;
}

export const getGetApiV1AccountsIdRolesUrl = (id: string,) => {


  return `/api/v1/accounts/${id}/roles`
}

export const getApiV1AccountsIdRoles = async (id: string, options?: RequestInit): Promise<getApiV1AccountsIdRolesResponse> => {
return customFetch<Promise<getApiV1AccountsIdRolesResponse>>(getGetApiV1AccountsIdRolesUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AccountsIdRolesResponse = {
  data: RoleDto;
  status: number;
}

export const getPostApiV1AccountsIdRolesUrl = (id: string,) => {


  return `/api/v1/accounts/${id}/roles`
}

export const postApiV1AccountsIdRoles = async (id: string,
    createRoleRequest: CreateRoleRequest, options?: RequestInit): Promise<postApiV1AccountsIdRolesResponse> => {
return customFetch<Promise<postApiV1AccountsIdRolesResponse>>(getPostApiV1AccountsIdRolesUrl(id),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      createRoleRequest,)
  }
);}


export type patchApiV1AccountsIdRolesRoleIdResponse = {
  data: RoleDto;
  status: number;
}

export const getPatchApiV1AccountsIdRolesRoleIdUrl = (id: string,
    roleId: string,) => {


  return `/api/v1/accounts/${id}/roles/${roleId}`
}

export const patchApiV1AccountsIdRolesRoleId = async (id: string,
    roleId: string,
    updateRoleRequest: UpdateRoleRequest, options?: RequestInit): Promise<patchApiV1AccountsIdRolesRoleIdResponse> => {
return customFetch<Promise<patchApiV1AccountsIdRolesRoleIdResponse>>(getPatchApiV1AccountsIdRolesRoleIdUrl(id,roleId),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      updateRoleRequest,)
  }
);}


export type deleteApiV1AccountsIdRolesRoleIdResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1AccountsIdRolesRoleIdUrl = (id: string,
    roleId: string,) => {


  return `/api/v1/accounts/${id}/roles/${roleId}`
}

export const deleteApiV1AccountsIdRolesRoleId = async (id: string,
    roleId: string, options?: RequestInit): Promise<deleteApiV1AccountsIdRolesRoleIdResponse> => {
return customFetch<Promise<deleteApiV1AccountsIdRolesRoleIdResponse>>(getDeleteApiV1AccountsIdRolesRoleIdUrl(id,roleId),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type postApiV1RutubePostsPostIdLinkResponse = {
  data: RtLinkVideoResponse;
  status: number;
}

export const getPostApiV1RutubePostsPostIdLinkUrl = (postId: string,) => {


  return `/api/v1/rutube/posts/${postId}/link`
}

export const postApiV1RutubePostsPostIdLink = async (postId: string,
    rtLinkVideoRequest: RtLinkVideoRequest, options?: RequestInit): Promise<postApiV1RutubePostsPostIdLinkResponse> => {
return customFetch<Promise<postApiV1RutubePostsPostIdLinkResponse>>(getPostApiV1RutubePostsPostIdLinkUrl(postId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      rtLinkVideoRequest,)
  }
);}


export type deleteApiV1RutubePostsPostIdLinkResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1RutubePostsPostIdLinkUrl = (postId: string,) => {


  return `/api/v1/rutube/posts/${postId}/link`
}

export const deleteApiV1RutubePostsPostIdLink = async (postId: string, options?: RequestInit): Promise<deleteApiV1RutubePostsPostIdLinkResponse> => {
return customFetch<Promise<deleteApiV1RutubePostsPostIdLinkResponse>>(getDeleteApiV1RutubePostsPostIdLinkUrl(postId),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1RutubePostsPostIdStatsResponse = {
  data: RtVideoStatsResponse;
  status: number;
}

export const getGetApiV1RutubePostsPostIdStatsUrl = (postId: string,) => {


  return `/api/v1/rutube/posts/${postId}/stats`
}

export const getApiV1RutubePostsPostIdStats = async (postId: string, options?: RequestInit): Promise<getApiV1RutubePostsPostIdStatsResponse> => {
return customFetch<Promise<getApiV1RutubePostsPostIdStatsResponse>>(getGetApiV1RutubePostsPostIdStatsUrl(postId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1RutubeReachEridEridLatestResponse = {
  data: RtEridReachResponse;
  status: number;
}

export const getGetApiV1RutubeReachEridEridLatestUrl = (erid: string,) => {


  return `/api/v1/rutube/reach/erid/${erid}/latest`
}

export const getApiV1RutubeReachEridEridLatest = async (erid: string, options?: RequestInit): Promise<getApiV1RutubeReachEridEridLatestResponse> => {
return customFetch<Promise<getApiV1RutubeReachEridEridLatestResponse>>(getGetApiV1RutubeReachEridEridLatestUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1RutubeReachEridEridMonthlyResponse = {
  data: RtMonthlyReachResponse;
  status: number;
}

export const getGetApiV1RutubeReachEridEridMonthlyUrl = (erid: string,) => {


  return `/api/v1/rutube/reach/erid/${erid}/monthly`
}

export const getApiV1RutubeReachEridEridMonthly = async (erid: string, options?: RequestInit): Promise<getApiV1RutubeReachEridEridMonthlyResponse> => {
return customFetch<Promise<getApiV1RutubeReachEridEridMonthlyResponse>>(getGetApiV1RutubeReachEridEridMonthlyUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1RutubeMetricsCollectNowResponse = {
  data: void;
  status: number;
}

export const getPostApiV1RutubeMetricsCollectNowUrl = () => {


  return `/api/v1/rutube/metrics/collect-now`
}

export const postApiV1RutubeMetricsCollectNow = async ( options?: RequestInit): Promise<postApiV1RutubeMetricsCollectNowResponse> => {
return customFetch<Promise<postApiV1RutubeMetricsCollectNowResponse>>(getPostApiV1RutubeMetricsCollectNowUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


/**
 * Returns presigned URL that client can use to upload image directly to S3
 * @summary Generate presigned URL for uploading original image
 */
export type postApiV1StoragePresignUploadResponse = {
  data: void;
  status: number;
}

export const getPostApiV1StoragePresignUploadUrl = () => {


  return `/api/v1/storage/presign-upload`
}

export const postApiV1StoragePresignUpload = async (presignUploadRequest: PresignUploadRequest, options?: RequestInit): Promise<postApiV1StoragePresignUploadResponse> => {
return customFetch<Promise<postApiV1StoragePresignUploadResponse>>(getPostApiV1StoragePresignUploadUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      presignUploadRequest,)
  }
);}


/**
 * Returns presigned URL for uploading a processed (marked) creative to S3
 * @summary Generate presigned URL for uploading processed creative
 */
export type postApiV1StoragePresignUploadProcessedResponse = {
  data: void;
  status: number;
}

export const getPostApiV1StoragePresignUploadProcessedUrl = () => {


  return `/api/v1/storage/presign-upload-processed`
}

export const postApiV1StoragePresignUploadProcessed = async (presignUploadProcessedRequest: PresignUploadProcessedRequest, options?: RequestInit): Promise<postApiV1StoragePresignUploadProcessedResponse> => {
return customFetch<Promise<postApiV1StoragePresignUploadProcessedResponse>>(getPostApiV1StoragePresignUploadProcessedUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      presignUploadProcessedRequest,)
  }
);}


/**
 * Returns presigned URL for uploading watermark overlay to a separate S3 prefix (watermarks/) so it doesn't appear in post images list
 * @summary Generate presigned URL for uploading video watermark overlay PNG
 */
export type postApiV1StoragePresignUploadWatermarkOverlayResponse = {
  data: void;
  status: number;
}

export const getPostApiV1StoragePresignUploadWatermarkOverlayUrl = () => {


  return `/api/v1/storage/presign-upload-watermark-overlay`
}

export const postApiV1StoragePresignUploadWatermarkOverlay = async (presignUploadWatermarkOverlayRequest: PresignUploadWatermarkOverlayRequest, options?: RequestInit): Promise<postApiV1StoragePresignUploadWatermarkOverlayResponse> => {
return customFetch<Promise<postApiV1StoragePresignUploadWatermarkOverlayResponse>>(getPostApiV1StoragePresignUploadWatermarkOverlayUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      presignUploadWatermarkOverlayRequest,)
  }
);}


/**
 * Returns presigned URL for uploading video directly to S3 (max 2GB)
 * @summary Generate presigned URL for uploading video
 */
export type postApiV1StoragePresignUploadVideoResponse = {
  data: void;
  status: number;
}

export const getPostApiV1StoragePresignUploadVideoUrl = () => {


  return `/api/v1/storage/presign-upload-video`
}

export const postApiV1StoragePresignUploadVideo = async (presignUploadVideoRequest: PresignUploadVideoRequest, options?: RequestInit): Promise<postApiV1StoragePresignUploadVideoResponse> => {
return customFetch<Promise<postApiV1StoragePresignUploadVideoResponse>>(getPostApiV1StoragePresignUploadVideoUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      presignUploadVideoRequest,)
  }
);}


/**
 * Returns presigned GET URL for a given S3 object key after ownership validation
 * @summary Generate presigned URL for viewing an image
 */
export type getApiV1StoragePresignGetResponse = {
  data: void;
  status: number;
}

export const getGetApiV1StoragePresignGetUrl = (params: GetApiV1StoragePresignGetParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/storage/presign-get?${normalizedParams.toString()}`
}

export const getApiV1StoragePresignGet = async (params: GetApiV1StoragePresignGetParams, options?: RequestInit): Promise<getApiV1StoragePresignGetResponse> => {
return customFetch<Promise<getApiV1StoragePresignGetResponse>>(getGetApiV1StoragePresignGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


/**
 * Set lifecycle tags on processed creative and delete original image
 * @summary Finalize creative after processing
 */
export type postApiV1StorageFinalizeCreativeResponse = {
  data: void;
  status: number;
}

export const getPostApiV1StorageFinalizeCreativeUrl = () => {


  return `/api/v1/storage/finalize-creative`
}

export const postApiV1StorageFinalizeCreative = async (finalizeCreativeRequest: FinalizeCreativeRequest, options?: RequestInit): Promise<postApiV1StorageFinalizeCreativeResponse> => {
return customFetch<Promise<postApiV1StorageFinalizeCreativeResponse>>(getPostApiV1StorageFinalizeCreativeUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      finalizeCreativeRequest,)
  }
);}


/**
 * Set lifecycle tags on video (30-day retention) and update post
 * @summary Finalize video after ERID generation
 */
export type postApiV1StorageFinalizeVideoResponse = {
  data: void;
  status: number;
}

export const getPostApiV1StorageFinalizeVideoUrl = () => {


  return `/api/v1/storage/finalize-video`
}

export const postApiV1StorageFinalizeVideo = async (finalizeVideoRequest: FinalizeVideoRequest, options?: RequestInit): Promise<postApiV1StorageFinalizeVideoResponse> => {
return customFetch<Promise<postApiV1StorageFinalizeVideoResponse>>(getPostApiV1StorageFinalizeVideoUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      finalizeVideoRequest,)
  }
);}


/**
 * Returns validation status for video compliance with ERID specifications
 * @summary Validate video against ERID requirements
 */
export type getApiV1StorageValidateVideoPostIdResponse = {
  data: void;
  status: number;
}

export const getGetApiV1StorageValidateVideoPostIdUrl = (postId: string,) => {


  return `/api/v1/storage/validate-video/${postId}`
}

export const getApiV1StorageValidateVideoPostId = async (postId: string, options?: RequestInit): Promise<getApiV1StorageValidateVideoPostIdResponse> => {
return customFetch<Promise<getApiV1StorageValidateVideoPostIdResponse>>(getGetApiV1StorageValidateVideoPostIdUrl(postId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


/**
 * Validates video against ERID requirements using S3 key directly
 * @summary Validate video by S3 key (for temp uploads without post)
 */
export type getApiV1StorageValidateVideoByKeyResponse = {
  data: VideoValidationResponse;
  status: number;
}

export const getGetApiV1StorageValidateVideoByKeyUrl = (params: GetApiV1StorageValidateVideoByKeyParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/storage/validate-video-by-key?${normalizedParams.toString()}`
}

export const getApiV1StorageValidateVideoByKey = async (params: GetApiV1StorageValidateVideoByKeyParams, options?: RequestInit): Promise<getApiV1StorageValidateVideoByKeyResponse> => {
return customFetch<Promise<getApiV1StorageValidateVideoByKeyResponse>>(getGetApiV1StorageValidateVideoByKeyUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


/**
 * Quickly relocates moov atom to beginning for web streaming without re-encoding
 * @summary Fix moov atom position (relocate to beginning)
 */
export type postApiV1StorageFixMoovAtomResponse = {
  data: FixMoovAtomResponse;
  status: number;
}

export const getPostApiV1StorageFixMoovAtomUrl = () => {


  return `/api/v1/storage/fix-moov-atom`
}

export const postApiV1StorageFixMoovAtom = async (fixMoovAtomRequest: FixMoovAtomRequest, options?: RequestInit): Promise<postApiV1StorageFixMoovAtomResponse> => {
return customFetch<Promise<postApiV1StorageFixMoovAtomResponse>>(getPostApiV1StorageFixMoovAtomUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      fixMoovAtomRequest,)
  }
);}


export type activateTrialResponse = {
  data: ActivateTrialResponse;
  status: number;
}

export const getActivateTrialUrl = () => {


  return `/api/v1/subscriptions/trial/activate`
}

export const activateTrial = async (activateTrialRequest: ActivateTrialRequest, options?: RequestInit): Promise<activateTrialResponse> => {
return customFetch<Promise<activateTrialResponse>>(getActivateTrialUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      activateTrialRequest,)
  }
);}


export type getCurrentSubscriptionResponse = {
  data: CurrentSubscriptionResponse;
  status: number;
}

export const getGetCurrentSubscriptionUrl = () => {


  return `/api/v1/subscriptions/current`
}

export const getCurrentSubscription = async ( options?: RequestInit): Promise<getCurrentSubscriptionResponse> => {
return customFetch<Promise<getCurrentSubscriptionResponse>>(getGetCurrentSubscriptionUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type toggleAutoRenewResponse = {
  data: ToggleAutoRenewResponse;
  status: number;
}

export const getToggleAutoRenewUrl = () => {


  return `/api/v1/subscriptions/auto-renew`
}

export const toggleAutoRenew = async (toggleAutoRenewRequest: ToggleAutoRenewRequest, options?: RequestInit): Promise<toggleAutoRenewResponse> => {
return customFetch<Promise<toggleAutoRenewResponse>>(getToggleAutoRenewUrl(),
  {      
    ...options,
    method: 'PATCH',
    body: JSON.stringify(
      toggleAutoRenewRequest,)
  }
);}


export type postApiV1SubscriptionsSubscriptionIdCalculateChangeResponse = {
  data: CalculateTariffChangeResponse;
  status: number;
}

export const getPostApiV1SubscriptionsSubscriptionIdCalculateChangeUrl = (subscriptionId: string,) => {


  return `/api/v1/subscriptions/${subscriptionId}/calculate-change`
}

export const postApiV1SubscriptionsSubscriptionIdCalculateChange = async (subscriptionId: string,
    calculateTariffChangeRequest: CalculateTariffChangeRequest, options?: RequestInit): Promise<postApiV1SubscriptionsSubscriptionIdCalculateChangeResponse> => {
return customFetch<Promise<postApiV1SubscriptionsSubscriptionIdCalculateChangeResponse>>(getPostApiV1SubscriptionsSubscriptionIdCalculateChangeUrl(subscriptionId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      calculateTariffChangeRequest,)
  }
);}


export type postApiV1SubscriptionsSubscriptionIdChangeTariffResponse = {
  data: ChangeTariffResponse;
  status: number;
}

export const getPostApiV1SubscriptionsSubscriptionIdChangeTariffUrl = (subscriptionId: string,) => {


  return `/api/v1/subscriptions/${subscriptionId}/change-tariff`
}

export const postApiV1SubscriptionsSubscriptionIdChangeTariff = async (subscriptionId: string,
    changeTariffRequest: ChangeTariffRequest, options?: RequestInit): Promise<postApiV1SubscriptionsSubscriptionIdChangeTariffResponse> => {
return customFetch<Promise<postApiV1SubscriptionsSubscriptionIdChangeTariffResponse>>(getPostApiV1SubscriptionsSubscriptionIdChangeTariffUrl(subscriptionId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      changeTariffRequest,)
  }
);}


export type getApiV1SubscriptionsSubscriptionIdChangeHistoryResponse = {
  data: TariffChangeDto[];
  status: number;
}

export const getGetApiV1SubscriptionsSubscriptionIdChangeHistoryUrl = (subscriptionId: string,) => {


  return `/api/v1/subscriptions/${subscriptionId}/change-history`
}

export const getApiV1SubscriptionsSubscriptionIdChangeHistory = async (subscriptionId: string, options?: RequestInit): Promise<getApiV1SubscriptionsSubscriptionIdChangeHistoryResponse> => {
return customFetch<Promise<getApiV1SubscriptionsSubscriptionIdChangeHistoryResponse>>(getGetApiV1SubscriptionsSubscriptionIdChangeHistoryUrl(subscriptionId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1TariffsResponse = {
  data: TariffDto[];
  status: number;
}

export const getGetApiV1TariffsUrl = () => {


  return `/api/v1/tariffs`
}

export const getApiV1Tariffs = async ( options?: RequestInit): Promise<getApiV1TariffsResponse> => {
return customFetch<Promise<getApiV1TariffsResponse>>(getGetApiV1TariffsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1TariffsCurrentResponse = {
  data: CurrentTariffResponse;
  status: number;
}

export const getGetApiV1TariffsCurrentUrl = () => {


  return `/api/v1/tariffs/current`
}

export const getApiV1TariffsCurrent = async ( options?: RequestInit): Promise<getApiV1TariffsCurrentResponse> => {
return customFetch<Promise<getApiV1TariffsCurrentResponse>>(getGetApiV1TariffsCurrentUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1TariffsQuotaResponse = {
  data: QuotaUsageInfo;
  status: number;
}

export const getGetApiV1TariffsQuotaUrl = () => {


  return `/api/v1/tariffs/quota`
}

export const getApiV1TariffsQuota = async ( options?: RequestInit): Promise<getApiV1TariffsQuotaResponse> => {
return customFetch<Promise<getApiV1TariffsQuotaResponse>>(getGetApiV1TariffsQuotaUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1TgMeResponse = {
  data: TelegramMeResponse;
  status: number;
}

export const getGetApiV1TgMeUrl = () => {


  return `/api/v1/tg/me`
}

export const getApiV1TgMe = async ( options?: RequestInit): Promise<getApiV1TgMeResponse> => {
return customFetch<Promise<getApiV1TgMeResponse>>(getGetApiV1TgMeUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1TgConnectResponse = {
  data: TelegramChannelConnectResponse;
  status: number;
}

export const getPostApiV1TgConnectUrl = () => {


  return `/api/v1/tg/connect`
}

export const postApiV1TgConnect = async (connectRequest: ConnectRequest, options?: RequestInit): Promise<postApiV1TgConnectResponse> => {
return customFetch<Promise<postApiV1TgConnectResponse>>(getPostApiV1TgConnectUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      connectRequest,)
  }
);}


export type getApiV1TgMetricsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1TgMetricsUrl = (params: GetApiV1TgMetricsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/tg/metrics?${normalizedParams.toString()}`
}

export const getApiV1TgMetrics = async (params: GetApiV1TgMetricsParams, options?: RequestInit): Promise<getApiV1TgMetricsResponse> => {
return customFetch<Promise<getApiV1TgMetricsResponse>>(getGetApiV1TgMetricsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1TgReachEridEridLatestResponse = {
  data: EridReachResponse;
  status: number;
}

export const getGetApiV1TgReachEridEridLatestUrl = (erid: string,) => {


  return `/api/v1/tg/reach/erid/${erid}/latest`
}

export const getApiV1TgReachEridEridLatest = async (erid: string, options?: RequestInit): Promise<getApiV1TgReachEridEridLatestResponse> => {
return customFetch<Promise<getApiV1TgReachEridEridLatestResponse>>(getGetApiV1TgReachEridEridLatestUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1TgReachEridEridMonthlyResponse = {
  data: MonthlyReachResponse;
  status: number;
}

export const getGetApiV1TgReachEridEridMonthlyUrl = (erid: string,) => {


  return `/api/v1/tg/reach/erid/${erid}/monthly`
}

export const getApiV1TgReachEridEridMonthly = async (erid: string, options?: RequestInit): Promise<getApiV1TgReachEridEridMonthlyResponse> => {
return customFetch<Promise<getApiV1TgReachEridEridMonthlyResponse>>(getGetApiV1TgReachEridEridMonthlyUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1TgMetricsCollectNowResponse = {
  data: void;
  status: number;
}

export const getPostApiV1TgMetricsCollectNowUrl = () => {


  return `/api/v1/tg/metrics/collect-now`
}

export const postApiV1TgMetricsCollectNow = async ( options?: RequestInit): Promise<postApiV1TgMetricsCollectNowResponse> => {
return customFetch<Promise<postApiV1TgMetricsCollectNowResponse>>(getPostApiV1TgMetricsCollectNowUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type getApiV1AdminTgUsersWithPadsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1AdminTgUsersWithPadsUrl = () => {


  return `/api/v1/admin/tg/users-with-pads`
}

export const getApiV1AdminTgUsersWithPads = async ( options?: RequestInit): Promise<getApiV1AdminTgUsersWithPadsResponse> => {
return customFetch<Promise<getApiV1AdminTgUsersWithPadsResponse>>(getGetApiV1AdminTgUsersWithPadsUrl(),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1AdminTgCollectReachUserUserIdResponse = {
  data: void;
  status: number;
}

export const getPostApiV1AdminTgCollectReachUserUserIdUrl = (userId: string,) => {


  return `/api/v1/admin/tg/collect-reach/user/${userId}`
}

export const postApiV1AdminTgCollectReachUserUserId = async (userId: string, options?: RequestInit): Promise<postApiV1AdminTgCollectReachUserUserIdResponse> => {
return customFetch<Promise<postApiV1AdminTgCollectReachUserUserIdResponse>>(getPostApiV1AdminTgCollectReachUserUserIdUrl(userId),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1TgPublishResponse = {
  data: TelegramPublishResponse;
  status: number;
}

export const getPostApiV1TgPublishUrl = () => {


  return `/api/v1/tg/publish`
}

export const postApiV1TgPublish = async (publishRequest: PublishRequest, options?: RequestInit): Promise<postApiV1TgPublishResponse> => {
return customFetch<Promise<postApiV1TgPublishResponse>>(getPostApiV1TgPublishUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      publishRequest,)
  }
);}


export type getApiV1TgMessagesResponse = {
  data: TelegramMessagesResponse;
  status: number;
}

export const getGetApiV1TgMessagesUrl = (params: GetApiV1TgMessagesParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/tg/messages?${normalizedParams.toString()}`
}

export const getApiV1TgMessages = async (params: GetApiV1TgMessagesParams, options?: RequestInit): Promise<getApiV1TgMessagesResponse> => {
return customFetch<Promise<getApiV1TgMessagesResponse>>(getGetApiV1TgMessagesUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1TgWebhookResponse = {
  data: TelegramWebhookResponse;
  status: number;
}

export const getPostApiV1TgWebhookUrl = () => {


  return `/api/v1/tg/webhook`
}

export const postApiV1TgWebhook = async (update: Update, options?: RequestInit): Promise<postApiV1TgWebhookResponse> => {
return customFetch<Promise<postApiV1TgWebhookResponse>>(getPostApiV1TgWebhookUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      update,)
  }
);}


export type postApiV1PostsIdVideoWatermarkResponse = {
  data: VideoWatermarkEnqueueResponse;
  status: number;
}

export const getPostApiV1PostsIdVideoWatermarkUrl = (id: string,) => {


  return `/api/v1/posts/${id}/video-watermark`
}

export const postApiV1PostsIdVideoWatermark = async (id: string,
    videoWatermarkRequest: VideoWatermarkRequest, options?: RequestInit): Promise<postApiV1PostsIdVideoWatermarkResponse> => {
return customFetch<Promise<postApiV1PostsIdVideoWatermarkResponse>>(getPostApiV1PostsIdVideoWatermarkUrl(id),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      videoWatermarkRequest,)
  }
);}


export type getApiV1PostsIdVideoWatermarkResponse = {
  data: VideoWatermarkStatusDto | void;
  status: number;
}

export const getGetApiV1PostsIdVideoWatermarkUrl = (id: string,) => {


  return `/api/v1/posts/${id}/video-watermark`
}

export const getApiV1PostsIdVideoWatermark = async (id: string, options?: RequestInit): Promise<getApiV1PostsIdVideoWatermarkResponse> => {
return customFetch<Promise<getApiV1PostsIdVideoWatermarkResponse>>(getGetApiV1PostsIdVideoWatermarkUrl(id),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1PostsIdVideoWatermarkRetryResponse = {
  data: VideoWatermarkEnqueueResponse;
  status: number;
}

export const getPostApiV1PostsIdVideoWatermarkRetryUrl = (id: string,) => {


  return `/api/v1/posts/${id}/video-watermark/retry`
}

export const postApiV1PostsIdVideoWatermarkRetry = async (id: string,
    videoWatermarkRequest: VideoWatermarkRequest, options?: RequestInit): Promise<postApiV1PostsIdVideoWatermarkRetryResponse> => {
return customFetch<Promise<postApiV1PostsIdVideoWatermarkRetryResponse>>(getPostApiV1PostsIdVideoWatermarkRetryUrl(id),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      videoWatermarkRequest,)
  }
);}


export type postApiV1VkCallbackResponse = {
  data: void;
  status: number;
}

export const getPostApiV1VkCallbackUrl = () => {


  return `/api/v1/vk/callback`
}

export const postApiV1VkCallback = async ( options?: RequestInit): Promise<postApiV1VkCallbackResponse> => {
return customFetch<Promise<postApiV1VkCallbackResponse>>(getPostApiV1VkCallbackUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1VkConnectManualResponse = {
  data: VkConnectManualResponse;
  status: number;
}

export const getPostApiV1VkConnectManualUrl = () => {


  return `/api/v1/vk/connect-manual`
}

export const postApiV1VkConnectManual = async (vkConnectManualRequest: VkConnectManualRequest, options?: RequestInit): Promise<postApiV1VkConnectManualResponse> => {
return customFetch<Promise<postApiV1VkConnectManualResponse>>(getPostApiV1VkConnectManualUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      vkConnectManualRequest,)
  }
);}


export type postApiV1VkPublishResponse = {
  data: void;
  status: number;
}

export const getPostApiV1VkPublishUrl = () => {


  return `/api/v1/vk/publish`
}

export const postApiV1VkPublish = async (vkPublishRequest: VkPublishRequest,
    headers?: PostApiV1VkPublishHeaders, options?: RequestInit): Promise<postApiV1VkPublishResponse> => {
return customFetch<Promise<postApiV1VkPublishResponse>>(getPostApiV1VkPublishUrl(),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      vkPublishRequest,)
  }
);}


export type getApiV1VkPostsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1VkPostsUrl = (params: GetApiV1VkPostsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/vk/posts?${normalizedParams.toString()}`
}

export const getApiV1VkPosts = async (params: GetApiV1VkPostsParams, options?: RequestInit): Promise<getApiV1VkPostsResponse> => {
return customFetch<Promise<getApiV1VkPostsResponse>>(getGetApiV1VkPostsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1VkMetricsResponse = {
  data: void;
  status: number;
}

export const getGetApiV1VkMetricsUrl = (params: GetApiV1VkMetricsParams,) => {

  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === null) {
      normalizedParams.append(key, 'null');
    } else if (value !== undefined) {
      normalizedParams.append(key, value.toString());
    }
  });

  return `/api/v1/vk/metrics?${normalizedParams.toString()}`
}

export const getApiV1VkMetrics = async (params: GetApiV1VkMetricsParams, options?: RequestInit): Promise<getApiV1VkMetricsResponse> => {
return customFetch<Promise<getApiV1VkMetricsResponse>>(getGetApiV1VkMetricsUrl(params),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1PaymentsYookassaWebhookResponse = {
  data: void;
  status: number;
}

export const getPostApiV1PaymentsYookassaWebhookUrl = () => {


  return `/api/v1/payments/yookassa/webhook`
}

export const postApiV1PaymentsYookassaWebhook = async ( options?: RequestInit): Promise<postApiV1PaymentsYookassaWebhookResponse> => {
return customFetch<Promise<postApiV1PaymentsYookassaWebhookResponse>>(getPostApiV1PaymentsYookassaWebhookUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


export type postApiV1YoutubePostsPostIdLinkResponse = {
  data: YtLinkVideoResponse;
  status: number;
}

export const getPostApiV1YoutubePostsPostIdLinkUrl = (postId: string,) => {


  return `/api/v1/youtube/posts/${postId}/link`
}

export const postApiV1YoutubePostsPostIdLink = async (postId: string,
    ytLinkVideoRequest: YtLinkVideoRequest, options?: RequestInit): Promise<postApiV1YoutubePostsPostIdLinkResponse> => {
return customFetch<Promise<postApiV1YoutubePostsPostIdLinkResponse>>(getPostApiV1YoutubePostsPostIdLinkUrl(postId),
  {      
    ...options,
    method: 'POST',
    body: JSON.stringify(
      ytLinkVideoRequest,)
  }
);}


export type deleteApiV1YoutubePostsPostIdLinkResponse = {
  data: void;
  status: number;
}

export const getDeleteApiV1YoutubePostsPostIdLinkUrl = (postId: string,) => {


  return `/api/v1/youtube/posts/${postId}/link`
}

export const deleteApiV1YoutubePostsPostIdLink = async (postId: string, options?: RequestInit): Promise<deleteApiV1YoutubePostsPostIdLinkResponse> => {
return customFetch<Promise<deleteApiV1YoutubePostsPostIdLinkResponse>>(getDeleteApiV1YoutubePostsPostIdLinkUrl(postId),
  {      
    ...options,
    method: 'DELETE'
    
  }
);}


export type getApiV1YoutubePostsPostIdStatsResponse = {
  data: YtVideoStatsResponse;
  status: number;
}

export const getGetApiV1YoutubePostsPostIdStatsUrl = (postId: string,) => {


  return `/api/v1/youtube/posts/${postId}/stats`
}

export const getApiV1YoutubePostsPostIdStats = async (postId: string, options?: RequestInit): Promise<getApiV1YoutubePostsPostIdStatsResponse> => {
return customFetch<Promise<getApiV1YoutubePostsPostIdStatsResponse>>(getGetApiV1YoutubePostsPostIdStatsUrl(postId),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1YoutubeReachEridEridLatestResponse = {
  data: YtEridReachResponse;
  status: number;
}

export const getGetApiV1YoutubeReachEridEridLatestUrl = (erid: string,) => {


  return `/api/v1/youtube/reach/erid/${erid}/latest`
}

export const getApiV1YoutubeReachEridEridLatest = async (erid: string, options?: RequestInit): Promise<getApiV1YoutubeReachEridEridLatestResponse> => {
return customFetch<Promise<getApiV1YoutubeReachEridEridLatestResponse>>(getGetApiV1YoutubeReachEridEridLatestUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type getApiV1YoutubeReachEridEridMonthlyResponse = {
  data: YtMonthlyReachResponse;
  status: number;
}

export const getGetApiV1YoutubeReachEridEridMonthlyUrl = (erid: string,) => {


  return `/api/v1/youtube/reach/erid/${erid}/monthly`
}

export const getApiV1YoutubeReachEridEridMonthly = async (erid: string, options?: RequestInit): Promise<getApiV1YoutubeReachEridEridMonthlyResponse> => {
return customFetch<Promise<getApiV1YoutubeReachEridEridMonthlyResponse>>(getGetApiV1YoutubeReachEridEridMonthlyUrl(erid),
  {      
    ...options,
    method: 'GET'
    
  }
);}


export type postApiV1YoutubeMetricsCollectNowResponse = {
  data: void;
  status: number;
}

export const getPostApiV1YoutubeMetricsCollectNowUrl = () => {


  return `/api/v1/youtube/metrics/collect-now`
}

export const postApiV1YoutubeMetricsCollectNow = async ( options?: RequestInit): Promise<postApiV1YoutubeMetricsCollectNowResponse> => {
return customFetch<Promise<postApiV1YoutubeMetricsCollectNowResponse>>(getPostApiV1YoutubeMetricsCollectNowUrl(),
  {      
    ...options,
    method: 'POST'
    
  }
);}


